import { Component, OnInit, TemplateRef, EventEmitter, Output, Input, ElementRef, Renderer, ViewChild, AfterContentInit, AfterViewChecked } from '@angular/core';
// import { ColorPickerService } from 'angular2-color-picker';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { LayerObj, Ilayer, ViewLayerData, IViewlayer, IPlayer, PlayerObj, IUniformSubmission, UniformSubmissionObject, Icolorselected, SelectedColorObj, ILayerColorOriginal, LayerColorOriginalObj, ITexttoCanvas, TexttoCanvasObj, IGraphic, GraphicObj } from "../models/jersey";
import FontFaceObserver from 'fontfaceobserver';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FirebaseApp } from 'angularfire2';
import { MatDialog } from "@angular/material";
import { base64StringToBlob } from 'blob-util';
// import * as firebase from 'firebase';
import { UploadService } from 'services/upload.service';
import { SubmissionsService } from 'services/submissions.service';
import { SignInModalComponent } from "app/modals/sign-in/sign-in.component";

import { UniformStyle, Jersey, gender, JerseyObj } from '../admin/models/upload';
import { SelectUniformComponent } from '../select-uniform/select-uniform.component';
import { colorComponent } from '../color-implementation/color.component';
import { patternComponent } from '../pattern-implementation/pattern.component';

import { AlertComponent } from '../alert-component/alert.component';
import { AlertService } from '../alert-component/alert.service';
import { graphicoptionComponent } from '../graphicoption/graphicoption.component';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import * as moment from 'moment';
import html2canvas from 'html2canvas';
import 'fabric';
import $ from "jquery";
import SvgText from 'svg-text';
import { ToastrService } from 'ngx-toastr';
import { AngularFireAuth } from 'angularfire2/auth';
import { style } from '@angular/animations';
import { async } from 'q';
import CircleType from "circletype";
import svgpng from "svg-to-png-lite";
import { AngularMultiSelect } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { flatten } from '@angular/compiler';
import * as firebase from 'firebase/app';
import { element } from 'protractor';
import { FONT_SIZE } from './font';
import * as svgImg from 'save-svg-as-png';


// import * as Jimp from 'jimp';




declare const fabric: any;
declare var Snap: any;
declare var mina: any;


@Component({
    selector: 'app-editor',
    styleUrls: ['./editor.component.css'],
    templateUrl: './editor.component.html'
})

export class EditorComponent implements OnInit {
    @Input('color') color: string;
    @ViewChild('scrolldiv', { static: false }) el: ElementRef;
    @ViewChild(graphicoptionComponent, { static: false }) graphicOption;
    @ViewChild('submitJerseyForm', { static: false }) submitJerseyForm;
    @ViewChild('colorSelectDropDown', { static: false }) colorSelectDropDown: AngularMultiSelect;

    // private submitJerseyForm: NgForm;
    private submitJerseyFormupdate: {
        "name": '',
        "email": '',
        "phone": '',
        "organization": ''
    };
    graphicElementsHeight: any[];
    private loading: boolean = false;
    private loading1: boolean = false;
    private loadingFlag: boolean = false;
    public selectedJerseyCuts: Jersey[] = [];
    public selectedJerseyCutsNew: Jersey[] = [];
    public emailAddress: string;
    public message: string;
    public emailAddress2: string;
    backbelowName: any;
    frontbelowName: any;
    toBeDeleted:any
    selectedCategory: "Mascots";
    openClipArt: boolean = false;
    public message2: string;
    selectedImgIndex: number = 0;
    submitFlag = undefined;
    finalizeBtnFlag: boolean = false;
    resubmittedDesign: any;
    designId: any;
    uploadFileFlag = true;
    circleType: any;
    circleType1: any;
    clipartList: any;
    previewImage: any;
    is_show: boolean = false;
    is_show1: boolean = false;
    clipArtImage: any;
    cirlceLength: any;
    playerListFlag: boolean = false;
    lastSubmissions = [];
    lastSubmissions1: any;
    lastRevisions = [];
    frontLogo: any;
    submissonId: any;
    urlsSvgData: any;
    urlsSvgDataPng: any;
    private defaultLogoBase64: string = `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`;
	private base64textString: any = this.defaultLogoBase64;

    urlsSvgSide2Data: any;
    urlsSvgSide2DataPng: any;
    public categoriesList = [
        { "id": 1, "name": "Mascots", "itemName": "Mascots" },
        { "id": 2, "name": "Flags", "itemName": "Flags" }
      ];

    menuState = {
        "SelectUniform": false,
        "TopOptions": false,
        "BottomOptions": false,
        "GraphicOptions": false,
        "TeamRoster": false,
        "SubmitUniform": false,
        "ProductInfo": true,
        "Cuttype": false,
        "PatternOption": false
        // "patternOption"
    }
    selected_slide = 1;
    viewJson: any[] = [{
        "id": "uniformDesign",
        "json": "Populate template design here"
    },];
    stateTracker = {
        "SelectUniform": false,
        "TopOptions": false,
        "BottomOptions": false,
        "GraphicOptions": false,
        "TeamRoster": false,
        "SubmitUniform": false,
        "ProductInfo": false,
        "Cuttype": false,
        "PatternOption": false
    }


    private svgIdColors: Icolorselected[] = [];
    private showBuilder: boolean = true;
    private showUniformSelectComponent: boolean = false;

    fontArray: string[] = ["dade-webfont", "CollegeBlock2-0", "full_block-webfont", "golden_bear___font-webfont", "full_clock_outline-webfont", "golden_bear-webfont", "horned_frogs-webfont", "huskie-webfont", "kights-webfont", "lubbock-webfont", "pullman-webfont"];
    private canvas: any;
    private lowerImages = "";
    private selectedId = "";
    private selectedImage = "";
    private props: any = {
        canvasFill: '#ffffff',
        canvasImage: '',
        id: null,
        opacity: null,
        fill: null,
        fontSize: null,
        lineHeight: null,
        charSpacing: null,
        fontWeight: null,
        fontStyle: null,
        textAlign: null,
        fontFamily: null,
        TextDecoration: ''
    };

    private textString: string;
    private url: string = '';
    private size: any = {
        width: 0,
        height: 0
    };

    private json: any;
    private textEditor: boolean = false;
    private imageEditor: boolean = false;
    private figureEditor: boolean = false;
    private hasCuts: boolean = false;
    private selected: any;
    public modalRef: BsModalRef;
    private List: any;
    private colorsList: any;
    patternList: any;
    colorsList1: any;
    colorsList2: any;
    private selectedJersycut: Jersey;
    private editableLayers: Ilayer[];
    private layerColorobj: Icolorselected[];
    private layerColorApplied_OutSide: Icolorselected[] = []; //Modified for Toggle buttons
    private layerColorApplied_InSide: Icolorselected[] = [];
    private actualColorofLayer_OutSide: ILayerColorOriginal[] = [];
    private actualColorofLayer_InSide: ILayerColorOriginal[] = [];
    //For Holding Graphic data when Toggle
    private graphic_Data_Outside: IGraphic = new GraphicObj("", "", "", "", 0, 0, "", 0, 0, "", "", "", 0, 0, 0, 0, 0, 0, 0, 0, "", "");
    private graphic_Data_Inside: IGraphic = new GraphicObj("", "", "", "", 0, 0, "", 0, 0, "", "", "", 0, 0, 0, 0, 0, 0, 0, 0, "", "");
    //For Holding Submissions
    private Database64_OutSide: any = null;
    private Database64_InSide: any = null;
    private Datajson_OutSide: any = null;
    private Datajson_Inside: any = null;
    //Load from ID
    private load_FromID: boolean = false;
    private id_Load_From: string;
    private obj_Outside: any;
    private obj_Inside: any;

    private ddselectedCutType: Jersey;
    private players: IPlayer[];
    private eventFromcolorcomponent: any;
    private layerFromcolorcomponent: Ilayer;
    private colorselect: Icolorselected;
    private eventFromcolorhovercomponent: any;
    private colorselectedForHover: any;
    private isSelectedcolor: any;
    private colorName: string = '';
    private colorselected: any;
    private playersData: IPlayer[];
    private selectedStyle: Jersey;
    private selectedCutsList: Jersey[] = [];
    private reversible: boolean = false;
    private imageObjectArray: any;

    private isFrontImage = false;
    private isBackImage = false;
    private isShortLegImage = false;

    private isTeamRosterEnabledForBusiness = false;

    //defining  Submission to Store both Outside and Inside Uniform Data
    private outside_Uniform: Jersey;
    private inside_Uniform: Jersey;
    snapSvg: any;
    promoVideoUrl: string;
    selectedDesignUniformStyles: any[];
    isloader: boolean;
    savelaterFlag: any;
    submissionFlag: boolean;
    submitFormData: any;
    submittedDesign: any;
    submittedDesign1: any;
    editDesignFlag: boolean;
    availableLogoLocations: any[];
    showMessageFlag: boolean = false;
    reEditFlag: boolean;
    prevColorObj: any;
    disabledValue: boolean;
    applied_OutSideOptions: any;
    logoFiles: any[];
    logo: string;
    firstLoader: boolean;
    isMac: boolean;
    uniformtypes: any[] = [
        { "id": 'Reversible', "name": "Reversible", "subtext": "One Uniform", "text": "Printed on both sides", "visible": false },
        { "id": 'HomeAway', "name": "Home and Away", "subtext": "Single Ply", "text": "2 Sets of Uniform", "visible": false },
        { "id": 'GameDay', "name": "Game Day", "subtext": "Single Ply", "text": "1 Set", "visible": true }
    ];
    selectedUniformType: any;
    activeJersey: Jersey;
    selectedJerseyInsideCuts: Jersey[];
    selectedJerseyOutsideCuts: Jersey[];
    reversibleFlag: boolean;
    homeAwayFlag: boolean;
    gameDayFlag: boolean;
    outsideFileHTML: any;
    insideFileHTML: any;
    outsideFileHTMLDef: any;
    insideFileHTMLDef: any;
    refreshPanel: boolean;
    activeOutsideCutName: string;
    activeInsideCutName: string;
    toggleFlag: boolean;
    @ViewChild('warningmodal', { static: false }) public templateref: TemplateRef<any>;
    isSafari: any;
    myLogo = ''
    ExtFontList: any[];
    //Component constructor, loads jerseyStyles into
    constructor(private router: Router, private rd: Renderer, private http: Http, private submissionService: SubmissionsService, private modalService: BsModalService,
        private afAuth: AngularFireAuth, private dbService: AngularFireDatabase, private fb: FirebaseApp,
        private route: ActivatedRoute, private alertService: AlertService, private us: UploadService, private toastr: ToastrService, private dialog: MatDialog) {
        this.players = [new PlayerObj(null, null, null, null)]
        this.isloader = false;
        this.getClipArt();
        // if (localStorage.getItem('ulCompanyLogo') == null) {
            this.submissionService.getConfiguration()
            .subscribe(data => {
             
              var object = data.json()[0];
              // let object = data.payload.val()
              this.myLogo = object['logoPath'] = object.companyLogoPath;
              this.isTeamRosterEnabledForBusiness = object.rosterFrontEnd;
              localStorage.setItem('ulCompanyLogo', this.myLogo);
            });
        // this.dbService.object('/company-info/myInfo').snapshotChanges().subscribe(data => {
        //     let object = data.payload.val();
        //     console.log("object is ", object);
        //     this.myLogo = object['logoPath'];
        //     this.isTeamRosterEnabledForBusiness = object['builderSettings']['rosterFrontEnd']
        //     localStorage.setItem('ulCompanyLogo', this.myLogo);
        // }, err => {
        //     this.myLogo = '';
        // })
        // }
        // else {
        //     this.myLogo = localStorage.getItem('ulCompanyLogo');
        // }


        dbService.list('/colors').valueChanges().subscribe(colors => {
            colors.sort((a, b) => a['order'] - b['order']);
            this.colorsList = colors.reduce(function (acc, cur, i) {
                let cur1 = <any>cur;
                acc[cur1.colorCode] = {
                    ...cur,
                    isSelected: false
                };
                return acc;
            }, {});
        });
        dbService.list('/patterns').valueChanges().subscribe(colors => {
            this.patternList = colors.reduce(function (acc, cur, i) {
                let cur1 = <any>cur;
                acc[cur1.colorCode] = {
                    ...cur,
                    isSelected: false
                };
                return acc;
            }, {});
        });
        if (window.navigator.userAgent.indexOf("Mac") !== -1) {
            var cstyles = '.rightOptionsPanel{ padding-left: 88px !important; } \
            @media (max-width:1199px){\
                .rightOptionsPanel{ padding-left: 80px !important; }\
            }';
            this.addCustomStyle(cstyles);
            this.isMac = true;
        } else {
            this.isMac = false;
        }
        this.outsideFileHTML = "";
        this.insideFileHTML = "";
        try {
            this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (this.isSafari) {
                setTimeout(() => {
                    this.toastr.warning("This browser is not supported. You may experience issues with fonts. ", 'Unsupported browser!', { positionClass: 'toast-top-right' });
                }, 2000);
            }

            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (isMobile) {
                /* your code here */
                setTimeout(() => {
                    // this.openModal(this.templateref);
                    this.signInForUpload('submission');
                    this.router.navigate(['/customer/login'])
                }, 1000);
            }
        } catch (error) {

        }

    }

    // Works with Static and Dynamic accordion for Colors
    get GetColorArray() {
        let colorList = [];
        for (let key in this.colorsList) {
            colorList.push(this.colorsList[key]);
        }
        return colorList;
    }

    get getPatternArray() {
        let patternList = [];
        for (let key in this.patternList) {
            patternList.push(this.patternList[key]);
        }
        return patternList;
    }

    getMyLogo() {
        console.log("Getting my logo!")


    }

    addCustomStyle(styles) {
        if (document.getElementById("customstyle")) {
            document.getElementById("customstyle").remove();
        }
        /* Create style document */
        var css = document.createElement('style');
        css.type = 'text/css';
        css.id = "customstyle";
        if ((<any>css).styleSheet)
            (<any>css).styleSheet.cssText = styles;
        else
            css.appendChild(document.createTextNode(styles));
        /* Append style to the tag name */
        document.getElementsByTagName("head")[0].appendChild(css);
    }

    submitemailtonotify() {
        this.modalRef.hide();
        this.toastr.success('Thank you!', '', { positionClass: 'toast-top-right' });
    }

    async loadHomeSvgAsPngUri(urlImg) {
        return new Promise(resolve => {
            setTimeout(() => {
                var elementToExport2 = document.querySelectorAll("#svg")[0];
                if (elementToExport2) {
                    this.setInlineStyles(elementToExport2);
                    // $("#svgContainer").css("height","450px");
                    $("#svg").css("height", "100%");
                    $("#svg").css("width", "100%");

                    svgImg.svgAsPngUri(document.querySelectorAll("#svg")[0], {
                        encoderOptions: 1,
                    }, (uri) => {
                        urlImg = uri;
                        console.log("uri",uri);

                        // $("#svgContainer").css("height","100%");
                        $("#svg").css("height", "100%");
                        $("#svg").css("width", "100%");
                        console.log("=======")
                        resolve(urlImg);
                    });
                } else {
                }
            }, 2000);
        });        
    }
    async loadAwaySvgAsPngUri(AwayImgUri) {
        return new Promise(resolve => {
            setTimeout(() => {
                var elementToExport2 = document.querySelectorAll("#svg")[0];
                if (elementToExport2) {
                    this.setInlineStyles(elementToExport2);
                    // $("#svgContainer").css("height","450px");
                    $("#svg").css("height", "100%");
                    $("#svg").css("width", "100%");
                    svgImg.svgAsPngUri(document.querySelectorAll("#svg")[0], {
                        encoderOptions: 1,
                    }, (uri) => {
                        AwayImgUri = uri;
                        // $("#svgContainer").css("height","100%");
                        $("#svg").css("height", "100%");
                        $("#svg").css("width", "100%");
                        console.log("=======")
                        resolve(AwayImgUri);
                    });
                } else {
                }
            }, 2000);
        });        
    }

    async handleReaderLoaded(data) {
        console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", data);
        this.loading = true;
        let uniqlogo1 = 'ReQuestImageSvg' + (new Date().getTime());
        let storageRef = firebase.storage().ref();
        const fileData = await storageRef.child(`${'/svg-design-images'}/${uniqlogo1}`).put(data)
            .then(snapshot => {
                return snapshot.ref.getDownloadURL();
            }).then(async (downloadURL) => {
                this.urlsSvgData = downloadURL;
                // console.log(" this.urlsSvgData   !!!!!!", this.urlsSvgData);
                // this.uploadedImage.push(downloadURL);
                // this.uploadedImage=downloadURL;
                // this.toastr.success('Image. sucessfully upload/ed', '', { positionClass: 'toast-top-right' });
            }).catch(error => {
                this.toastr.error("Faild to upload image. Plase try again", '', { positionClass: 'toast-top-right', onActivateTick: true, timeOut: 10000 });
            });
    }

    async handleReaderLoaded4(data) {
        this.loading = true;
        let uniqlogo1 = 'ReQuestImageSvg4' + (new Date().getTime());
        let storageRef = firebase.storage().ref();
        const fileData = await storageRef.child(`${'/svg-design-images4'}/${uniqlogo1}`).put(data)
            .then(snapshot => {
                return snapshot.ref.getDownloadURL();
            }).then(async (downloadURL) => {
                // this.urlsSvgData = downloadURL;
                // this.urlsSvgSide2Data= downloadURL;
                this.urlsSvgSide2DataPng = downloadURL;
                // console.log(" this.urlsSvgData   !!!!!!", this.urlsSvgData);
                // this.uploadedImage.push(downloadURL);
                // this.uploadedImage=downloadURL;
                // this.toastr.success('Image. sucessfully upload/ed', '', { positionClass: 'toast-top-right' });
            }).catch(error => {
                this.toastr.error("Faild to upload image. Plase try again", '', { positionClass: 'toast-top-right', onActivateTick: true, timeOut: 10000 });
            });
    }



    async handleReaderLoaded1(data) {
        console.log("data   ########################################", data);
        this.loading = true;
        // this.toastr.warning("Plase wait while uploading image.", '', { onActivateTick: true, timeOut: 10000, positionClass: 'toast-top-right' });
        let uniqlogo1 = 'ReQuestImageSvg1' + (new Date().getTime());
        let storageRef = firebase.storage().ref();
        const fileData = await storageRef.child(`${'/svg-design-images1'}/${uniqlogo1}`).put(data)
            .then(snapshot => {
                return snapshot.ref.getDownloadURL();
            }).then(async (downloadURL) => {
                this.urlsSvgDataPng = downloadURL;
                // this.toastr.success('Image. sucessfully upload/ed', '', { positionClass: 'toast-top-right' });
            }).catch(error => {
                // this.toastr.error("Faild to upload image. Plase try again", '', { positionClass: 'toast-top-right', onActivateTick: true, timeOut: 10000 });
            });
    }

    async handleReaderLoaded3(data) {
        this.loading = true;
        let uniqlogo1 = 'ReQuestImageSvg3' + (new Date().getTime());
        let storageRef = firebase.storage().ref();
        const fileData = await storageRef.child(`${'/svg-design-images3'}/${uniqlogo1}`).put(data)
            .then(snapshot => {
                return snapshot.ref.getDownloadURL();
            }).then(async (downloadURL) => {
                this.urlsSvgSide2Data= downloadURL;
                // this.toastr.success('Image. sucessfully upload/ed', '', { positionClass: 'toast-top-right' });
            }).catch(error => {
                this.toastr.error("Faild to upload image. Plase try again", '', { positionClass: 'toast-top-right', onActivateTick: true, timeOut: 10000 });
            });
    }

    async convertBase64ToBlob(base64Image: string) {
        // Split into two parts
        if(base64Image!=null){
            const parts = base64Image.split(';base64,');
        // Hold the content type
        const imageType = parts[0].split(':')[1];
        // Decode Base64 string
        const decodedData = window.atob(parts[1]);
        // Create UNIT8ARRAY of size same as row data length
        const uInt8Array = new Uint8Array(decodedData.length);
        // Insert all character code into uInt8Array
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        // Return BLOB image after conversion
        return new Blob([uInt8Array], { type: imageType });
    }
    }

    // async  makeblob(dataURL) {
    //     const BASE64_MARKER = ';base64,';
    //     const parts = dataURL.split(BASE64_MARKER);
    //     const contentType = parts[0].split(':')[1];
    //     const raw = window.atob(parts[1]);
    //     const rawLength = raw.length;
    //     const uInt8Array = new Uint8Array(rawLength);

    //     for (let i = 0; i < rawLength; ++i) {
    //         uInt8Array[i] = raw.charCodeAt(i);
    //     }

    //     return new Blob([uInt8Array], { type: contentType });
    // }


    ngOnInit() {
        this.fetchSubmissionToINCID();
        if (localStorage.getItem('category'))
            localStorage.removeItem('category')
        if (localStorage.getItem('emitcolor'))
            localStorage.removeItem('emitcolor')
        this.localStorage();
        this.removeLocalStorage();
        var arrayLength = this.fontArray.length;
        var fontA = this.fontArray;
        var font;
        this.availableLogoLocations = [];
        this.applied_OutSideOptions = [];

        // this.promoVideoUrl = "https://www.youtube.com/embed/PSUBkMIV3bI?mute=0&&autoplay=0&loop=1&rel=0&showinfo=0&controls=0&color=white&iv_load_policy=1&playlist=PSUBkMIV3bI";
        // if (localStorage.getItem("isFirstTimeNavigate") != "visible") {
        // document.getElementById("overlay-section").style.cssText = "display: block;";
        // if (document.getElementsByClassName("iframe-video")[0]) {
        //     document.getElementsByClassName("iframe-video")[0].setAttribute("src", this.promoVideoUrl);
        // }
        // }
        for (var i = 0; i < arrayLength; i++) {
            font = new FontFaceObserver(fontA[i]);
            font.load().then(function () {
            }).catch(function () { });
        }
        this.selectedUniformType = 'GameDay';

        this.snapSvg = Snap("#svg");
        const g = this.snapSvg.g();
        let el = "/assets/img/STR8LOGO.png";
        var image = g.image(el, "33%", 150, 296, 210);
        var svgtxt = g.text('25%', 426, "Choose a uniform to begin.");
        svgtxt.attr({
            style: 'font-family: full_block-webfont; font-size: 36px;'
        });

        var element = document.getElementById('canvasOuter');
        var cs = getComputedStyle(element);

        var paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
        var paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);

        var borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
        var borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

        // Element width and height minus padding and border
        var elementWidth = element.offsetWidth - paddingX - borderX;
        var elementHeight = element.offsetHeight - paddingY - borderY;

        this.size.width = elementWidth - 100;
        this.size.height = elementHeight - 100;

        this.snapSvg.height = this.size.height;
        this.snapSvg.width = this.size.width;
        // this.setupWelcomeCanvas(this.size.width, this.size.height);
        const skuId = window.location.href.split('/design/')[1];
        if (skuId) {
            this.showDesignbySkuId(skuId);
        }

        const design_id = window.location.href.split('/submissions/')[1];
        console.log("design_id",design_id);
        if (design_id) {
            // this.selectColorOptions()

            this.showDesignbyId(design_id);
        }
        if (window.location.href.includes('editor')) {
            this.toggleUniformSelect(false);
            this.getSelectedJerseyStylesFromDb();
        }

        // this.graphicOption.onChangeTeamNameValues('CollegeBlock2-0','Fonttype','Team');
        // this.onChangeTeamNameValues('CollegeBlock2-0','Fonttype','Player');
    }
    private colorsSelected: boolean = false;
    private patternSelected: boolean = false;
    private textSelected: boolean = false;
    private logoSelected: boolean = false;
    private introSelected: boolean = true;
    private showRosterUpload: boolean = false;
    private showThanks: boolean = false;
    private hoverColor: string = "";
    private showSubmitForm: boolean = false;
    private showProductIntro: boolean = true;
    private showStyleCuts: boolean = false;
    private showSubDetail: boolean = false;
    private activeThumbnill: any;

    async showDesignbySkuId(skuNumber) {
        //  skuNumber = "dsaff";
        var selStyle;
        // this.toggleUniformSelect();
        this.isloader = true;
        // this.startLoadingSpinner();
        this.dbService.list('/jersey-styles').valueChanges().subscribe(stytempla => {
            if (this.isloader) {
                this.stytemplates = stytempla;
                this.selectedDesignUniformStyles = this.loadAlldesignUniforms();
                this.selectedDesignUniformStyles.forEach(function (d) {
                    if (d.sku_number == skuNumber || d.shorts_sku == skuNumber || d.jersey_sku == skuNumber || (d.skuList && d.skuList.length > 0 && d.skuList.includes(skuNumber))) {
                        selStyle = d;
                        selStyle.name = selStyle.name.replace(/\s+/g, '-').toLowerCase();
                    }
                })
                if (selStyle) {
                    this.selectedUniformType = 'GameDay';
                    this.clearDefaultFonts();
                    this.handleImageClick(selStyle, false);
                    this.toggleSelectCutType();
                    // this.selectColorOptions();
                }
            }
            this.isloader = false;
            this.loading = false;

        });
    }

    async resubmitDesign(url, designid, that) {
        await this.dbService.object(url).valueChanges().subscribe(sub => {
            if (sub) {
                this.resubmittedDesign = sub;
                this.getDesign(designid, that)
            }
        });
    }
    toDataURL(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function() {
			var reader = new FileReader();
			reader.onloadend = function() {
				callback(reader.result);
			}
			reader.readAsDataURL(xhr.response);
		};
		xhr.open('GET', url);
		xhr.responseType = 'blob';
		xhr.send();
	}

    async  showDesignbyId(designid) {
        console.log(designid);
        var that = this;
        this.firstLoader = true;
        this.getSelectedJerseyStylesFromDb();
        let revisionId = window.location.href.split('?revisionKey=')[1];
        let url;
        if (revisionId) {
            revisionId = revisionId.split('&curveFlag')[0];
            if (designid.includes('?revisionKey='))
                designid = designid.split('?revisionKey=')[0];
            else
                designid = designid.split('?curveFlag')[0];
            url = `/revision/${designid}/${revisionId}`;
        }
        else {
            designid = designid.split('?curveFlag')[0];
            url = `/submissions/${designid}`;
        }
        this.dbService.list('/jersey-styles').valueChanges().subscribe(stytempla => {
                this.stytemplates = stytempla;
                this.submissionService.getSubmissionByID(designid).subscribe(async res => {
                    if (this.firstLoader) {
                                this.reEditFlag = true;
                                this.firstLoader = false;
                                this.submittedDesign1 = res.json().submission;
                                var pat = /^https?:\/\//i;
                                let svgHtmldata = null;
                                    if (pat.test(res.json().submission.data.svgFileHtml))
                                    {
                                        var request = new XMLHttpRequest();
                                        var url = "https://firebasestorage.googleapis.com/v0/b/uniform-e640f.appspot.com/o/svg-design-images%2FReQuestImageSvg1597325059768?alt=media&token=ab98f7cd-2826-4d08-a651-a42a1548921a"
                                        var txtFile = new XMLHttpRequest();
                                        let v = this;
                                        txtFile.open("GET", res.json().submission.data.svgFileHtml, true);
                                        txtFile.onreadystatechange = function() {
                                            if (txtFile.readyState === 4) {  // Makes sure the document is ready to parse.
                                            if (txtFile.status === 200) {  // Makes sure it's found the file.
                                                var allText = txtFile.responseText;
                                                svgHtmldata = allText.toString();
                                                v.submittedDesign1.data['svgFileHtml'] = svgHtmldata;
                                                v.submittedDesign = v.submittedDesign1;
                                                v.resubmittedDesign = res.json().submission;
                                                localStorage.setItem('category', v.resubmittedDesign.data.JerseyObj.category);
                                                    if (revisionId) {
                                                        v.dbService.object(url).valueChanges().subscribe(sub => {
                                                            v.resubmittedDesign = res.json().submission;
                                                            v.getDesign(designid, that)
                                                        
                                                        });
                                                    } else {
                                                        v.getDesign(designid, that);
                                                    }
                                             }
                                         }
                                        }
                                        txtFile.send(null);
                                        }else{
                                            this.submittedDesign1.data['svgFileHtml'] =res.json().submission.data.svgFileHtml
                                        }
                            }
                })
         
        });
 
      
        // `/submissions/${designid}`

        // console.log('url',url);
        // this.reEditFlag = true;
        // this.firstLoader = false;
        // this.getDesign(designid, that);

        // await this.dbService.object(url).valueChanges().subscribe(sub => {
        //     console.log("sub",sub);
        //     if (this.firstLoader) {
        //         this.reEditFlag = true;
        //         this.firstLoader = false;
        //         this.submittedDesign = sub;
        //         this.resubmittedDesign = sub;
        //         localStorage.setItem('category', this.resubmittedDesign.JerseyObj.category);
        //         if (revisionId) {
        //             this.dbService.object(url).valueChanges().subscribe(sub => {
                      
        //                 this.resubmittedDesign = sub;
        //                 this.getDesign(designid, that)
                      
        //             });
        //         } else {
        //             this.getDesign(designid, that);
        //         }


        //     }
        // });
    }

  


    async getDesign(designid, that) {
        this.designId = designid;
        let revisionId = window.location.href.split('?revisionKey=')[1];
        if (revisionId) {
        this.fetchRevisionToINCID();
        }
        var element = this.submittedDesign.data.JerseyObj;
        let curJerseyStyle: Jersey;
        this.logo = this.submittedDesign.data.logo;
        if (this.submittedDesign.data.availableLogoLocations) {
            this.availableLogoLocations = this.submittedDesign.data.availableLogoLocations;
        } else { }
        console.log("this.outsideFileHTML",this.outsideFileHTML);
        this.outsideFileHTML = this.submittedDesign.data.svgFileHtml;
        this.insideFileHTML = this.submittedDesign.data.insideFileHTML;
        if (this.submittedDesign.data.LayerColors_OutSide) {
            var copy1 = JSON.parse(JSON.stringify(this.submittedDesign.data.LayerColors_OutSide));
            copy1.forEach(function (item) {
                that.layerColorApplied_OutSide.push(new SelectedColorObj(item.layer, item.colorCode, item.colorName, item.fontStroke, item.strokeWidth, item.fontStrokeColorName, item.fontType, item.fontSize, item.text));
            });
        }
        if (this.submittedDesign.data.LayerColors_InSide) {
            var copy2 = JSON.parse(JSON.stringify(this.submittedDesign.data.LayerColors_InSide));
            copy2.forEach(function (item) {
                that.layerColorApplied_InSide.push(new SelectedColorObj(item.layer, item.colorCode, item.colorName, item.fontStroke, item.strokeWidth, item.fontStrokeColorName, item.fontType, item.fontSize, item.text));
            });
        }
        if (this.submittedDesign.data.uniformType) {
            this.selectedUniformType = this.submittedDesign.data.uniformType;
        } else {
            this.selectedUniformType = 'GameDay';
        }
        if (element) {
            curJerseyStyle = new JerseyObj(element.category, element.gender, element.name, element.display_Name, element.img_url, true, element.cut_name, element.layoutType, element.thumbnail_url, element.sku_number, element.product_id, element.jersey_sku, element.shorts_sku);
            this.clearDefaultFonts();
            this.handleImageClick(curJerseyStyle, false);
            this.toggleSelectCutType();
            this.selectColorOptions();
            // this.selectPatternOptions();
        } else {
            this.toastr.error("No record found Please contact support.", '', { timeOut: 10000, positionClass: 'toast-top-right' });
        }
    }

   

    loadAlldesignUniforms() {
        let allUnis: any[] = [];

        this.stytemplates.forEach(element => {
            let curJerseyStyle: Jersey;
            if (element.files.length > 1) {
                let thumbnail_url = element.files[0].img_url;
                if (element.thumbnail_url) {
                    thumbnail_url = element.thumbnail_url;
                }
                curJerseyStyle = new JerseyObj(element.category, element.gender, element.name, element.display_Name, element.files[0].img_url, true, element.files[0].cutType, element.files[0].layoutType, thumbnail_url, element.sku_number, element.product_id, element.jersey_sku, element.shorts_sku);
            } else {
                curJerseyStyle = new JerseyObj(element.category, element.gender, element.name, element.display_Name, element.files[0].img_url, false, element.files[0].cutType, element.files[0].layoutType, element.thumbnail_url, element.sku_number, element.product_id, element.jersey_sku, element.shorts_sku);
            }

            while (curJerseyStyle.name.includes("-"))
                curJerseyStyle.name = curJerseyStyle.name.replace("-", " ");
            curJerseyStyle.name = curJerseyStyle.name.toUpperCase();
            if (element.skuList && element.skuList.length > 0) {
                curJerseyStyle['skuList'] = element.skuList;
            }
            allUnis.push(curJerseyStyle);
        });
        this.selectedDesignUniformStyles = allUnis;
        return allUnis;
    }

    showBuilderOnly() {
        this.showBuilder = true;
        this.textSelected = false;
        this.logoSelected = false;
        this.introSelected = false;
        this.showSubmitForm = false;
        this.showProductIntro = false;
        this.showUniformSelectComponent = false;
        this.showRosterUpload = false;
    }

    showSelectOnly() {
        this.showBuilder = false;
        this.textSelected = false;
        this.logoSelected = false;
        this.introSelected = false;
        this.showProductIntro = false;
        this.showSubmitForm = false;
        this.showUniformSelectComponent = true;
        this.colorsSelected = false;
        this.patternSelected = false;
        this.showRosterUpload = false;
    }

    hideAllNotBuilder() {
        this.showBuilder = true;
        this.textSelected = false;
        this.logoSelected = false;
        this.introSelected = false;
        this.showRosterUpload = false;
        this.showProductIntro = false;
        this.showSubmitForm = false;
        this.colorsSelected = false;
        this.patternSelected = false;
        this.showUniformSelectComponent = false;
    }

    setdefaultSlide() {
        this.selected_slide = 1;
    }

    openSizingChart() {
        window.open("http://www.str8sports.com/size-charts/", "_blank");
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

    openModalReset(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

    confirmClear() {
        if (confirm('Are you sure?')) {
            this.canvas.clear();
        }
    }

    resetPopup() {
        this.canvas.clear();
        this.modalRef.hide();
    }

    cancelResetPopup() {
        this.modalRef.hide();
    }

    closeModal(template: TemplateRef<any>) {
        this.modalRef.hide();
    }
    closeOverlay() {
        // this.promoVideoUrl.replace("mute=0", "mute=1");
        if (document.getElementsByClassName("iframe-video")[0]) {
            document.getElementsByClassName("iframe-video")[0].setAttribute("src", " ");
        }
        document.getElementById("overlay-section").style.display = "none";
        localStorage.setItem("isFirstTimeNavigate", "visible");
    }
    showPromoVideo() {
        // localStorage.removeItem("isFirstTimeNavigate");
        if (document.getElementById("overlay-section")) {
            document.getElementById("overlay-section").style.cssText = "display: block;";
            this.promoVideoUrl.replace("mute=1", "mute=0");
            if (document.getElementsByClassName("iframe-video")[0]) {
                document.getElementsByClassName("iframe-video")[0].setAttribute("src", this.promoVideoUrl);
            }
        }
    }

    toggleColors() {
        this.showBuilderOnly()
        this.colorsSelected = true;
    }

    toggleUniformSelect(flag) {
        if (document.getElementById("overlay-section")) {
            if (document.getElementsByClassName("iframe-video")[0]) {
                document.getElementsByClassName("iframe-video")[0].setAttribute("src", " ");
            }
            document.getElementById("overlay-section").style.display = "none";
            localStorage.setItem("isFirstTimeNavigate", "visible");
        }
        this.setAllMenuInActive();
        this.menuState.SelectUniform = true;
        this.showSelectOnly();
        this.colorsSelected = false;
        this.patternSelected = false;
        this.showStyleCuts = false;
        this.el.nativeElement.scrollTo(0, 0);

        this.stateTracker.ProductInfo = true;
        this.stateTracker.SelectUniform = false;
        this.stateTracker.Cuttype = false;
        this.stateTracker.TopOptions = false;
        this.stateTracker.PatternOption = false;
        this.stateTracker.GraphicOptions = false;
        this.stateTracker.SubmitUniform = false;
        this.stateTracker.TeamRoster = false;
        const design_id = window.location.href.split('/submissions/')[1];
        if (design_id && flag) {
            this.router.navigate(['/editor'])
        }
    }

    setAllMenuInActive() {
        for (var property in this.menuState) {
            if (this.menuState.hasOwnProperty(property)) {
                this.menuState[property] = false;
            }
        }
    }

    getItemById(id) {
        var object = null,
            objects = this.canvas.getObjects();
        for (var i = 0, len = objects.length; i < len; i++) {
            if (objects[i].id && objects[i].id === id) {
                object = objects[i];
                break;
            }
        }
        return object;
    }
    getImageById(id) {
        var object = null,
            objects = this.imageObjectArray;
        for (var i = 0, len = objects.length; i < len; i++) {
            if (objects[i].id && objects[i].id === id) {
                object = objects[i];
                break;
            }
        }
        return object;
    }

    toggleProductInfo() {
        this.toggleTopOptions();
        this.togglePatternOption();
        this.showProductIntro = true;
        this.colorsSelected = false;
        this.patternSelected = false;
        this.showStyleCuts = false;
        this.menuState.ProductInfo = true;
        this.menuState.TopOptions = false;
        this.menuState.PatternOption = false;


        this.el.nativeElement.scrollTo(0, 0);

        this.stateTracker.ProductInfo = false;
        this.stateTracker.SelectUniform = false;
        this.stateTracker.Cuttype = false;
        this.stateTracker.TopOptions = false;
        this.stateTracker.PatternOption = false;

        this.stateTracker.GraphicOptions = false;
        this.stateTracker.SubmitUniform = false;
        this.stateTracker.TeamRoster = false;
        // if (localStorage.getItem('graphicspage'))
        //     localStorage.removeItem('graphicspage');

    }

    toggleSelectCutType() {
        this.toggleTopOptions();
        this.showStyleCuts = true;
        this.colorsSelected = false;
        this.patternSelected = false;
        this.menuState.Cuttype = true;
        this.menuState.TopOptions = false;
        this.menuState.PatternOption = false;

        this.el.nativeElement.scrollTo(0, 0);
        this.stateTracker.ProductInfo = true;
        this.stateTracker.SelectUniform = true;
        this.stateTracker.Cuttype = false;
        this.stateTracker.TopOptions = false;
        this.stateTracker.PatternOption = false;



        this.stateTracker.GraphicOptions = false;
        this.stateTracker.SubmitUniform = false;
        this.stateTracker.TeamRoster = false;
        this.dragTextElements(false);
        // if (localStorage.getItem('graphicspage'))
        //     localStorage.removeItem('graphicspage');
    }

    toggleTopOptions() {
        this.el.nativeElement.scrollTo(0, 0);
        this.setAllMenuInActive();
        this.menuState.TopOptions = true;
        this.hideAllNotBuilder();
        this.colorsSelected = true;
        this.showStyleCuts = false;
    }

    togglePatternOption() {
        this.el.nativeElement.scrollTo(0, 0);
        this.setAllMenuInActive();
        this.menuState.PatternOption = true;
        this.hideAllNotBuilder();
        this.patternSelected = true;
        this.colorsSelected = false;
        this.stateTracker.TopOptions = true;
        this.stateTracker.PatternOption = false;


    }

    selectColorOptions() {
        if (this.stateTracker.TopOptions == true) {
            try {
                if (this.selected_slide == 1) {
                    this.outsideFileHTML = this.snapSvg.select("svg").node.outerHTML;
                } else {
                    this.insideFileHTML = this.snapSvg.select("svg").node.outerHTML;
                }
            } catch (error) {
                console.log(error)
            }
        }
        this.toggleTopOptions();
        this.stateTracker.Cuttype = true;
        this.stateTracker.TopOptions = false;
        this.stateTracker.PatternOption = false;

        this.stateTracker.ProductInfo = true;
        this.stateTracker.GraphicOptions = false;
        this.stateTracker.SubmitUniform = false;
        this.stateTracker.TeamRoster = false;
        this.dragTextElements(false);
        this.setDefaultTextColorOptions(this.snapSvg, true);
        // if (localStorage.getItem('graphicspage'))
        //     localStorage.removeItem('graphicspage');
    }


    selectPatternOptions() {
        if (this.stateTracker.PatternOption == true) {
            try {
                if (this.selected_slide == 1) {
                    this.outsideFileHTML = this.snapSvg.select("svg").node.outerHTML;
                } else {
                    this.insideFileHTML = this.snapSvg.select("svg").node.outerHTML;
                }
            } catch (error) {
                console.log(error)
            }
        }
        this.stateTracker.Cuttype = true;
        this.stateTracker.TopOptions = false;
        this.stateTracker.PatternOption = true;
        this.togglePatternOption();
        this.stateTracker.ProductInfo = true;
        this.stateTracker.GraphicOptions = false;
        this.stateTracker.SubmitUniform = false;
        this.stateTracker.TeamRoster = false;
        this.dragTextElements(false);
        this.setDefaultTextColorOptions(this.snapSvg, true);
        // if (localStorage.getItem('graphicspage'))
        //     localStorage.removeItem('graphicspage');
    }

    toggleBottomOptions() {
        this.setAllMenuInActive();
        this.menuState.BottomOptions = true;
        this.toggleTopOptions();
        this.el.nativeElement.scrollTo(0, 0);
    }

    over(color) {
        this.hoverColor = color.colorName;
    }

    toggleGraphicOptions() {

        this.setAllMenuInActive();
        this.menuState.GraphicOptions = true;
        this.hideAllNotBuilder()
        this.logoSelected = true;
        this.textSelected = true;
        this.menuState.TopOptions = false;
        this.menuState.PatternOption = false;
        this.menuState.Cuttype = false;
        this.showStyleCuts = false;
        this.el.nativeElement.scrollTo(0, 0);

        this.stateTracker.TopOptions = true;
        this.stateTracker.PatternOption = true;
        this.stateTracker.PatternOption = true;

        this.stateTracker.GraphicOptions = false;
        this.stateTracker.ProductInfo = true;
        this.stateTracker.SubmitUniform = false;
        this.stateTracker.TeamRoster = false;
        this.dragTextElements(true);
        this.setDefaultTextColorOptions(this.snapSvg, false);
    }
    toggleTeamRoster() {
        this.setAllMenuInActive();
        this.menuState.TeamRoster = true;
        this.hideAllNotBuilder()
        this.showRosterUpload = true;
        this.menuState.TopOptions = false;
        this.menuState.PatternOption = false;
        this.menuState.Cuttype = false;
        this.showStyleCuts = false;
        this.el.nativeElement.scrollTo(0, 0);

        this.stateTracker.GraphicOptions = true;
        this.stateTracker.Cuttype = true;
        this.stateTracker.TopOptions = true;
        this.stateTracker.PatternOption = true;
        this.stateTracker.TeamRoster = false;
        this.stateTracker.ProductInfo = true;
        this.getVariantSize();

        //to hide Team Roster
        //this.submitTeamRosterForm(null);
    }
    toggleSubmitUniform() {
        this.el.nativeElement.scrollTo(0, 0);
        this.setAllMenuInActive();
        this.menuState.SubmitUniform = true;
        this.hideAllNotBuilder();
        this.showSubmitForm = true;
        this.submitFlag = undefined;
        this.finalizeBtnFlag = false;
        this.menuState.TopOptions = false;
        this.menuState.PatternOption = false;
        this.menuState.Cuttype = false;
        this.showStyleCuts = false;
        this.stateTracker.TeamRoster = true;
    }

    toggleSaveUniform() {
        // Vishal TODO
        // Add logic to check if admin enabled team roster
        if (this.isTeamRosterEnabledForBusiness) {
            this.toggleRosterPanel();
            // team roster enabled, open Team Roster instead of Save Unform 
        } else {
            // team roster not enabled, open Save Uniform

            this.el.nativeElement.scrollTo(0, 0);
            this.setAllMenuInActive();
            this.menuState.SubmitUniform = true;
            this.hideAllNotBuilder();
            this.showSubmitForm = true;
            this.submitFlag = undefined;
            this.finalizeBtnFlag = false;
            this.menuState.TopOptions = false;
            this.menuState.PatternOption = false;
            this.menuState.Cuttype = false;
            this.showStyleCuts = false;

            this.stateTracker.GraphicOptions = true;
            this.stateTracker.SubmitUniform = false;
            this.stateTracker.TeamRoster = false;
            setTimeout(() => {
                try {
                    if (this.selected_slide == 1) {
                        this.outsideFileHTML = this.snapSvg.select("svg").node.outerHTML;
                    } else {
                        this.insideFileHTML = this.snapSvg.select("svg").node.outerHTML;
                    }
                    this.setDefaultTextColorOptions(this.snapSvg, false);
                } catch (error) {
                    console.log(error);
                }
                try {
                    if (this.reEditFlag && this.submittedDesign) {
                        // this.getVariantSize();
                        this.submitJerseyForm.setValue({ name: this.submittedDesign.name, email: this.submittedDesign.email, phone: this.submittedDesign.phone, organization: this.submittedDesign.data.organization });
                        this.submitJerseyFormupdate =
                            {
                                "name": this.submittedDesign.name,
                                "email": this.submittedDesign.email,
                                "phone": this.submittedDesign.phone,
                                "organization": this.submittedDesign.data.organization
                            };
                        this.disabledValue = true;
                    }
                    if (this.selectedUniformType == 'HomeAway' || this.selectedUniformType == 'Reversible') {
                        this.toastr.warning("Double check both uniform sides before submitting. ", "NOTE", { positionClass: 'toast-top-right' });
                    }
                } catch (error) {
                }
            }, 100);
            // if (localStorage.getItem('graphicspage'))
            //     localStorage.removeItem('graphicspage');

        }


    }

    ngAfterViewChecked() {
    }

    toggleRosterPanel() {
        this.setAllMenuInActive();
        this.menuState.TeamRoster = true;
        this.hideAllNotBuilder();
        this.showRosterUpload = true;
        this.menuState.TopOptions = false;
        this.menuState.PatternOption = false;
        this.menuState.Cuttype = false;
        this.showStyleCuts = false;
        this.el.nativeElement.scrollTo(0, 0);

        this.stateTracker.GraphicOptions = true;
        this.stateTracker.Cuttype = true;
        this.stateTracker.TopOptions = true;
        this.stateTracker.PatternOption = true;
        this.stateTracker.SubmitUniform = true;
        this.stateTracker.TeamRoster = false;
        this.stateTracker.ProductInfo = true;
        this.getVariantSize();
        // if (localStorage.getItem('graphicspage'))
        //     localStorage.removeItem('graphicspage');
        //to hide Team Roster
        //this.submitTeamRosterForm(null);
    }

    goToRosterPanel(submitJersey, savelaterFlag) {

        if (savelaterFlag)
            this.submitFlag = true;
        else
            this.submitFlag = false;
        if (savelaterFlag) {
            // this.toggleRosterPanel();
            let checkdesign_id = window.location.href.split('/submissions/')[1];
            if (checkdesign_id) {
                if (!this.playerListFlag) {
                    this.getVariantSizeForLater(submitJersey, savelaterFlag);
                }
                else {
                    this.submitJersey(submitJersey, savelaterFlag,'');
                }
            } else {
                this.submitJersey(submitJersey, savelaterFlag,'');
            }
        } else {
            this.submitFormData = submitJersey;
            this.toggleRosterPanel();
            this.playerListFlag = true;
        }
    }

    submitTeamRosterFormdata() {
        this.finalizeBtnFlag = true;
        this.submitJersey(this.submitFormData, false,'');

    }

    getSvgBase64UrlwithText() {
        var svg = document.getElementById("svg");
        //get svg source.
        var serializer = new XMLSerializer();
        var source = serializer.serializeToString(svg);
        //add name spaces.
        if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
            source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
            source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }
        //add xml declaration
        source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
        //convert svg source to URI data scheme.
        var url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);
    }

    RGBToHex(rgb) {
        // Choose correct separator
        let sep = rgb.indexOf(",") > -1 ? "," : " ";
        // Turn "rgb(r,g,b)" into [r,g,b]
        rgb = rgb.substr(4).split(")")[0].split(sep);

        let r = (+rgb[0]).toString(16),
            g = (+rgb[1]).toString(16),
            b = (+rgb[2]).toString(16);

        if (r.length == 1)
            r = "0" + r;
        if (g.length == 1)
            g = "0" + g;
        if (b.length == 1)
            b = "0" + b;

        return "#" + r + g + b;
    }

    saveDesign(submitJersey, savelaterFlag, isLogin) {
        this.loading = true;
        if(isLogin=='login') {
            var loginObject = {
                email: submitJersey.email,
                password: submitJersey.password
            }
            let me = this;
            
            this.submissionService.login(loginObject).subscribe(res => {
                let user = res.json();
                console.log("user is login ",user);
                window.localStorage.setItem('name', user.user.name);
                window.localStorage.setItem('emailForSignIn', user.user.email);
                window.localStorage.setItem('token', user.token);
                if (user.user.role) {
                    if (user.user.role == 'customer') {
                        window.localStorage.setItem('userrole', 'User');
                        // me.router.navigate(['/locker-room/submissions']);
                    } else if (user.user.role == 'admin') {
                        window.localStorage.setItem('userrole', 'Admin');
                        // me.router.navigate(['/admin/submissions']); 
                    }
                }
                var existingUser = {
                    userRole:user.user.role,
                    name:user.user.name,
                    email:user.user.email,
                    organization:'',
                    phone:''   
                }
                this.submitFlag = true;
                this.submitJersey(submitJersey, savelaterFlag,existingUser);
                
                // this.loading = false;
            }, error => {
                let err = error.json();
                console.log("err is !!!!!!!",err);
                this.toastr.error("User name and password provided is incorrect", '', { timeOut: 5000, positionClass: 'toast-top-right' });
                this.loading = false;
            });
        }else if(isLogin=='register'){
            console.log("submitJersey",submitJersey);
            
        var obj = {
            email: submitJersey.email,
            password: submitJersey.password,
            fullName: submitJersey.name,
            organization: submitJersey.organization ? submitJersey.organization : '',
            phoneNumber: submitJersey.phone ? submitJersey.phone : ''

        }
        let me = this;
        this.submissionService.registerUser(obj).subscribe(res => {
            let user = res.json();
            console.log("user is register ",user);
            // console.log(user.user.email);
            window.localStorage.setItem('emailForSignIn', user.user.emailAddress);
            window.localStorage.setItem('token', user.token);
            
            if (user.user.role) {
                if (user.user.role == 'customer') {
                    window.localStorage.setItem('userrole', 'User');
                    // me.router.navigate(['/locker-room/submissions']);
                } else if (user.user.role == 'admin') {
                    window.localStorage.setItem('userrole', 'Admin');
                    // me.router.navigate(['/admin/submissions']);
                }
            }

            var newUser = {
                userRole:user.user.role,
                name:user.user.fullName,
                email:user.user.emailAddress,
                organization:user.user.organization,
                phone:user.user.phoneNumber
            }
            this.submitFlag = true;
            this.submitJersey(submitJersey, savelaterFlag,newUser);

            // this.loading = false;

        }, error => {
            let err = error.json();
            console.log("err is !!!!!!!",err);
            this.toastr.error(err.errorMessage, '', { timeOut: 5000, positionClass: 'toast-top-right' });
            this.loading = false;
        });
        //  this.createNewAccount(submitJersey.email, submitJersey.password, submitJersey.name, submitJersey.organization, submitJersey.phone);
        }
        // this.submitFlag = true;
        // this.submitJersey(submitJersey, savelaterFlag,isLogin);
    }

    async submitJersey(submitJersey, savelaterFlag,user) {
        if(user!=''){
            submitJersey = user;                                                                                     
        }
        
  
        //Fill Color of Layer with Acutal Color in SVG if not selected any Layer
        this.savelaterFlag = savelaterFlag;
        var object = {
            paths: document.getElementsByTagName("path")
        };
        if (this.selected_slide === 1) {
            if (this.layerColorApplied_OutSide.length > 0) {
                for (let i = 0; i < this.layerColorApplied_OutSide.length; i++) {
                    if (this.layerColorApplied_OutSide[i].colorCode === "") {
                        for (var j in object.paths) {
                            if (object.paths[j].id == this.layerColorApplied_OutSide[i].layer) {
                                this.layerColorApplied_OutSide[i].colorCode = object.paths[j].style.fill;
                            }
                        }
                    }
                    if (!this.layerColorApplied_OutSide[i].fontSize) {
                        this.layerColorApplied_OutSide[i].fontSize = "";
                    }
                    if (this.layerColorApplied_OutSide[i].colorCode === "") {
                        var layerId = "#" + this.layerColorApplied_OutSide[i].layer;
                        if ($(layerId).css("fill") == 'rgba(0, 0, 0, 0)') {
                            this.layerColorApplied_OutSide[i].colorCode = "#000000";
                            this.layerColorApplied_OutSide[i].colorName = "Team Black";
                        } else if ($(layerId).css("fill") == 'rgb(255, 255, 255)') {
                            this.layerColorApplied_OutSide[i].colorCode = "#FFFFFF";
                            this.layerColorApplied_OutSide[i].colorName = "White";
                        } else {
                            try {
                                this.layerColorApplied_OutSide[i].colorCode = this.RGBToHex($(layerId).css("fill"));
                            } catch (error) { }
                        }
                    }
                }
            }
        } else {
            if (this.layerColorApplied_InSide.length > 0) {
                for (let i = 0; i < this.layerColorApplied_InSide.length; i++) {
                    if (this.layerColorApplied_InSide[i].colorCode === "") {
                        for (var j in object.paths) {
                            if (object.paths[j].id == this.layerColorApplied_InSide[i].layer) {
                                this.layerColorApplied_InSide[i].colorCode = object.paths[j].style.fill;
                            }
                        }
                    }
                    if (this.layerColorApplied_InSide[i].colorCode === "") {
                        var layerId = "#" + this.layerColorApplied_InSide[i].layer;
                        if ($(layerId).css("fill") == 'rgba(0, 0, 0, 0)') {
                            this.layerColorApplied_InSide[i].colorCode = "#000000";
                            this.layerColorApplied_InSide[i].colorName = "Team Black";
                        } else if ($(layerId).css("fill") == 'rgb(255, 255, 255)') {
                            this.layerColorApplied_InSide[i].colorCode = "#FFFFFF";
                            this.layerColorApplied_InSide[i].colorName = "White";
                        } else {
                            try {
                                this.layerColorApplied_InSide[i].colorCode = this.RGBToHex($(layerId).css("fill"));
                            } catch (error) { }
                        }
                    }
                }
            }
        }

        //top bottom
        if (!savelaterFlag) {
            var tarr = [],
                barr = [];
            this.players.forEach(function (d) {
                tarr.push(d.topSize);
                barr.push(d.bottomSize);
            });
            var topArr = []
            tarr.forEach(function (t) {
                var cnt = tarr.filter(function (d) {
                    return d == t
                });
                var obj = {
                    size: t,
                    quantity: cnt.length
                };
                topArr.push(obj)
            });
            topArr = Array.from(new Set(topArr.map(x => x.size))).map(size => {
                return {
                    size: size,
                    quantity: topArr.find(s => s.size == size).quantity
                }
            });

            var bottomArr = []
            barr.forEach(function (t) {
                var cnt = barr.filter(function (d) {
                    return d == t
                });
                var obj = {
                    size: t,
                    quantity: cnt.length
                };
                bottomArr.push(obj)
            });
            bottomArr = Array.from(new Set(bottomArr.map(x => x.size))).map(size => {
                return {
                    size: size,
                    quantity: bottomArr.find(s => s.size == size).quantity
                }
            });

            var self = this;
            topArr.forEach(function (t) {
                var obj = self.orderDataJersey.filter(function (d) {
                    return d.title == t.size
                });
                if (obj.length > 0) {
                    t.id = obj[0].id
                }
            })

            bottomArr.forEach(function (t) {
                var obj = self.orderDataShorts.filter(function (d) {
                    return d.title == t.size
                });
                if (obj.length > 0) {
                    t.id = obj[0].id
                }
            });

            var mainArr = topArr.concat(bottomArr);

            var Jarr = [],
                shorts = [];
            this.players.forEach(function (d) {
                var index = Jarr.findIndex(x => x.size === d.topSize);
                if (index == -1) {
                    var obj = {
                        size: d.topSize,
                        note: d.name + "(" + d.number + ")"
                    };
                    Jarr.push(obj)
                } else {
                    Jarr[index].note = Jarr[index].note + "," + d.name + "(" + d.number + ")"
                }
                var index2 = shorts.findIndex(x => x.size === d.bottomSize)
                if (index2 == -1) {
                    var obj2 = {
                        size: d.bottomSize,
                        note: d.name + "(" + d.number + ")"
                    };
                    shorts.push(obj2)
                } else {
                    shorts[index2].note = shorts[index2].note + "," + d.name + "(" + d.number + ")"
                }
            });
            var ordernote = ''
            Jarr.forEach(function (d) {
                ordernote = ordernote + 'Jersey ' + d.size + ' - ' + d.note + "%0A"
            })

            shorts.forEach(function (d) {
                ordernote = ordernote + 'Shorts ' + d.size + ' - ' + d.note + "%0A"
            })
        }
        //   this.alertService.confirmThis("Are you sure you are done designing your uniform?", function() {
        //ACTION: Do this If user says YES
        //Stores Base64 and Json for Submission Saving.
        if (this.selected_slide == 1) {
            // this.Database64_OutSide = this.snapSvg.toDataURL();
            this.Datajson_OutSide = "";
        } else {
            this.Database64_InSide = this.snapSvg.toDataURL();
            // this.Database64_InSide = '';
            this.Datajson_Inside = "";
        }
        var date = moment().format('L');
        // console.log("this.Database64_OutSide     ***********************",this.Database64_OutSide);
        // console.log("this..Database64_InSide     ***********************",this.Database64_InSide)
        // var svgFileHtml = this.snapSvg.select("svg").node.outerHTML;
        // console.log();
        var svgFileHtml = this.outsideFileHTML;
        var insideFileHTML = this.insideFileHTML;
        if (svgFileHtml == "" || !svgFileHtml) {
            if (this.selected_slide == 1) {
                svgFileHtml = this.snapSvg.select("svg").node.outerHTML;
            }
        }
        var JerseyObj = JSON.parse(JSON.stringify(this.selectedJersycut));

        var lg = "";
        if (this.logo) {
            lg = this.logo;
        }
        var flist = document.querySelectorAll("foreignObject object")
        for(var i in flist){
        if(!isNaN(<any>i)){
        var img = document.createElement("image");
        img.setAttribute('x', flist[i].parentElement.getAttribute("x"));
        img.setAttribute('y', flist[i].parentElement.getAttribute("y"));
        img.setAttribute('height', flist[i].parentElement.getAttribute("height"));
        img.setAttribute('width', flist[i].parentElement.getAttribute("width"));
        var d = flist[i].getAttribute("data");
        img.setAttribute('xlink:href', flist[i].getAttribute("data"));
        if(d && d != ""){
        flist[i].parentElement.outerHTML = img.outerHTML;
        }
        }
        }
        Array.prototype.forEach.call( flist, function( node ) {
            node.parentNode.removeChild( node );
        });

        if(svgFileHtml && svgFileHtml!=''){
            if (this.selected_slide == 2 && insideFileHTML && insideFileHTML!='') {
                if (this.selectedUniformType == 'HomeAway' ){
                    this.onselectSide(1, this, 'HomeAway');
                }else if(this.selectedUniformType == 'Reversible'){
                    this.onselectSide(1, this, 'reversible');
                }
            }
            // console.log("lg", lg);
            this.getAllExtFonts();
            // this.setTextElementHeight("#svgContainer");
            //console.log(this.graphicElementsHeight);
            this.appendExternalFonts("svg");
            var urlImg = null;
            let a = this; 
            urlImg = await this.loadHomeSvgAsPngUri(urlImg);
            
            var data = null,
                makeTextFile = function (text) {
                    data = new Blob([text], { type: 'text/plain' });
                    return data;
                };
            
            var createdFile = makeTextFile(svgFileHtml);
            await this.handleReaderLoaded(createdFile);
            
            let createdFile2 = await this.convertBase64ToBlob(urlImg);
            await a.handleReaderLoaded1(createdFile2);
        }

        ////------Vishal Added This For Away 
        if(insideFileHTML && insideFileHTML!=''){
            if (this.selected_slide == 1 && svgFileHtml && svgFileHtml!='') {
                if (this.selectedUniformType == 'HomeAway' ){
                    this.onselectSide(2, this, 'HomeAway');
                }else if(this.selectedUniformType == 'Reversible'){
                    this.onselectSide(2, this, 'reversible');
                }
            }
            
            this.getAllExtFonts();
            // this.setTextElementHeight("#svgContainer");
            this.appendExternalFonts("svg");
            var AwayImgUri= null;
            let a = this;
            
            AwayImgUri = await this.loadAwaySvgAsPngUri(urlImg);
            var data = null,
            makeTextFile = function (text) {
                data = new Blob([text], { type: 'text/plain' });
                return data;
            };
            var createdFile1 = makeTextFile(insideFileHTML);
            await this.handleReaderLoaded3(createdFile1);
            let createdFile3 = await this.convertBase64ToBlob(AwayImgUri);
            await a.handleReaderLoaded4(createdFile3);
        }
        
        let newSubmission: IUniformSubmission = new UniformSubmissionObject(this.urlsSvgData, this.urlsSvgDataPng, submitJersey.name, submitJersey.phone, submitJersey.email, submitJersey.organization, '', this.players, this.Database64_OutSide, this.Database64_InSide, this.Datajson_OutSide, this.Datajson_Inside, this.layerColorApplied_OutSide, this.layerColorApplied_InSide, date, this.urlsSvgData, insideFileHTML, JerseyObj, lg, this.selectedUniformType, this.availableLogoLocations,  this.urlsSvgSide2Data,this.urlsSvgSide2DataPng,this.attachmentURL);
        // console.log("newSubmission *************************************** "+newSubmission);
        // let id = (submitJersey.name).replace(/\s/g, "") + Math.floor(Math.random() * 10000) + 1;
        // let id = ('UL-') + Math.floor(Math.random() * 10000) + 1;
        this.loading = false;
        this.submitFlag = undefined;
        let abc = window.location.href.split('/submissions/')[1];
        if (!this.resubmittedDesign) {
            newSubmission['dateToShow'] = new Date().getTime();
        } else {
            newSubmission['dateToShowUpdate'] = new Date().getTime();
        }
        // new start
        let id = "UL-1"
        if (this.lastSubmissions1 && this.lastSubmissions1.length > 0) {
            let temp = +this.lastSubmissions1;
            id = "UL-" + (temp + 1)
        }
        // if (this.lastSubmissions1 && this.lastSubmissions1.length > 0) {
        //     let temp = +this.lastSubmissions1.split('UL-')[1];
        //     id = "UL-" + (temp + 1)
        // }
        // else{
        //     this.toastr.warning("Plase check Your 

        this.submissonId = parseInt(this.lastSubmissions1) + 1;
        let skuId = window.location.href.split('/design/')[1];
        if (!skuId) {
            if (this.route && this.route.params) {
                var key = (<any>this.route.params).value.id;
                if (key) {
                    id = key;
                }
            }
        }




        //read file 
        // var request = new XMLHttpRequest();
        // var url = "https://firebasestorage.googleapis.com/v0/b/uniform-e640f.appspot.com/o/svg-design-images%2FReQuestImageSvg1597325059768?alt=media&token=ab98f7cd-2826-4d08-a651-a42a1548921a"
        // var txtFile = new XMLHttpRequest();
        // let svgHtmldata = null;
        // txtFile.open("GET", url, true);
        // txtFile.onreadystatechange = function() {
        //     if (txtFile.readyState === 4) {  // Makes sure the document is ready to parse.
        //       if (txtFile.status === 200) {  // Makes sure it's found the file.
        //          var allText = txtFile.responseText;
        //          svgHtmldata = allText.toString();
        //       }
        //     }
        //   }
        //   txtFile.send(null);

        // console.log("createdFile is ***************************",createdFile);

        // newSubmission['key'] = id;
        // html2canvas(document.querySelector("#svg")).then(canvas => {
        //     document.body.appendChild(canvas).toDataURL();
        //     console.log("canvas",canvas);
        //     console.log("document.body.appendChild(canvas)",document.body.appendChild(canvas))
        // });

        // var s = new XMLSerializer().serializeToString(document.getElementById("svg"));
        // var imgurl = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(s)));
        // console.log("imgaee urls",imgurl);
        // return;
        // console.log("this.canvssss",this.canvas.toDataURL);
        // newSubmission['key'] = id;
        var newSubmissionclone = JSON.parse(JSON.stringify(newSubmission))
        // console.log("newSubmissionclone !!!!!!!!!",newSubmissionclone);
        // return;
        var that = this;
        if (this.logoFiles && this.logoFiles.length > 0) {
            try {
                var newSubmissionclone = JSON.parse(JSON.stringify(newSubmission));
                var submissionclone = JSON.parse(JSON.stringify(newSubmission));
                this.loading = true;
                console.log("submissionclone ", submissionclone);
                await this.submissionService.saveSubmissionData(submissionclone).subscribe(res => {
                    this.submissionFlag = true;
                    console.log("submisson id is ,",res.json().submissionId);
                    //API For TopSize and BottomSize
                    var counter = 0;
                    var paramString = "";
                    if (!savelaterFlag) {
                        for (var i in mainArr) {
                            let body = {
                                "quantity": mainArr[i].quantity,
                                "id": mainArr[i].id,
                            }
                            paramString = paramString + body.id + ":" + body.quantity + ",";
                            // return;
                            this.http.post('https://uniform-e640f.appspot.com/addcart.php',
                                JSON.stringify(body), {}).subscribe(
                                    res => {
                                        counter++;
                                        if (counter == mainArr.length) {
                                            setTimeout(async () => {
                                                this.submissionFlag = false;
                                                paramString = paramString + '?checkout[email]=' + newSubmission.email + '&note=' + ordernote;
                                                this.players = [new PlayerObj(null, null, null, null)];
                                                var reurl = 'https://str8-sports-inc.myshopify.com/cart/' + paramString;
                                                var rflag = await this.us.uploadLogo(this.logoFiles, newSubmission, id, reurl, savelaterFlag, submitJersey).then(async (data) => {

                                                    this.uploadFileFlag = data;
                                                    this.showMessage(savelaterFlag, submitJersey, id, reurl);



                                                });
                                                this.loading = false;
                                                // this.startLoadingSpinner();
                                            }, 150);
                                        }
                                    }
                                );
                        }
                    } else {
                        var rflag = this.us.uploadLogo(this.logoFiles, newSubmission, id, undefined, savelaterFlag, submitJersey).then(async (data) => {
                            this.uploadFileFlag = data;
                            this.showMessage(savelaterFlag, submitJersey, id, undefined);
                            this.loading = false;
                        });

                    }
                    if (submitJersey.userRole) {
                        if (submitJersey.userRole == 'customer') {
                            console.log();
                            this.router.navigate(['/locker-room/submissions'], { queryParams: { lastsubmission:  res.json().submissionId} });
                            // this.router.navigate(['/locker-room/submissions']);
                        } else if (submitJersey.userRole == 'admin') {
                            this.router.navigate(['/admin/submissions']);
                        }
                    }  
                });

                // await submissionList.set(submissionclone);
                // Alim to Vishal, 6/28 - Dont save submission svg data in /submissions table
                // Save in /submissions-svg-data and create foriegn key to /submissions object
                // var submissionbase64_OutSide = await that.dbService.database.ref('/submissions  /' + id.trim() + '/base64_OutSide')
                // this.dbService.object('/submissions/' + id + '/base64_OutSide');
                // if (newSubmissionclone.base64_OutSide)
                //     await submissionbase64_OutSide.set(newSubmissionclone.base64_OutSide);
                // var submissionSvgFileHtml = await that.dbService.database.ref('/submissions/' + id + '/svgFileHtml')
                // if (newSubmissionclone.svgFileHtml)
                //     await submissionSvgFileHtml.set(newSubmissionclone.svgFileHtml);
                // var submissioninsideFileHTML = await that.dbService.database.ref('/submissions/' + id + '/insideFileHTML');

                // if (newSubmissionclone.insideFileHTML)
                //     await submissioninsideFileHTML.set(newSubmissionclone.insideFileHTML);
                // var counter = 0;
                // var paramString = ""
                // return;,

            } catch (error) {
                console.log(error);
            }

        } else {
            try {
                var newSubmissionclone = JSON.parse(JSON.stringify(newSubmission));
                var submissionclone = JSON.parse(JSON.stringify(newSubmission));
                this.loading = true;
                await this.submissionService.saveSubmissionData(submissionclone).subscribe(res => {
                    this.submissionFlag = true;
                    console.log("submisson id is ,",res.json());
                    //API For TopSize and BottomSize
                    var counter = 0;
                    var paramString = "";
                    if (!savelaterFlag) {
                        for (var i in mainArr) {
                            let body = {
                                "quantity": mainArr[i].quantity,
                                "id": mainArr[i].id,
                            }
                            paramString = paramString + body.id + ":" + body.quantity + ",";
                            const me = this;
                            this.http.post('https://uniform-e640f.appspot.com/addcart.php',
                                JSON.stringify(body), {}).subscribe(
                                    res => {
                                        counter++;
                                        if (counter == mainArr.length) {
                                            setTimeout(function () {
                                                me.submissionFlag = false;
                                                me.players = [new PlayerObj(null, null, null, null)];
                                                me.showMessage(savelaterFlag, submitJersey, id, undefined);
                                                me.loading = false;
                                            }, 250);
                                        }
                                    }
                                );
                        }
                    } else {
                        this.showMessage(savelaterFlag, submitJersey, id, undefined);
                        this.loading = false;
                    }
                    if (submitJersey.userRole) {
                        if (submitJersey.userRole == 'customer') {
                            this.router.navigate(['/locker-room/submissions'], { queryParams: { lastsubmission:  res.json().submissionId} });
                            // this.router.navigate(['/locker-room/submissions']);
                        } else if (submitJersey.userRole == 'admin') {
                            this.router.navigate(['/admin/submissions']);
                        }
                    }
                   
                });

                // await submissionList.set(submissionclone);
                // Alim to Vishal, 6/28 - Dont save submission svg data in /submissions table
                // Save in /submissions-svg-data and create foriegn key to /submissions object
                // var submissionbase64_OutSide = await that.dbService.database.ref('/submissions  /' + id.trim() + '/base64_OutSide')
                // this.dbService.object('/submissions/' + id + '/base64_OutSide');
                // if (newSubmissionclone.base64_OutSide)
                //     await submissionbase64_OutSide.set(newSubmissionclone.base64_OutSide);
                // var submissionSvgFileHtml = await that.dbService.database.ref('/submissions/' + id + '/svgFileHtml')
                // if (newSubmissionclone.svgFileHtml)
                //     await submissionSvgFileHtml.set(newSubmissionclone.svgFileHtml);
                // var submissioninsideFileHTML = await that.dbService.database.ref('/submissions/' + id + '/insideFileHTML');

                // if (newSubmissionclone.insideFileHTML)
                //     await submissioninsideFileHTML.set(newSubmissionclone.insideFileHTML);
                // var counter = 0;
                // var paramString = ""
                // return;,

            } catch (error) {
                console.log(error);
            }
            // return;,
            // this.submissionFlag = true;
            //API For TopSize and BottomSize
            // var counter = 0;
            // var paramString = "";
            // if (!savelaterFlag) {
            //     console.log("savelaterFlag is ##########################",savelaterFlag);
            //     for (var i in mainArr) {
            //         let body = {
            //             "quantity": mainArr[i].quantity,
            //             "id": mainArr[i].id,
            //         }
            //         paramString = paramString + body.id + ":" + body.quantity + ",";
            //         const me = this;
            //         this.http.post('https://uniform-e640f.appspot.com/addcart.php',
            //             JSON.stringify(body), {}).subscribe(
            //             res => {
            //                 counter++;
            //                 if (counter == mainArr.length) {
            //                     setTimeout(function () {
            //                         me.submissionFlag = false;
            //                         me.players = [new PlayerObj(null, null, null, null)];
            //                         me.showMessage(savelaterFlag, submitJersey, id, undefined);
            //                         me.loading = false;
            // me.startLoadingSpinner();
            //                     }, 250);
            //                 }
            //             }
            //             );
            //     }
            // } else {
            //     console.log("savelaterFlag is ############!!!!!!!!!!!#############",savelaterFlag);
            //     this.showMessage(savelaterFlag, submitJersey, id, undefined);
            //     this.loading = false;
            // this.startLoadingSpinner();
            // }
        }

    }
    ///////////////////////////////////////////////////////////
    setTextElementHeight(pId) {
        this.graphicElementsHeight = [];
        var nameFront = $(pId + "#Name-Front").attr("height");
        var w = $(pId + "#Name-Front").attr("width");
        $(pId + "#Name-Front-p").css("height", nameFront);
        var obj = {
            'Name-Front-p': nameFront
        };
        this.graphicElementsHeight.push(obj);

        // nameFront = $("#Name-Back").css("height");
        nameFront = $(pId + "#Name-Back").attr("height");
        w = $(pId + "#Name-Back").attr("width");
        $(pId + "#Name-Back-p").css("height", nameFront);
        var obj2 = {
            'Name-Back-p': nameFront
        };
        this.graphicElementsHeight.push(obj2);

        // nameFront = $("#Number-Front").css("height");
        nameFront = $(pId + "#Number-Front-p").attr("height");
        var fNfont = $(pId + "#Number-Front-p").css("font-size");
        w = $(pId + "#Number-Front-p").attr("width");
        if (parseInt(nameFront) < 80) {
            // nameFront = 90;
        }
        $(pId + "#Number-Front-p").css("height", nameFront);
        $(pId + "#Number-Front").css("height", nameFront);
        $(pId + "#Number-Front").css("width", w);
        var obj3 = {
            'Number-Front-p': nameFront
        };
        this.graphicElementsHeight.push(obj3);

        // nameFront = $("#Number-Back").css("height");
        nameFront = $(pId + "#Number-Back-p").attr("height");
        w = $(pId + "#Number-Back-p").attr("width");
        if (parseInt(nameFront) < 80) {
            nameFront = 90;
        }
        $(pId + "#Number-Back-p").css("height", nameFront);
        $(pId + "#Number-Back").css("height", nameFront);
        $(pId + "#Number-Back").css("width", w);
        var obj4 = {
            'Number-Back-p': nameFront
        };
        this.graphicElementsHeight.push(obj4);
    }
    // Set Inline Styles method
    setInlineStyles(svg) {
        var that = this;

        function explicitlySetStyle(element) {
            var cSSStyleDeclarationComputed = getComputedStyle(element);
            var i, len, key, value;
            var svgExcludedValues = ['height', 'width', 'min-height', 'min-width'];
            var computedStyleStr = "";
            for (i = 0, len = cSSStyleDeclarationComputed.length; i < len; i++) {
                key = cSSStyleDeclarationComputed[i];
                if (!((element instanceof SVGElement) && svgExcludedValues.indexOf(key) >= 0)) {
                    value = cSSStyleDeclarationComputed.getPropertyValue(key);
                    computedStyleStr += key + ":" + value + ";";
                }
            }
            var sty = '';
            for (var j in that.graphicElementsHeight) {
                if (that.graphicElementsHeight[j][element.id]) {
                    sty = "height: " + that.graphicElementsHeight[j][element.id];
                    break;
                }
            }
            computedStyleStr = computedStyleStr + sty;
            element.setAttribute('style', computedStyleStr);
        }

        function traverse(obj) {
            var tree = [];
            tree.push(obj);
            visit(obj);

            function visit(node) {
                if (node && node.hasChildNodes()) {
                    var child = node.firstChild;
                    while (child) {
                        if (child.nodeType === 1 && child.nodeName != 'SCRIPT') {
                            tree.push(child);
                            visit(child);
                        }
                        child = child.nextSibling;
                    }
                }
            }
            return tree;
        }
        // hardcode computed css styles inside SVG
        var allElements = traverse(svg);
        var i = allElements.length;
        while (i--) {
            explicitlySetStyle(allElements[i]);
        }
    }

    // 
    appendExternalFonts(eId) {
        var fontString = '';
        try {
            if (parseInt(document.querySelectorAll("#" + eId + " #Number-Back-p")[0].getAttribute("height")) < 100) {
                document.querySelectorAll("#" + eId + " #Number-Back-p")[0].setAttribute("height", "100");
            }
            console.log(this.ExtFontList);
            if (this.ExtFontList && this.ExtFontList.length == 0) {
                this.getAllExtFonts();
            }
            var t = document.querySelectorAll("#" + eId)[0].outerHTML;

            for (var i in this.ExtFontList) {
                if (t.includes(Object.keys(this.ExtFontList[i])[0])) {
                    fontString = fontString + ' ' + Object["values"](this.ExtFontList[i])[0];
                }
            }
        } catch (error) {
        }
        if (eId == "svg") {
            if (document.getElementById("extstyle") == null || !document.getElementById("extstyle")) {
                var s = document.createElement("style");
                s.id = "extstyle";
                s.innerHTML = fontString;
                // if(document.querySelectorAll("#" + eId)[0])
                document.querySelectorAll("#" + eId)[0].appendChild(s);
            }
        } else {
            if (document.getElementById("extIstyle") == null || !document.getElementById("extIstyle")) {
                var s = document.createElement("style");
                s.id = "extIstyle";
                s.innerHTML = fontString;
                // if(document.querySelectorAll("#" + eId)[0])
                document.querySelectorAll("#" + eId)[0].appendChild(s);
            }
        }
    }

    getAllExtFonts() {
        this.ExtFontList = [];
        var CollegeBlock2 = '@font-face {font-family: CollegeBlock2-0;src: url(\'data:font/truetype;charset=utf-8;base64,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\') format(\'truetype\');}';

        this.ExtFontList.push({ CollegeBlock2: CollegeBlock2 });

        // var dadefont = '@font-face {font-family: CollegeBlock2-0;src: url(\'data:font/truetype;charset=utf-8;base64,\')'
        var dadefont = '@font-face {font-family: dade-webfont;src: url(\'data:font/woff2;charset=utf-8;base64,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\');}';
        this.ExtFontList.push({ 'dade-webfont': dadefont });

        var full_block_webfont = '@font-face {font-family: full_block-webfont;src: url(\'data:font/truetype;charset=utf-8;base64,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\');}';
        this.ExtFontList.push({ 'full_block-webfont': full_block_webfont });

        var golden_bear_webfont = '@font-face {font-family: golden_bear-webfont;src: url(\'data:font/truetype;charset=utf-8;base64,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\');}'
        this.ExtFontList.push({ 'golden_bear-webfont': golden_bear_webfont });

        var horned_frogs_webfont = '@font-face {font-family: horned_frogs-webfont;src: url(\'data:font/truetype;charset=utf-8;base64,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\');}'
        this.ExtFontList.push({ 'horned_frogs-webfont': horned_frogs_webfont });

        var Huskies = '@font-face {font-family: huskie-webfont;src: url(\'data:font/truetype;charset=utf-8;base64,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\');}'
        this.ExtFontList.push({ 'huskie-webfont': Huskies });

        var kights_webfont = '@font-face {font-family: kights-webfont;src: url(\'data:font/truetype;charset=utf-8;base64,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\');}'
        this.ExtFontList.push({ 'kights-webfont': kights_webfont });

        var lubbock_webfont = '@font-face {font-family: lubbock-webfont;src: url(\'data:font/truetype;charset=utf-8;base64,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\')'
        this.ExtFontList.push({ 'lubbock-webfont': lubbock_webfont });

        // console.log(this.ExtFontList);

    }


    // ======================================

    async showMessage(savelaterFlag, submitJersey, id, reurl) {
        if (this.uploadFileFlag) {
            try {
                if (this.resubmittedDesign) {
                    let submissionList = await this.dbService.object(`/revision/${this.designId}`);
                    let id = "UL-R-1"
                    if (this.lastRevisions && this.lastRevisions.length > 0) {
                        let temp = +this.lastRevisions[0].split('UL-R-')[1];
                        id = "UL-R-" + (temp + 1);
                    }
                    this.resubmittedDesign['resubmitDate'] = new Date().getTime();
                    var revision = await this.dbService.object(`/revision/${this.designId}/${id}`);
                    await revision.set(this.resubmittedDesign);
                }
            }
            catch (error) {
                this.toastr.error("Internal Server error", '', { timeOut: 10000, positionClass: 'toast-top-right' });
                window.location.href = 'https://str8sports.uniformlab.net/';
            }
            this.submitFlag = undefined;
            this.finalizeBtnFlag = false;
            this.emailAddress = submitJersey.email;
            this.emailAddress2 = "admin@gmail.com";
            this.message = "Thank you for submitting a Uniform to UniformLab";
            this.message2 = "A user submitted a uniform to uniform lab. View the submission by going to- \"uniformlab.net/admin/submission-detail/" + id;

            const loginAftersubmit = this;
            var alertMsg = '<div><span style="color: #000;">Thank you. Please check your email for a link to finish your custom uniform order. If you have any questions, click here to contact us.</span><br><a href="https://str8sports.com/pages/contact">https://str8sports.com/pages/contact</a></div>';
            if (savelaterFlag) {
                this.alertService.thankYouMsg(alertMsg, function () {
                    // console.log("console is %%%%%%%%%%");
                    // loginAftersubmit.signInForUpload('submission');
                    
                    // window.localStorage.setItem('emailForSignIn', loginAftersubmit.emailAddress);
                    // window.localStorage.setItem('userrole', 'User');
                    // loginAftersubmit.router.navigate(['/locker-room/submissions'], { queryParams: { lastsubmission:  loginAftersubmit.submissonId} });
                    // window.location.href = 'https://str8sports.uniformlab.net/';
                });
            } else {
                var msg = '<div><font size="5">Thank you.</font></div>';
                this.alertService.thankYouMsg(msg, function () {
                    window.location.href = 'https://str8sports.uniformlab.net/';
                });

            }
        } else {
            this.toastr.error('Failed to upload file', '', { timeOut: 10000, positionClass: 'toast-top-right' });
            if (this.resubmittedDesign)
                window.history.back();
            else
                window.location.href = 'https://str8sports.uniformlab.net/';
        }

    }

    /*------------------------Text Functions Right Panel------------------------*/

    private selectedTextType: string;
    setTeamNameActive() {
        this.selectedTextType = "Team Name";
        this.canvas.setActiveObject(this.canvas.item(1)); //got team name
    }
    setPlayerNumberFrontActive() {
        this.selectedTextType = "Player Name Front";
        this.canvas.setActiveObject(this.canvas.item(2)); //got team name
    }
    updateSelectedText(props) {
    }


    //Build another uniform clicked
    buildAnother() {
        /*
            setTimeout(2200, function(){
              location.reload();
            })
          */
    }

    /*------------------------Load uniform by submission ID------------------------*/

    // private uniformFromID: AngularFireList < any > ;

    loadFromID(id: string) {

        this.id_Load_From = id;
        this.load_FromID = true;

        let key = id;
        // this.dbService.object(`/submissions/${key}`).subscribe(sub => {

        //     if (sub.$value !== null) {
        //         if (sub.json_InSide) {
        //             this.obj_Inside = JSON.parse(sub.json_InSide);
        //             this.reversible = true;
        //         } else {
        //             this.reversible = false;
        //             this.obj_Outside = JSON.parse(sub.json_OutSide);
        //         }
        //         var canvas = document.getElementsByClassName('upper-canvas ');
        //         var ctx = this.canvas.getContext("2d");
        //         ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        //         if (this.selected_slide === 1)
        //             this.canvas.loadFromJSON(this.obj_Outside, this.canvas.renderAll.bind(canvas));
        //         else
        //             this.canvas.loadFromJSON(this.obj_Inside, this.canvas.renderAll.bind(canvas));

        //     } else {
        //         alert("No uniform style was returned with that ID");
        //     }
        // });

    }

    /*------------------------Block elements------------------------*/

    //Block "Size"

    changeSize(event: any) {
        this.canvas.setWidth(this.size.width);
        this.canvas.setHeight(this.size.height);
    }

    //Block "Add text"

    addText() {
        let textString = this.textString;
        let text = new fabric.IText(textString, {
            left: 200,
            top: 200,
            fontFamily: 'arial',
            angle: 0,
            fill: '#000000',
            fontWeight: '',
            hasRotatingPoint: true
        });
        this.extend(text, this.randomId());
        this.canvas.add(text);
        text.setCoords();
        this.canvas.calcOffset();
        this.textString = '';
        this.canvas.renderAll();
    }

    //adds text onto the canvas given a location & text string
    addCanvasText(canvas, viewid, text, tops, left) {


        //check what type of jersey before adding text
        if (this.selectedSport == "Basketball") {
            var top = canvas.item(0).top;
            top = top - (top / tops) + 20;
            var fSize = 18;
        }
        var sport = this.selectedSport;
        if (this.selectedSport == "Football") {
            top = canvas.item(0).top;
            top = top - 90;
            fSize = 25;
            if (viewid == "BackView") {
                top = top - 35;
                fSize = 30;
            }
        }

        text = new fabric.IText(text, {
            id: "uniform-text",
            left: left,
            top: top,
            fontFamily: 'full_block-webfont',
            angle: 0,
            fill: '#000000',
            originX: 'center',
            originY: 'center',
            fontSize: fSize,
            sport: sport,
            hasRotatingPoint: true,
            view: viewid
        });
        canvas.add(text);
        canvas.renderAll();
    }

    //Add jersey to canvas : Initial Logo Display
    setupWelcomeCanvas(w, h) {

        let el = "/assets/img/STR8LOGO.png";
        fabric.Image.fromURL(el, (image) => {
            image.set({
                left: w / 2 - 160,
                top: h / 2 - 150,
                angle: 0,
                padding: 0,
                cornersize: 10,
                hasRotatingPoint: false,
                selected: false,
                peloas: 12,
                lockMovementX: true,
                lockMovementY: true,
                selectable: false
            });
            image.setWidth(300);
            image.setHeight(200);
            this.extend(image, this.randomId());
            this.canvas.add(image);
            var text = new fabric.IText("Choose a uniform to begin.", {
                id: "uniform-text",
                left: w / 2,
                top: h / 2 + 100,
                fontFamily: 'full_block-webfont',
                angle: 0,
                fill: '#000000',
                originX: 'center',
                originY: 'center',
                fontSize: 36,
                hasRotatingPoint: true,
            });
            this.canvas.add(text);
        });
    }

    //Updates Canvas with Default Font.
    update_defaultfont() {
        let color = "";
        let layerid;
        let cobject;
        if (this.selected_slide === 1) {
            if (this.layerColorApplied_OutSide.length != 0) { //update canvas object with Colors Applied to Outside- required to update when Toggle Inside and Outside
                color = this.layerColorApplied_OutSide[0].colorCode;
                for (var i = 0; i < this.layerColorApplied_OutSide.length; i++) {
                    if (this.layerColorApplied_OutSide[i].colorCode != "") {
                        layerid = this.layerColorApplied_OutSide[i].layer;
                        cobject = this.canvas._objects[0];
                        for (var j = 0; j < cobject.paths.length; j++) {
                            if (cobject.paths[j].id == layerid) {
                                this.canvas._objects[0].paths[j].setFill(this.layerColorApplied_OutSide[i].colorCode);
                                this.canvas._objects[0].paths[j].set("colorName", this.layerColorApplied_OutSide[i].colorName);
                            }
                        }
                    }
                    if (this.layerColorApplied_OutSide[i].fontStroke != "") {
                        layerid = this.layerColorApplied_OutSide[i].layer;
                        cobject = this.canvas._objects[0];
                        for (var j = 0; j < cobject.paths.length; j++) {
                            if (cobject.paths[j].id == layerid) {
                                this.canvas._objects[0].paths[j].set('stroke', this.layerColorApplied_OutSide[i].fontStroke);
                                this.canvas._objects[0].paths[j].set('fontStrokeColorName', this.layerColorApplied_OutSide[i].fontStrokeColorName);
                            }
                        }
                    }
                }
            }
        } else {
            if (this.layerColorApplied_InSide.length != 0) { //update canvas object with Colors Applied to Inside- required to update when Toggle Inside and Outside
                color = this.layerColorApplied_InSide[0].colorCode;
                for (var i = 0; i < this.layerColorApplied_InSide.length; i++) {
                    if (this.layerColorApplied_InSide[i].colorCode != "") {
                        layerid = this.layerColorApplied_InSide[i].layer;
                        cobject = this.canvas._objects[0];
                        for (var j = 0; j < cobject.paths.length; j++) {
                            if (cobject.paths[j].id == layerid) {
                                this.canvas._objects[0].paths[j].setFill(this.layerColorApplied_InSide[i].colorCode);
                                this.canvas._objects[0].paths[j].set("colorName", this.layerColorApplied_InSide[i].colorName);
                            }
                        }
                    }
                    if (this.layerColorApplied_InSide[i].fontStroke != "") {
                        layerid = this.layerColorApplied_InSide[i].layer;
                        cobject = this.canvas._objects[0];
                        for (var j = 0; j < cobject.paths.length; j++) {
                            if (cobject.paths[j].id == layerid) {
                                this.canvas._objects[0].paths[j].set('stroke', this.layerColorApplied_InSide[i].fontStroke);
                                this.canvas._objects[0].paths[j].set('fontStrokeColorName', this.layerColorApplied_InSide[i].fontStrokeColorName);
                            }
                        }
                    }
                }
            }
        }

        if (color == "" || color === undefined) {
            if (this.selected_slide === 1) {
                if (this.actualColorofLayer_OutSide.length > 0)
                    color = this.actualColorofLayer_OutSide[0].colorCode;
            } else {
                if (this.actualColorofLayer_InSide.length > 0) {
                    color = this.actualColorofLayer_InSide[0].colorCode;
                }
            }
        }
        var object = this.canvas._objects[0];
        if (object) {
            if (object.paths) {
                if (color === "") {
                    color = object.paths[0].fill;
                }
                for (var i = 0; i < object.paths.length; i++) {
                    if (!this.reEditFlag) {

                        if (object.paths[i].id === "Name-Below-Front" || object.paths[i].id === "Name-Front" || object.paths[i].id === "Name-Back" || object.paths[i].id == "Number-Back" || object.paths[i].id === "Number-Front" || object.paths[i].id === "Front-Number-2") {
                            this.canvas._objects[0].paths[i].fontFamily = "CollegeBlock2-0";
                        }
                    } else {
                    }
                }

                if (this.selected_slide === 1)
                    this.applyText_Props_OnToggle(this.graphic_Data_Outside);
                else
                    this.applyText_Props_OnToggle(this.graphic_Data_Inside);

                object.paths[0].setFill(color);
                this.canvas.renderAll();
            }
        }

        this.addLogoOnFrontChest();
        this.addLogoOnBackUpper();
        this.addLogoOnShortLeg();
        if (this.graphicOption) {
            this.graphicOption.setDefaultValues();
        }

    }

    //Apply Text - Font Type, Size in Graphic options
    applyText_Props_OnToggle(side: IGraphic) {
        if (side.Back_FontSize != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("BackNumber", "Fontsize", side.Back_FontSize));
        if (side.Front_FontSize != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("FrontNumber", "Fontsize", side.Front_FontSize));
        if (side.Numbers_FontType != "")
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Numbers", "Fonttype", side.Numbers_FontType));
        if (side.Player_FontSize != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Player", "Fontsize", side.Player_FontSize));
        if (side.Player_FontType != "")
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Player", "Fonttype", side.Player_FontType));
        if (side.Player_Name != "")
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Player", "Name", side.Player_Name));
        if (side.Team_FontSize != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Team", "Fontsize", side.Team_FontSize));
        if (side.Team_FontType != "")
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Team", "Fonttype", side.Team_FontType));
        if (side.Team_Name != "")
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Team", "Name", side.Team_Name));
        //if(side.Team_FontStroke !="")
        // this.updateCanvasWithTeamName(new TexttoCanvasObj("Team","FontStroke", side.Team_FontStroke));
        //if(side.Player_FontStroke !="")
        //this.updateCanvasWithTeamName(new TexttoCanvasObj("Player","FontStroke", side.Player_FontStroke));
        //if(side.Numbers_FontStroke !="")
        //this.updateCanvasWithTeamName(new TexttoCanvasObj("Numbers","FontStroke", side.Numbers_FontStroke));
        if (side.Team_Left != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Team", "Left", side.Team_Left));
        if (side.Team_Top != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Team", "Top", side.Team_Top));
        if (side.Player_Left != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Player", "Left", side.Player_Left));
        if (side.Player_Top != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("Player", "Top", side.Player_Top));
        if (side.Front_Left != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("FrontNumber", "Left", side.Front_Left));
        if (side.Front_Top != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("FrontNumber", "Top", side.Front_Top));
        if (side.Back_Left != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("BackNumber", "Left", side.Back_Left));
        if (side.Back_Top != 0)
            this.updateCanvasWithTeamName(new TexttoCanvasObj("BackNumber", "Top", side.Back_Top));
        if (side.Front_Number != "") {
            this.updateCanvasWithTeamName(new TexttoCanvasObj("FrontNumber", "Text", side.Front_Number));
        }
        if (side.Back_Number != "")
            this.updateCanvasWithTeamName(new TexttoCanvasObj("BackNumber", "Text", side.Back_Number));
    }

    addColor(id) {
        document.getElementById(id).style.fill = "#" + ((1 << 24) * Math.random() | 0).toString(16);
    }



    // Add Jersey Svg
    //////<-------------------------------------------show svg image in main view-------------------->    
    addSnapSvgJersey(event: any, src: any, flag: any) {
        // alert("Adding jersey")
        let me = this;
        this.snapSvg.clear();
        if (this.selectedJersycut) {
            if (!src) {
                src = event.target.getAttribute('svgsrc');
            }
        }
        let can = this.canvas;
        let that = this;
        this.selectedId;
        if (event) {
            this.selectedId = event.target.id;
            // Bind Layer on Every click of View
            if (this.selectedJersycut) {
                this.editableLayers = this.getEditableLayers(this.selectedJersycut);
            }
        }

        let el;
        if (src) {
            el = src;
        } else {
            el = event.target.getAttribute('svgsrc');
        }
        var snapSvg = Snap("#svg");

        (function () {

            Snap.plugin(function (Snap, Element, Paper, global) {

                Element.prototype.altDrag = function () {
                    this.drag(dragMove, dragStart, dragEnd);
                    return this;
                }

                var dragStart = function (x, y, ev) {
                    this.data('ot', this.transform().local);
                }


                var dragMove = function (dx, dy, ev, x, y) {
                    var tdx, tdy;
                    var snapInvMatrix = this.transform().diffMatrix.invert();
                    snapInvMatrix.e = snapInvMatrix.f = 0;
                    tdx = snapInvMatrix.x(dx, dy);
                    tdy = snapInvMatrix.y(dx, dy);
                    this.transform("t" + [tdx, tdy] + this.data('ot'));
                    this.node.style.cssText = 'cursor: move; border: 2px dotted;';
                }

                var dragEnd = function () {
                    this.node.style.cssText = 'cursor: move;';
                }

            });
        })();

        var foreignObject = '';
        let submittedDesign = this.submittedDesign;

        var tux = Snap.load(el, function (loadedFragment) {
            snapSvg.append(loadedFragment);
            var txts = document.getElementsByTagName("text");

            for (var i in txts) {
                if (that.reEditFlag && that.submittedDesign) {
                    var arr1 = [], arr2 = [];
                    if (that.submittedDesign.data.LayerColors_OutSide) {
                        arr1 = that.submittedDesign.data.LayerColors_OutSide.filter(function (d) {
                            return d.layer == txts[i].id;
                        });
                    } else if (that.submittedDesign.data.LayerColors_InSide) {
                        arr1 = that.submittedDesign.data.LayerColors_InSide.filter(function (d) {
                            return d.layer == txts[i].id;
                        });
                    }

                    if (arr1[0]) {
                        that.setDefaultElements(arr1[0]);
                    }
                } else if (txts[i].style && txts[i].style.fontFamily == "" && !this.reEditFlag) {
                    var cssText = "";
                    try {
                        cssText = loadedFragment.paper.select("#" + txts[i].id + "").node.style.cssText;
                    } catch (error) {
                        console.log(error)
                    }
                    // loadedFragment.paper.select("#" + txts[i].id + "").attr({
                    //     style: cssText + 'font-family: \'CollegeBlock2-0\', sans-serif;color: #2b2d2f;'
                    // });
                }
            }

            var rects = ['Name-Front', 'Name-Back', 'Number-Back', 'Number-Front', 'Name-Below-Front', 'Front-Number-2'];
            var deafultValues;
            if (localStorage.getItem('category') == 'Basketball') {
                deafultValues = ["Team Name", "Last Name", "23", "23", "Team Name", "23"];
            }
            else if (localStorage.getItem('category') == 'Football') {
                deafultValues = ["Team Name", "Last Name", "88", "88", "Team Name", "88"];
            } else {
                deafultValues = ["Team Name", "Last Name", "22", "22", "Team Name", "22"];
            }

            for (var i in rects) {
                if (rects[i] != "" && loadedFragment.paper.select("#" + rects[i] + "")) {
                    var rect = loadedFragment.paper.select("#" + rects[i] + "").node;
                    try {
                        var w = rect.getAttribute("width");
                        var h = rect.getAttribute("height");
                        var x = rect.getAttribute("x");
                        if (rects[i] == 'Number-Back' && w < 90) {
                            var d = (90 - w) / 2;
                            w = 90;
                            x = x - d;
                        }
                        if (h <= 20) {
                            h = 20;
                        }
                        let zindex = 0;
                        let verticalAlignment = `vertical-align: middle;`;
                        if (rect.id == 'Name-Back' || rect.id == 'Name-Front') {
                            zindex = 9999;
                            verticalAlignment = `vertical-align: top;`;
                        }

                        let style = `style="z-index:${zindex}"`;
                        let fontSize = FONT_SIZE[localStorage.getItem('category')];
                        if (fontSize) {
                        } else {
                            fontSize = FONT_SIZE['DeafultValues'];
                        }

                        if (localStorage.getItem('category') == 'Football') {
                            if (rect.id == 'Number-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.backNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Number-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.frontNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Name-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.teamName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else if (rect.id == 'Name-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.playerName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else if (rect.id == 'Name-Below-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                              <div id="' + rect.id + '" class="text-element" style="display:none;height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                               </foreignObject>';
                            } else if (rect.id == 'Front-Number-2') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;display:none;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                             </foreignObject>';
                            } else {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                            <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                            </foreignObject>';
                            }
                        } else {
                            if (rect.id == 'Name-Below-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                            <div id="' + rect.id + '" class="text-element" style="display:none;height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px; z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                        </foreignObject>';
                            } else if (rect.id == 'Front-Number-2') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                        <div id="' + rect.id + '" class="text-element" style="height: 100%;display:none;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                    </foreignObject>';
                            } else if (rect.id == 'Number-Back') {

                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.backNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Number-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.frontNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Name-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.teamName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else if (rect.id == 'Name-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.playerName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else {

                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                        <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                    </foreignObject>';
                            }
                        }

                        if (rect.id)
                            if (that.isSafari) {

                                var c = loadedFragment.paper.select("#" + rects[i] + "").node.parentNode.innerHTML;
                                loadedFragment.paper.select("#" + rects[i] + "").node.parentNode.innerHTML = c + foreignObject;
                                document.querySelectorAll("#" + rects[i])[0].remove();
                            } else {
                                loadedFragment.paper.select("#" + rects[i] + "").node.outerHTML = foreignObject;
                            }
                    } catch (error) {
                        console.log(error)
                    }
                }
            }
            // me.editableLayers = me.getEditableLayers(me.selectedJersycut);
            // if (localStorage.getItem('category') == 'Football') {
            //     document.getElementById('Number-Front').style.fontSize = "80px";
            //     document.getElementById('Number-Back').style.fontSize = "80px";
            // }
            // document.getElementById("Layer_1").innerHTML = document.getElementById("Layer_1").innerHTML +
            // `<foreignObject id="Name-Below-Front-p" xmlns="http://www.w3.org/2000/svg" x="88" y="180" class="st5" width="86.5" height="20" style="cursor: move;overflow: visible;"><div id="Name-Below-Front" class="text-element" style="'+verticalAlignment+' width: 86.5px; height: 20px;"></div> </foreignObject>
            // <foreignObject id="Name-Below-Back-p" xmlns="http://www.w3.org/2000/svg" x="478.2" y="180" class="st5" width="78.1" height="20" style="cursor: move; overflow: visible;"> <div id="Name-Below-Back" class="text-element" style="height: 100%;'+verticalAlignment+'width:78.1px; height:20px;"></div>                    </foreignObject>
            // `
            console.log("this.submittedDesign",submittedDesign);
            if (submittedDesign && submittedDesign.data.svgFileHtml) {
                try {
                    if (that.isSafari){
                        // $(loadedFragment.paper.select("svg").node).replaceWith(submittedDesign.svgFileHtml);
                        var c = loadedFragment.paper.select("svg").node.parentNode.innerHTML;
                        loadedFragment.paper.select("svg").node.parentNode.innerHTML = c + submittedDesign.data.svgFileHtml;
                    } else {
                        loadedFragment.paper.select("svg").node.outerHTML = submittedDesign.data.svgFileHtml;
                    }
                    for (var i in rects) {
                        if (loadedFragment.paper.select("#" + rects[i] + "")) {
                            var cssText = "";
                            var rect = loadedFragment.paper.select("#" + rects[i] + "-p").node;
                            var w = rect.getAttribute("width");
                            var h = rect.getAttribute("height");
                            if (h <= 20) {
                                h = 20;
                            }
                            let verticalAlignment = `vertical-align: middle;`;
                            if (rect.id == 'Name-Back' || rect.id == 'Name-Front') {
                                verticalAlignment = `vertical-align: top;`;
                            }
                            var t = loadedFragment.paper.select("#" + rects[i] + "").node.style.cssText;
                            // cssText = t + 'display: table-cell;'+verticalAlignment+'width:' + w + 'px; height:' + h + 'px;';
                            cssText = t + '' + verticalAlignment + 'width:' + w + 'px; height:' + h + 'px;';
                            var rec = loadedFragment.paper.select("#" + rects[i] + "");
                            rec.attr({
                                style: cssText + 'cursor: move;'
                            });
                        }
                    }

                    // 
                    setTimeout(() => {
                        txts = loadedFragment.paper.selectAll(".text-element")['items'];
                        for (var i in txts) {
                            var id = txts[i]['node'].id;
                            var arr1 = [], arr2 = [];
                            if (that.submittedDesign.data.LayerColors_OutSide) {
                                arr1 = that.submittedDesign.data.LayerColors_OutSide.filter(function (d) {
                                    return d.layer == id;
                                });
                            } else if (that.submittedDesign.data.LayerColors_InSide) {
                                arr1 = that.submittedDesign.data.LayerColors_InSide.filter(function (d) {
                                    return d.layer == id;
                                });
                            }
                            if (arr1[0]) {
                                that.setDefaultElements(arr1[0]);
                            }
                        }
                        that.setDefaultLogos();
                    }, 100);


                } catch (error) {
                }
            }

            try {
                loadedFragment.paper.select("#Name-Below-Front-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                loadedFragment.paper.select("#Name-Front-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                loadedFragment.paper.select("#Name-Back-p").attr({
                    style: 'cursor: move; overflow: visible;'
                }).altDrag();
                // loadedFragment.paper.select("#Name-Below-Back-p").attr({
                //     style: 'cursor: move; overflow: visible;'
                // }).altDrag();
                loadedFragment.paper.select("#Number-Front-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                loadedFragment.paper.select("#Number-Back-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
            } catch (error) { }

            // logo rect to image
            var allRectsvgElements = loadedFragment.paper.selectAll("rect");
            if (allRectsvgElements && allRectsvgElements.length > 0) {
                for (var i in allRectsvgElements) {
                    if (allRectsvgElements[i] && allRectsvgElements[i].id) {
                        if (that.isSafari) {
                            // $(allRectsvgElements[i].node).replaceWith(allRectsvgElements[i].node.outerHTML.replace("rect", "image"));                    
                            var c = allRectsvgElements[i].node.parentNode.innerHTML;
                            // allRectsvgElements[i].node.parentNode.innerHTML = c + allRectsvgElements[i].node.outerHTML.replace("rect", "image");
                            if(allRectsvgElements[i].node.getAttribute('id')=='Chest-Logo'){
                                // var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // </object></foreignObject>';
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                </object></foreignObject>';
                                }else{
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" prevx="' + allRectsvgElements[i].node.getAttribute('x') + '" prevy="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '"  prevwidth="' + allRectsvgElements[i].node.getAttribute('width') + '" prevheight="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                </object></foreignObject>';
                                }
                                allRectsvgElements[i].node.parentNode.innerHTML = c + foreignObject;
                        } else {
                            // allRectsvgElements[i].node.outerHTML = allRectsvgElements[i].node.outerHTML.replace("rect", "image");
                            if(allRectsvgElements[i].node.getAttribute('id')=='Chest-Logo'){
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                <object type="image/png" style="display:none" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                </object></foreignObject>';
                                // var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '"  prevx="' + allRectsvgElements[i].node.getAttribute('x') + '" prevy="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // </object></foreignObject>';
                                }else{
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '"  prevx="' + allRectsvgElements[i].node.getAttribute('x') + '" prevy="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '" prevwidth="' + allRectsvgElements[i].node.getAttribute('width') + '" prevheight="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                </object></foreignObject>';
                                
                                }
                                allRectsvgElements[i].node.outerHTML = foreignObject;
                        }
                    }
                }
            }
            try {
                if (that.selected_slide == 1) {
                    that.outsideFileHTML = loadedFragment.paper.select("svg").node.outerHTML;
                } else {
                    that.insideFileHTML = loadedFragment.paper.select("svg").node.outerHTML;
                    $("clipPath").remove();
                }
            } catch (error) {
                console.log(error);
            }
            that.getAvailbleLocations();
            if(loadedFragment.paper.select("svg").node.hasAttribute("width")){
                loadedFragment.paper.select("svg").node.removeAttribute("width");
            }
        });

        var loadedObjects = {
            paths: document.getElementsByTagName("path")
        };
        if (loadedObjects.paths) {
            for (var k = 0; k < that.svgIdColors.length; k++) {
                var id = that.svgIdColors[k].layer;
                var color = that.svgIdColors[k].colorCode;
                for (var i = 0; i < loadedObjects.paths.length; i++) {
                    if (loadedObjects.paths[i].id == id) {
                        if (color != null) {
                            loadedObjects.paths[i].style.fill = color;
                        }
                    }
                }
            }
        }

    }

    getAvailbleLocations() {
        try {
            if (document.getElementsByTagName("object").length > 0 && this.availableLogoLocations.length == 0) {
                var location = document.getElementsByTagName("object");
                if (location) {
                    for (var i = 0; i < location.length; i++) {
                        if (location[i].id) {
                            var selected = false;
                            try {
                                var sel = document.getElementById(location[i].id).getAttribute('data');
                                if (sel && sel != "") {
                                    selected = true;
                                }
                            } catch (error) {
                            }
                            var obj = {
                                id: location[i].id,
                                label: location[i].id.split("-").join(" ").split("_1_").join(" "),
                                selected: selected
                            };
                            var index = this.availableLogoLocations.findIndex(function (d) {
                                return d.id == location[i].id
                            });
                            if (index == -1) {
                                this.availableLogoLocations.push(obj);
                            }
                        }
                    }
                }
            }
        } catch (error) {
        }
    }

    // jersey color
    //Dyanmic method to color Canvas with Layer-Id passed on click event
    jerseycolorwithLayer(event, layer: LayerObj, colors: SelectedColorObj) {
        if (event) {
            let color = colors.colorCode;
            let id = layer.layerID;
            let that = this;
            var object = {
                paths: document.getElementsByTagName("path")
            };
            for (var k = 0; k < that.svgIdColors.length; k++) {
                if (that.svgIdColors[k].layer == id) {
                    that.svgIdColors[k].colorCode = color;
                }
            }
            if (object && object.paths) {
                for (var i = 0; i < object.paths.length; i++) {
                    if (object.paths[i].id == id) {
                        object.paths[i].style.fill = color;
                    }
                }
                var object = {
                    paths: document.getElementsByTagName("path")
                };
                for (var j = 0; j < that.svgIdColors.length; j++) {
                    id = that.svgIdColors[j].layer;
                    for (var i = 0; i < object.paths.length; i++) {
                        if (object.paths[i].id == id) {
                            that.svgIdColors[j].colorCode = object.paths[i].style.fill;
                        }
                    }
                }
            }
        }
    }

    //Block "Add images"

    getImgPolaroid(event: any) {
        let el = event.target;
        fabric.Image.fromURL(el.src, (image) => {
            image.set({
                left: 10,
                top: 10,
                angle: 0,
                padding: 10,
                cornersize: 10,
                hasRotatingPoint: true,
                peloas: 12
            });
            image.setWidth(150);
            image.setHeight(150);
            this.extend(image, this.randomId());
            this.canvas.add(image);
            this.selectItemAfterAdded(image);
        });
    }

    cleanSelect() {
        this.canvas.deactivateAllWithDispatch().renderAll();
    }

    selectItemAfterAdded(obj) {
        this.canvas.deactivateAllWithDispatch().renderAll();
        this.canvas.setActiveObject(obj);
    }

    setCanvasFill() {
        if (!this.props.canvasImage) {
            this.canvas.backgroundColor = this.props.canvasFill;
            this.canvas.renderAll();
        }
    }

    extend(obj, id) {
        obj.toObject = (function (toObject) {
            return function () {
                return fabric.util.object.extend(toObject.call(this), {
                    id: id
                });
            };
        })(obj.toObject);
    }


    randomId() {
        return Math.floor(Math.random() * 999999) + 1;
    }

    /*------------------------Global actions for element------------------------*/

    getActiveStyle(styleName, object) {
        object = object || this.canvas.getActiveObject();
        if (!object) return '';

        return (object.getSelectionStyles && object.isEditing) ?
            (object.getSelectionStyles()[styleName] || '') :
            (object[styleName] || '');
    }


    setActiveStyle(styleName, value, object) {
        object = object || this.canvas.getActiveObject();
        if (!object) return;

        if (object.setSelectionStyles && object.isEditing) {
            var style = {};
            style[styleName] = value;
            object.setSelectionStyles(style);
            object.setCoords();
        } else {
            object.set(styleName, value);
        }

        object.setCoords();
        this.canvas.renderAll();
    }


    getActiveProp(name) {
        var object = this.canvas.getActiveObject();
        if (!object) return '';

        return object[name] || '';
    }

    setActiveProp(name, value) {
        var object = this.canvas.getActiveObject();
        if (!object) return;
        object.set(name, value).setCoords();
        this.canvas.renderAll();
    }

    clone() {
        let activeObject = this.canvas.getActiveObject(),
            activeGroup = this.canvas.getActiveGroup();

        if (activeObject) {
            let clone;
            switch (activeObject.type) {
                case 'rect':
                    clone = new fabric.Rect(activeObject.toObject());
                    break;
                case 'circle':
                    clone = new fabric.Circle(activeObject.toObject());
                    break;
                case 'triangle':
                    clone = new fabric.Triangle(activeObject.toObject());
                    break;
                case 'i-text':
                    clone = new fabric.IText('', activeObject.toObject());
                    break;
                case 'image':
                    clone = fabric.util.object.clone(activeObject);
                    break;
            }
            if (clone) {
                clone.set({
                    left: 10,
                    top: 10
                });
                this.canvas.add(clone);
                this.selectItemAfterAdded(clone);
            }
        }
    }

    getId() {
        this.props.id = this.canvas.getActiveObject().toObject().id;
    }

    setId() {
        let val = this.props.id;
        let complete = this.canvas.getActiveObject().toObject();
        this.canvas.getActiveObject().toObject = () => {
            complete.id = val;
            return complete;
        };
    }


    getOpacity() {
        this.props.opacity = this.getActiveStyle('opacity', null) * 100;
    }

    setOpacity() {
        this.setActiveStyle('opacity', parseInt(this.props.opacity) / 100, null);
    }

    getFill() {
        this.props.fill = this.getActiveStyle('fill', null);
    }

    setFill() {
        this.setActiveStyle('fill', this.props.fill, null);
    }

    getLineHeight() {
        this.props.lineHeight = this.getActiveStyle('lineHeight', null);
    }

    setLineHeight() {
        this.setActiveStyle('lineHeight', parseFloat(this.props.lineHeight), null);
    }

    getCharSpacing() {
        this.props.charSpacing = this.getActiveStyle('charSpacing', null);
    }

    setCharSpacing() {
        this.setActiveStyle('charSpacing', this.props.charSpacing, null);
    }

    getBold() {
        this.props.fontWeight = this.getActiveStyle('fontWeight', null);
    }

    setBold() {
        this.props.fontWeight = !this.props.fontWeight;
        this.setActiveStyle('fontWeight', this.props.fontWeight ? 'bold' : '', null);
    }

    getFontStyle() {
        this.props.fontStyle = this.getActiveStyle('fontStyle', null);
    }

    setFontStyle() {
        this.props.fontStyle = !this.props.fontStyle;
        this.setActiveStyle('fontStyle', this.props.fontStyle ? 'italic' : '', null);
        this.canvas.renderAll();
    }


    getTextDecoration() {
        this.props.TextDecoration = this.getActiveStyle('textDecoration', null);
    }

    setTextDecoration(value) {
        let iclass = this.props.TextDecoration;
        if (iclass.includes(value)) {
            iclass = iclass.replace(RegExp(value, "g"), "");
        } else {
            iclass += ` ${value}`
        }
        this.props.TextDecoration = iclass;
        this.setActiveStyle('textDecoration', this.props.TextDecoration, null);
    }

    hasTextDecoration(value) {
        return this.props.TextDecoration.includes(value);
    }


    getTextAlign() {
        this.props.textAlign = this.getActiveProp('textAlign');
    }

    setTextAlign(value) {
        this.props.textAlign = value;
        this.setActiveProp('textAlign', this.props.textAlign);
    }

    getFontFamily() {
        this.props.fontFamily = this.getActiveProp('fontFamily');
    }

    setFontFamily() {
        this.setActiveProp('fontFamily', this.props.fontFamily);
        this.canvas.renderAll();
    }


    resetPanels() {
        this.textEditor = false;
        this.imageEditor = false;
        this.figureEditor = false;
    }
    public oneAtATime: boolean = true;
    public status: any = {
        isFirstOpen: true,
        isFirstDisabled: false
    };
    selectedJersy: Jersey;


    selectedspId = "";
    selectedSport = "Basketball";
    selectSport(event: any, src: any) {
        if (event) {
            this.selectedspId = event.target.parentElement.id;
        }
        this.selectedSport = event.target.parentElement.id;
        this.selectedJersyStyles = this.getSelectedJerseyStyles(this.selectedSport, this.selectedGender);
    }

    public gender: gender[] = [{
        "id": 1,
        "name": "Male"
    },
    {
        "id": 2,
        "name": "Female"
    }
    ];
    gendermodel = new gender();
    selectedGender = "male";
    getGender(gender) {
        if (gender == "1") {
            this.selectedGender = "Male";
            this.selectedJersyStyles = this.getSelectedJerseyStyles(this.selectedSport, this.selectedGender);
        }
        if (gender == "2") {
            this.selectedGender = "Female";
            this.selectedJersyStyles = this.getSelectedJerseyStyles(this.selectedSport, this.selectedGender);
        }
    }


    selectedJersyStyles: Jersey[] = [];
    stytemplates: any[];

    getSelectedJerseyStylesFromDb() {
        // this.loading1 = true;
        this.loading = true;
        // document.getElementById('blur').style.filter = "blur(8px)";
        // document.getElementById('blur').style.display= "none";
        this.dbService.list('/jersey-styles').valueChanges().subscribe(stytempla => {
            // setTimeout(() => {
                this.stytemplates = stytempla;
                console.log("this.stytemplates",this.stytemplates);
                // this.loading1 = false;
                this.loading = false;
                // document.getElementById('blur').style.filter = "";
                // document.getElementById('blur').style.display= "";
                // document.getElementById('blur1').style.display= "none";
            // }, 2000);
        });
    }

    getSelectedJerseyStyles(sport: string, gender: string): Jersey[] {
        let filJersyStyles: Jersey[] = [];
        this.stytemplates.forEach(element => {
            let curJerseyStyle: Jersey = new Jersey();
            let _category = (element.category && element.category === sport);
            let _gender = (element.gender && element.gender == gender);

            if (_category && _gender) {
                let i = 0;
                curJerseyStyle.cut_name = element.files[i].cutType;
                curJerseyStyle.img_url = element.files[i].img_url;
                curJerseyStyle.name = element.name;

                filJersyStyles.push(curJerseyStyle);
            }
        });
        return filJersyStyles;
    }

    bindCanvas() {
        this.selectedJersycut = new JerseyObj(null, null, this.selectedStyle.name, this.selectedStyle.display_Name, this.selectedStyle.img_url, null, null, null, null, null, null, null, null);
    }

    //It gets list of Cuts for selected Unioform-Style from Backend.
    getSelectedStyleCuts(jerseyStylename: Jersey): Jersey[] {
        
        this.activeThumbnill = jerseyStylename;
        try {
            if (this.selected_slide == 1) {
                this.activeOutsideCutName = jerseyStylename.cut_name;
                console.log("this.activeOutsideCutName",this.activeOutsideCutName);
            } else {
                this.activeInsideCutName = jerseyStylename.cut_name;
                console.log("this.activeInsideCutName",this.activeInsideCutName);
            }
        } catch (error) {
        }
        this.selectedStyle = jerseyStylename;
        this.selectedJersycut = jerseyStylename;

        console.log(this.selectedStyle,"this.selectedStyle");

        this.editableLayers = this.getEditableLayers(this.selectedStyle);
        this.gameDayFlag = true;
        this.homeAwayFlag = false;
        this.reversibleFlag = false;

        let selectedStyleCuts: Jersey[] = [];

        console.log("this.stytemplates",this.stytemplates);

        this.stytemplates.forEach(element => {
            let _category = (element.category && element.category === jerseyStylename.category);
            let _gender = (element.gender && element.gender === jerseyStylename.gender);
            let self = this;
            // console.log("_category",_category);
            // console.log("_gender",_gender);
            // console.log("jerseyStylename.name",jerseyStylename.name);

            if (_category && _gender && element.name === jerseyStylename.name) {
                if (element.files.length > 1) {
                    self.hasCuts = true;
                }
                if (element.reversible) {
                    this.reversible = true;
                } else {
                    this.reversible = false;
                }
                console.log("element.files",element.files);
                for (let count = 0; count < element.files.length; count++) {
                    let curJerStyle: Jersey = new JerseyObj(element.category, element.gender, element.name, element.display_Name, element.files[count].img_url, null, element.files[count].cutType, element.files[count].layoutType, element.thumbnail_url, element.sku_number, element.product_id, element.jersey_sku, element.shorts_sku);
                    console.log('curJerStyle1234',curJerStyle);
                    console.log("this.selectedUniformType",this.selectedUniformType);
                    // if (element.files[count].uniformType && this.selectedUniformType == element.files[count].uniformType) {
                    //     console.log("curJerStyle",curJerStyle);
                    //     selectedStyleCuts.push(curJerStyle);
                    // } else if (!element.files[count].uniformType && this.selectedUniformType == 'GameDay') {
                    //     console.log("curJerStyle",curJerStyle);
                    //     selectedStyleCuts.push(curJerStyle);
                    // }
                    if (element.files[count].uniformType && this.selectedUniformType == element.files[count].uniformType) {
                        selectedStyleCuts.push(curJerStyle);
                    } else if (!element.files[count].uniformType && this.selectedUniformType == 'GameDay') {
                        selectedStyleCuts.push(curJerStyle);
                    }else if(this.selectedUniformType == "GameDay"){
                        var idx = element.files.findIndex(function(d){
                            return d.uniformtype == "GameDay"
                        });
                        if(idx == -1){
                            this.selectedUniformType = element.files[0].uniformType;
                            if (element.files[count].uniformType && this.selectedUniformType == element.files[count].uniformType) {
                                selectedStyleCuts.push(curJerStyle);
                            }
                        }
                    } 
                    if (element.files[count].uniformType == 'HomeAway') {
                        this.homeAwayFlag = true;
                        this.uniformtypes.forEach(function (d) {
                            if (d.id == 'HomeAway') {
                                d.visible = true;
                            }
                        });
                    }
                    if (element.files[count].uniformType == 'Reversible') {
                        this.reversibleFlag = true;
                        this.uniformtypes.forEach(function (d) {
                            if (d.id == 'Reversible') {
                                d.visible = true;
                            }
                        });
                    }
                }
            }
        });
        return selectedStyleCuts;
    }

    selectedCutType = this.selectedCutsList[0];
    onChangeCutType(newObj: Jersey) {
        this.ddselectedCutType = newObj;
        this.selectedJersycut = this.ddselectedCutType;
        this.selectedStyle = this.ddselectedCutType;
        this.layerColorApplied_InSide;
        this.editableLayers = this.getEditableLayers(this.selectedStyle); //Get List of Layers
        this.addSnapSvgJersey('', this.selectedJersycut.img_url, false);
    }

    //Get Layers Data of Seleted View of Current Cut Tupe of Selected Jersey Style
    getEditableLayers(jerseyStylename: Jersey) {
        var inside_First: boolean = false;
        var outside_First: boolean = false;

        if (this.layerColorApplied_InSide && this.layerColorApplied_InSide.length === 0)
            inside_First = true;
        if (this.layerColorApplied_OutSide && this.layerColorApplied_OutSide.length === 0)
            outside_First = true;

        let curViewLayers: Ilayer[] = [];
        console.log("this.stytemplates !!!!!!!!!!!!",this.stytemplates);
        // this.dbService.list('/jersey-styles').valueChanges().subscribe(stytempla => {
        //         this.stytemplates = stytempla;
            
        // });
        // why the hell are we iterating again?!?!
        // just save the selected uniform as a class variable and reference it again?
        this.stytemplates.forEach(element => {

            console.log("element",element);

            let _jerseystyle = (element.name === jerseyStylename.name);
            let layerinfo: string = "Layerinfo";

            if (_jerseystyle && element.Layers) {

                var layername = jerseyStylename.cut_name + "-" + jerseyStylename.layoutType;

                var layersObj = element.Layers[layername]; // this is not referencing correctly for new Hooded Jacket


                if (layersObj) {
                    var layerlist = layersObj.Layerinfo.layerdata;
                    if (layerlist) {
                        layerlist.forEach(layer => {
                            if (layersObj.Layerinfo.CutType.includes("Outside")) {
                                var item;
                                var item2;
                                this.processlayers(layer, "Outside");
                            }
                            // this.layerColorobj = this.layerColorApplied_OutSide;
                            if (layersObj.Layerinfo.CutType.includes("Inside")) {
                                this.processlayers(layer, "Inside");
                            }
                            // this.layerColorobj = this.layerColorApplied_InSide;
                            if (layer.IsEditable) {
                                curViewLayers.push(layer);
                            }
                            if (this.selected_slide == 1) {
                                this.layerColorobj = this.layerColorApplied_OutSide;
                            } else {
                                this.layerColorobj = this.layerColorApplied_InSide;
                            }
                        });

                        return curViewLayers;
                    } else
                        return [];
                } else
                    return [];
            }
        })

        return curViewLayers;
    }

    processlayers(layer, type) {
        var item;
        var item2;
        if (this.reEditFlag && this.submittedDesign && this.submittedDesign.data.LayerColors_OutSide) {
            // item = this.submittedDesign.LayerColors_OutSide.filter(function(d){
            //     return d.layer == layer.layerID;
            // });
            if (this.layerColorApplied_OutSide.length > 0) {
                item = this.layerColorApplied_OutSide.filter(function (d) {
                    return d.layer == layer.layerID;
                });
            }
            if (!item || item.length == 0) {
                item = this.submittedDesign.data.LayerColors_OutSide.filter(function (d) {
                    return d.layer == layer.layerID;
                });
            }
        } else if (this.layerColorApplied_OutSide.length > 0) {
            item = this.layerColorApplied_OutSide.filter(function (d) {
                return d.layer == layer.layerID;
            });
        }
        if (this.reEditFlag && this.submittedDesign && this.submittedDesign.data.LayerColors_InSide) {
            // item2 = this.submittedDesign.LayerColors_InSide.filter(function(d){
            //     return d.layer == layer.layerID;
            // });
            if (this.layerColorApplied_InSide.length > 0) {
                item2 = this.layerColorApplied_InSide.filter(function (d) {
                    return d.layer == layer.layerID;
                });
            }
            if (!item2 || item2.length == 0) {
                item2 = this.submittedDesign.data.LayerColors_InSide.filter(function (d) {
                    return d.layer == layer.layerID;
                });
            }
        } else if (this.layerColorApplied_InSide.length > 0) {
            item2 = this.layerColorApplied_InSide.filter(function (d) {
                return d.layer == layer.layerID;
            });
        }
        if (type == 'Outside') {
            if (item && item.length > 0) {
                var index = this.layerColorApplied_OutSide.findIndex(function (d) {
                    return d.layer == layer.layerID;
                });
                if (index != -1) {
                    this.layerColorApplied_OutSide[index] = new SelectedColorObj(layer.layerID, item[0].colorCode, item[0].colorName, item[0].fontStroke, item[0].strokeWidth, item[0].fontStrokeColorName, item[0].fontType, item[0].fontSize, item[0].text);
                } else {
                    this.layerColorApplied_OutSide.push(new SelectedColorObj(layer.layerID, item[0].colorCode, item[0].colorName, item[0].fontStroke, item[0].strokeWidth, item[0].fontStrokeColorName, item[0].fontType, item[0].fontSize, item[0].text));
                }
                if (item[0].colorCode && item[0].colorCode != "") {
                    layer.color1 = {
                        colorCode: item[0].colorCode,
                        colorName: item[0].colorName
                    }
                }
                if (item2 && item2[0] && item2[0].colorCode && item2[0].colorCode != "") {
                    layer.color2 = {
                        colorCode: item2[0].colorCode,
                        colorName: item2[0].colorName
                    }
                }
            } else {
                this.layerColorApplied_OutSide.push(new SelectedColorObj(layer.layerID, "", "", "", "", "", "", "", ""));
            }
        } else {
            if (item2 && item2.length > 0) {
                var index = this.layerColorApplied_InSide.findIndex(function (d) {
                    return d.layer == layer.layerID;
                });
                if (index != -1) {
                    this.layerColorApplied_InSide[index] = new SelectedColorObj(layer.layerID, item2[0].colorCode, item2[0].colorName, item2[0].fontStroke, item2[0].strokeWidth, item2[0].fontStrokeColorName, item2[0].fontType, item2[0].fontSize, item2[0].text);
                } else {
                    this.layerColorApplied_InSide.push(new SelectedColorObj(layer.layerID, item2[0].colorCode, item2[0].colorName, item2[0].fontStroke, item2[0].strokeWidth, item2[0].fontStrokeColorName, item2[0].fontType, item2[0].fontSize, item2[0].text));
                }
                if (item && item[0] && item[0].colorCode && item[0].colorCode != "") {
                    layer.color1 = {
                        colorCode: item[0].colorCode,
                        colorName: item[0].colorName
                    }
                }
                if (item2[0] && item2[0].colorCode && item2[0].colorCode != "") {
                    layer.color2 = {
                        colorCode: item2[0].colorCode,
                        colorName: item2[0].colorName
                    }
                }
            } else {
                this.layerColorApplied_InSide.push(new SelectedColorObj(layer.layerID, "", "", "", "", "", "", "", ""));
            }
        }

        // 


    }

    uniformSelectHandler(event) {
        this.load_FromID = false;
        this.selectedJersycut = new JerseyObj(null, null, null, null, event.img_url, null, event.cut_name, null, null, null, null, null, null);
        this.hideAllNotBuilder();
        this.showProductIntro = true;
        this.addSnapSvgJersey('', this.selectedJersycut.img_url, false);
    }
    ////////////////////////////
    onSelectUniformtype() {
    }

    onselectSide(selection: number, event, utype) {
        this.insideFileHTMLDef = null;
        this.outsideFileHTMLDef = null;
        if (document.getElementById('Name-Below-Front'))
            this.frontbelowName = document.getElementById('Name-Below-Front');

        if (localStorage.getItem('curve')) {
            localStorage.removeItem('curve')
        }
        let elementStyle = document.getElementById("Name-Back");
        // let rightSideLogo = document.getElementById("Right-Leg-Side-Logo");
        let demodiv = <any>document.getElementById('Name-Front');
        let fronflag = false;
        let backflag = false;
        let demodiv1 = <any>document.getElementById('Name-Back');
        if (demodiv && demodiv.childNodes && demodiv.childNodes[0].style && demodiv.childNodes[0].style.marginTop) {
            fronflag = true;
        }
        if (demodiv1 && demodiv1.childNodes && demodiv1.childNodes[0].style && demodiv1.childNodes[0].style.marginTop) {
            backflag = true;
        }

        try {
            if (this.selected_slide == 1) {
                this.outsideFileHTML = this.snapSvg.select("svg").node.outerHTML;
            } else {
                this.insideFileHTML = this.snapSvg.select("svg").node.outerHTML;
            }
        } catch (error) {
        }
        this.selected_slide = selection;
        this.editableLayers = [];
        if (selection === 1 && this.selectedJerseyCutsNew && this.selectedJerseyCutsNew.length > 0) {
            // if (this.outsideFileHTML && this.outsideFileHTML != "") {
                console.log("sidde is 1");
            if (this.outsideFileHTML && this.outsideFileHTML != "" && this.menuState.GraphicOptions !== true) {
                if (this.isSafari) {
                    $(this.snapSvg.select("svg").node).replaceWith(this.outsideFileHTML);
                } else {
                    this.snapSvg.select("svg").node.outerHTML = this.outsideFileHTML;
                }
                this.selectedJerseyCutsNew = this.selectedJerseyOutsideCuts;
                this.svgIdColors = this.layerColorApplied_OutSide;
                if(this.selectedJerseyCuts.length !=0){
                    this.editableLayers = this.getEditableLayers(this.selectedJerseyCuts[0]);
                }else{
                    this.editableLayers = this.getEditableLayers(this.selectedJersycut);
                }
                
                console.log("this.editableLayers",this.editableLayers);
                this.layerColorobj = this.layerColorApplied_OutSide;
                this.setDefaultTextColorOptions(this.snapSvg, true);
            } else {
                this.insideFileHTMLDef = null;
                if (this.outsideFileHTML) {
                    let temp = this.outsideFileHTML;
                    if (temp.split('<defs><pattern')[1] || temp.split('<defs><linearGradient')[1] || temp.split('<defs><radialGradient')[1]) {
                        if (temp.split('<defs><pattern')[1])
                            this.outsideFileHTMLDef = '<pattern' + temp.split('<defs><pattern')[1].split('</defs>')[0];
                        else if (temp.split('<defs><linearGradient')[1])
                            this.outsideFileHTMLDef = '<linearGradient' + temp.split('<defs><linearGradient')[1].split('</defs>')[0];
                        else if (temp.split('<defs><radialGradient')[1])
                            this.outsideFileHTMLDef = '<radialGradient' + temp.split('<defs><radialGradient')[1].split('</defs>')[0];


                    }
                }
                // this.insideFileHTMLDef = null;
                this.selectedJerseyCutsNew = this.selectedJerseyOutsideCuts;
                this.svgIdColors = this.layerColorApplied_OutSide;
                if (this.outside_Uniform)
                    this.styleCutclickAddJerseySVG(event, this.outside_Uniform);
                this.layerColorobj = this.layerColorApplied_OutSide;
            }
        } else if (selection === 2 && this.selectedJerseyInsideCuts && this.selectedJerseyInsideCuts.length > 0) {
            console.log("side is 2 ");
            // if (this.insideFileHTML && this.insideFileHTML != "") {
            if (this.insideFileHTML && this.insideFileHTML != "" && this.menuState.GraphicOptions !== true) {
                this.snapSvg.node.style.cssText = "height: 100%;width: 100%;";
                if (this.isSafari) {
                    $(this.snapSvg.select("svg").node).replaceWith(this.insideFileHTML);
                } else {
                    this.snapSvg.select("svg").node.outerHTML = this.insideFileHTML;
                }
                this.selectedJerseyCutsNew = this.selectedJerseyInsideCuts;
                this.svgIdColors = this.layerColorApplied_InSide;
                if(this.selectedJerseyCuts.length !=0){
                    this.editableLayers = this.getEditableLayers(this.selectedJerseyCuts[1]);
                }else{
                    this.editableLayers = this.getEditableLayers(this.selectedJersycut);
                }
                // this.editableLayers = this.getEditableLayers(this.selectedJersycut);
                console.log("this.editableLayers 2",this.editableLayers);
                this.layerColorobj = this.layerColorApplied_InSide;
                this.setDefaultTextColorOptions(this.snapSvg, true);
            } else {
                this.outsideFileHTMLDef = null;
                if (this.insideFileHTML) {
                    let temp = this.insideFileHTML;
                    if (temp.split('<defs><pattern')[1] || temp.split('<defs><linearGradient')[1] || temp.split('<defs><radialGradient')[1]) {
                        if (temp.split('<defs><pattern')[1])
                            this.insideFileHTMLDef = '<pattern' + temp.split('<defs><pattern')[1].split('</defs>')[0];
                        else if (temp.split('<defs><linearGradient')[1])
                            this.insideFileHTMLDef = '<linearGradient' + temp.split('<defs><linearGradient')[1].split('</defs>')[0];
                        else if (temp.split('<defs><radialGradient')[1])
                            this.insideFileHTMLDef = '<radialGradient' + temp.split('<defs><radialGradient')[1].split('</defs>')[0];

                    }
                }
                // this.outsideFileHTMLDef = null;
                this.selectedJerseyCutsNew = this.selectedJerseyInsideCuts;
                this.svgIdColors = this.layerColorApplied_InSide;
                if (this.inside_Uniform)
                    this.styleCutclickAddJerseySVG(event, this.inside_Uniform);
                this.layerColorobj = this.layerColorApplied_InSide;
            }
        } else {
            console.log("No uniform Found");
        }
        this.refreshPanel = true;
        setTimeout(() => {

            if (this.selected_slide == 1) {
                this.layerColorobj = this.layerColorApplied_OutSide;
            } else {
                this.layerColorobj = this.layerColorApplied_InSide;
            }
            let setStyle = document.getElementById("Name-Back");
            let SetrightSideLogo = <any>document.getElementById("Right-Leg-Side-Logo");


            if (setStyle && elementStyle) {
                if (elementStyle.style.display == 'none') {

                    setStyle.style.display = "none";
                    this.showMessageFlag = true;
                } else {
                    setStyle.style.display = "";
                    this.showMessageFlag = false;
                }
            }
            if (fronflag) {
                this.markItCurveFront(demodiv, fronflag);
            }

            if (backflag) {
                this.markItCurveBack(demodiv1, backflag);
            }

            this.refreshPanel = false;
            this.setDefaultLogos();
            let back = <any>document.getElementById('Name-Back');
            if (localStorage.getItem('category') == 'Football') {
                let numFontkStyle = document.getElementById('Number-Front');
                let numBackStyle = document.getElementById('Number-Back');
                if (numFontkStyle && !numFontkStyle.style.fontSize)
                    numFontkStyle.style.fontSize = "80px";
                if (numBackStyle && !numBackStyle.style.fontSize)
                    numBackStyle.style.fontSize = "80px";
            }


        }, 1500);
    }



    markItCurveFront(demodiv, fronflag) {
        let front = <any>document.getElementById('Name-Front');
        if (fronflag) {
            let di = new XMLSerializer().serializeToString(demodiv.childNodes[0]);
            setTimeout(() => {
                front.innerHTML = di;
                localStorage.setItem('circleType', localStorage.getItem('circleType'));
            }, 300);

        }

    }
    markItCurveBack(demodiv1, backflag) {
        let back = <any>document.getElementById('Name-Back');
        if (backflag) {
            let di = new XMLSerializer().serializeToString(demodiv1.childNodes[0]);
            setTimeout(() => {
                back.innerHTML = di;
                localStorage.setItem('circleType1', localStorage.getItem('circleType1'));
            }, 300);

        }
    }

    setDefaultLogos() {
        if (Array.isArray(this.availableLogoLocations)) {
            this.availableLogoLocations.forEach(d => {
                if (d.selected) {
                    d.selected = false;
                    this.addLogoOnLocation(d);
                } else {
                    d.selected = true;
                    this.addLogoOnLocation(d);
                }
            });
        }
    }

    addLogoOnLocation(location) {
        if (this.logo) {
            var imageurl = this.logo;
        }
        location.selected = !location.selected;
        try {
            if (location.selected) {
                if (location.id == 'Right-Leg-Side-Logo') {
                    let data = <any>document.getElementById(location.id);
                    this.toDataURL(data.href.animVal, function(dataUrl) {
                        document.getElementById(location.id).setAttribute("data", dataUrl)
                    });
                    // document.getElementById(location.id).setAttribute("href", data.href.animVal)
                } else {
                    if (document.getElementById(location.id).getAttribute("name") == 'filpImage') {
                        this.rotateImage(imageurl, location.id);
                    } else {
                        this.toDataURL(imageurl, function(dataUrl) {
                             document.getElementById(location.id).setAttribute("data", dataUrl);
                        });

                        // document.getElementById(location.id).setAttribute("href", imageurl);
                    }
                }
            } else {
                if (location.id == 'Chest-Logo' || location.id == '_x33_D_Soccer_Jersey_Layout') {
                    // document.getElementById(location.id).setAttribute("href", imageurl);
                } else {
                    document.getElementById(location.id).setAttribute("data", "");
                }
            }
        } catch (error) {
        }
    }

    async rotateImage(imageurl, locationId) {
        var Jimp = require('jimp');
        const image = await Jimp.read(imageurl, (err, profile) => {
            const mimeType = profile.getMIME();
            let pa = profile.flip(true, false).getBase64(mimeType, (mimeType, getBase64) => {
                document.getElementById(locationId).setAttribute("data", getBase64);
                if (document.querySelectorAll("#svgOuterElement svg #" + locationId)) {
                    document.querySelectorAll("#svgOuterElement svg #" + locationId)[0].setAttribute("data", getBase64);
                }
                if (document.querySelectorAll("#svgInnerElement svg #" + locationId)) {
                    document.querySelectorAll("#svgInnerElement svg #" + locationId)[0].setAttribute("data", getBase64);
                }
            });
        });
    }

    selectUniformType(name) {
        this.removeLocalStorage();
        this.localStorage();
        this.selectedUniformType = name;
        this.setdefaultSlide();
        this.layerColorApplied_OutSide = [];
        this.layerColorApplied_InSide = [];
        this.outsideFileHTML = "";
        this.insideFileHTML = "";
        if (this.activeJersey) {
            this.selectedJerseyCuts = this.getSelectedStyleCuts(this.activeJersey);
            this.selectedJerseyCutsNew = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Outside");
            this.selectedJerseyOutsideCuts = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Outside");
            this.selectedJerseyInsideCuts = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Inside");
            this.outside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Outside")[0];
            this.inside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Inside")[0];
            if (this.selectedJerseyCutsNew) {
                this.selectedJersycut = this.selectedJerseyCutsNew[0];
            }
            if (this.selectedJerseyCutsNew && this.selectedJerseyCutsNew[0]) {
                this.addSnapSvgJersey('', this.selectedJerseyCutsNew[0].img_url, false);
            }
        }
    }

    //<< On click of select jersy show cuts and dispaly image of regular ----->
    ////////////////////////////

    handleImageClick(SelectedJersey: Jersey, flag: any) {
        this.uniformtypes = [
            { "id": 'Reversible', "name": "Reversible", "subtext": "One Uniform", "text": "Printed on both sides", "visible": false },
            { "id": 'HomeAway', "name": "Home and Away", "subtext": "Single Ply", "text": "2 Sets of Uniform", "visible": false },
            { "id": 'GameDay', "name": "Game Day", "subtext": "Single Ply", "text": "1 Set", "visible": true }
        ];


        console.log(SelectedJersey,"SelectedJersey !!!!!!!!!!!!");
        if (flag) {
            this.selectedUniformType = 'GameDay';
        }// 
        this.activeJersey = SelectedJersey;
        this.load_FromID = false;
        this.selectedJerseyCuts = [];
        this.selectedJerseyCutsNew = [];
        this.stateTracker.SelectUniform = true;
        this.hideAllNotBuilder();
        this.selectedJerseyCuts = this.getSelectedStyleCuts(SelectedJersey);
        this.selectedJerseyCutsNew = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Outside");
        this.selectedJerseyOutsideCuts = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Outside");
        this.selectedJerseyInsideCuts = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Inside");
        // this.outside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Outside")[0];
        // this.inside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.layoutType === "Inside")[0];
        this.outside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.cut_name === SelectedJersey.cut_name && opt.layoutType === "Outside")[0];
        this.inside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.cut_name === SelectedJersey.cut_name && opt.layoutType === "Inside")[0];
        if (this.selectedJerseyCutsNew) {
            try {
                if (this.selected_slide == 1) {
                    var selcut = this.selectedJerseyCutsNew.filter((opt) => opt.cut_name === SelectedJersey.cut_name)[0];
                    if (selcut && selcut[0]) {
                        this.selectedJersycut = selcut;
                    } else {
                    }
                } else {
                    var selcut = this.selectedJerseyInsideCuts.filter((opt) => opt.cut_name === SelectedJersey.cut_name)[0];
                    if (selcut && selcut[0])
                        this.selectedJersycut = selcut;
                }
            } catch (error) {
                this.selectedJersycut = this.selectedJerseyCutsNew[0];
            }
        }
        if (this.selectedJerseyCutsNew.length > 1) {
            this.showStyleCuts = true;
            this.showSubDetail = true;
            this.menuState.Cuttype = true;
            this.menuState.SelectUniform = false;
            this.menuState.Cuttype = true;
        } else if (this.selectedJerseyCutsNew.length == 1) {
            // if the template only has 1 cut type, just skip to color options
            this.showStyleCuts = true;
            this.showSubDetail = true;
            this.menuState.Cuttype = true;
            this.menuState.SelectUniform = false;
            this.menuState.Cuttype = true;

            this.menuState.Cuttype = false;
            this.selectColorOptions();
        } else {
            this.showSubDetail = false;
            this.showStyleCuts = true;
            this.menuState.Cuttype = true;
        }
        this.menuState.SelectUniform = false;
        if (!this.outside_Uniform && !this.inside_Uniform) {
            this.toastr.warning("Looks like you are designing an outdated template, you might experience issues with current design. Please create new design or contact support if error persists. Uniform Lab Team", 'Style Missing', { timeOut: 10000, positionClass: 'toast-top-right' });
        }
        if (this.selectedJerseyCutsNew && this.selectedJerseyCutsNew[0]) {
            this.addSnapSvgJersey('', this.selectedJerseyCutsNew[0].img_url, true);
        }
        this.actualColorofLayer_OutSide = [];
        this.actualColorofLayer_InSide = [];
    }
    //Changes cut type





    styleCutclickAddJerseySVG(event: any, src: Jersey) {
        this.clearDefaultFonts();
        this.snapSvg.clear();
        this.load_FromID = false;
        this.activeThumbnill = src;

        this.selectedJersycut = src;
        try {
            if (this.selected_slide == 1) {
                this.activeOutsideCutName = src.cut_name;
            } else {
                this.activeInsideCutName = src.cut_name;
            }
        } catch (error) {
        }

        let can = this.canvas;
        let that = this;
        this.selectedId;
        let el;
        if (src) {
            el = src.img_url;
        } else {
            el = event.target.getAttribute('svgsrc');
        }
        this.editableLayers = this.getEditableLayers(this.selectedJersycut);
        var group = [];
        var snapSvg = Snap("#svg");

        (function () {

            Snap.plugin(function (Snap, Element, Paper, global) {

                Element.prototype.altDrag = function () {
                    this.drag(dragMove, dragStart, dragEnd);
                    return this;
                }

                var dragStart = function (x, y, ev) {
                    this.data('ot', this.transform().local);
                }

                var dragMove = function (dx, dy, ev, x, y) {
                    var tdx, tdy;
                    var snapInvMatrix = this.transform().diffMatrix.invert();
                    snapInvMatrix.e = snapInvMatrix.f = 0;
                    tdx = snapInvMatrix.x(dx, dy);
                    tdy = snapInvMatrix.y(dx, dy);
                    this.transform("t" + [tdx, tdy] + this.data('ot'));
                    this.node.style.cssText = 'cursor: move; border: 2px dotted;';
                }

                var dragEnd = function () {
                    this.node.style.cssText = 'cursor: move;';
                }
            });
        })();
        var tux = Snap.load(el, function (loadedFragment) {
            snapSvg.append(loadedFragment);

            var rects = ['Name-Front', 'Name-Back', 'Number-Back', 'Number-Front', , 'Name-Below-Front', '', 'Front-Number-2'];
            // var deafultValues = ["Team Name", "Last Name", "22", "22", "Team Name", "Last Name"]
            var deafultValues;
            if (localStorage.getItem('category') == 'Basketball') {
                deafultValues = ["Team Name", "Last Name", "23", "23", "Team Name", "Last Name", "23"];
            }
            else if (localStorage.getItem('category') == 'Football') {
                deafultValues = ["Team Name", "Last Name", "88", "88", "Team Name", "Last Name", "88"];
            } else {
                deafultValues = ["Team Name", "Last Name", "22", "22", "Team Name", "Last Name", "22"];
            }
            for (var i in rects) {
                if (rects[i] != "" && loadedFragment.paper.select("#" + rects[i] + "")) {
                    var rect = loadedFragment.paper.select("#" + rects[i] + "").node;
                    try {
                        var w = rect.getAttribute("width");
                        var h = rect.getAttribute("height");
                        var x = rect.getAttribute("x");
                        if (rects[i] == 'Number-Back' && w < 90) {
                            var d = (90 - w) / 2;
                            w = 90;
                            x = x - d;
                        }
                        let verticalAlignment = `vertical-align: middle;`; let zindex;
                        if (rect.id == 'Name-Back' || rect.id == 'Name-Front') {
                            zindex = 9999;
                        }

                        let style = `style="z-index:${zindex}"`;
                        if (h <= 20) { h = 20; }
                        //     var foreignObject = '<foreignObject '+style+' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                        //     <div id="' + rect.id + '" class="text-element" style="'+verticalAlignment+'width:' + w + 'px; height:' + h + 'px;">' + deafultValues[i] + '</div>\
                        // </foreignObject>';

                        let fontSize = FONT_SIZE[localStorage.getItem('category')];
                        if (fontSize) {
                        } else {
                            fontSize = FONT_SIZE['DeafultValues'];
                        }
                        if (localStorage.getItem('category') == 'Football') {

                            if (rect.id == 'Number-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.backNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Number-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.frontNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Name-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.teamName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else if (rect.id == 'Name-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.playerName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else if (rect.id == 'Name-Below-Front') {
                                var foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                          <div id="' + rect.id + '" class="text-element" style="display:none;height: 100%;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                           </foreignObject>';
                            } else if (rect.id == 'Front-Number-2') {
                                var foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;display:none;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                             </foreignObject>';
                            } else {
                                var foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + '; height:' + h + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }
                        } else {
                            if (rect.id == 'Name-Below-Front') {
                                var foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                        <div id="' + rect.id + '" class="text-element" style="display:none;height: 100%;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + '; height:' + h + 'px;">' + deafultValues[i] + '</div>\
                    </foreignObject>';
                            } else if (rect.id == 'Front-Number-2') {
                                var foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;display:none;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;">' + deafultValues[i] + '</div>\
                             </foreignObject>';
                            } if (rect.id == 'Number-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.backNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Number-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.frontNumber + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else if (rect.id == 'Name-Front') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.teamName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            }else if (rect.id == 'Name-Back') {
                                foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                                <div id="' + rect.id + '" class="text-element" style="height: 100%;text-align:center;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + ';height:' + h + 'px;font-size:' + fontSize.playerName + 'px;">' + deafultValues[i] + '</div>\
                                </foreignObject>';
                            } else {
                                var foreignObject = '<foreignObject ' + style + ' id="' + rect.id + '-p" xmlns="http://www.w3.org/2000/svg" x="' + x + '" y="' + rect.getAttribute("y") + '" class="' + rect.getAttribute("class") + '" width="' + w + '" height="' + h + '" >\
                    <div id="' + rect.id + '" class="text-element" style="height: 100%;' + verticalAlignment + 'width:' + w + 'px;z-index:' + zindex + '; height:' + h + 'px;">' + deafultValues[i] + '</div>\
                </foreignObject>';
                            }
                        }
                        if (that.isSafari) {
                            // $(loadedFragment.paper.select("#" + rects[i] + "").node).replaceWith(foreignObject);
                            var c = loadedFragment.paper.select("#" + rects[i] + "").node.parentNode.innerHTML;
                            loadedFragment.paper.select("#" + rects[i] + "").node.parentNode.innerHTML = c + foreignObject;
                            document.querySelectorAll("#" + rects[i])[0].remove();
                        } else {
                            loadedFragment.paper.select("#" + rects[i] + "").node.outerHTML = foreignObject;
                        }

                    } catch (error) {
                        console.log(error)
                    }
                }
            }
            try {
                loadedFragment.paper.select("#Name-Front-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                loadedFragment.paper.select("#Name-Below-Front-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                loadedFragment.paper.select("#Name-Back-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                // loadedFragment.paper.select("#Name-Below-Back-p").attr({
                //     style: 'cursor: move;overflow: visible;'
                // }).altDrag();
                loadedFragment.paper.select("#Number-Front-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
                loadedFragment.paper.select("#Number-Back-p").attr({
                    style: 'cursor: move;overflow: visible;'
                }).altDrag();
            } catch (error) { }

            that.setDefaultTextColorOptions(loadedFragment, false);

            // logo rect to image
            var allRectsvgElements = loadedFragment.paper.selectAll("rect");
            if (allRectsvgElements && allRectsvgElements.length > 0) {
                for (var i in allRectsvgElements) {
                    if (allRectsvgElements[i] && allRectsvgElements[i].id) {
                        if (that.isSafari) {
                            // $(allRectsvgElements[i].node).replaceWith(allRectsvgElements[i].node.outerHTML.replace("rect", "image"));
                            var c = allRectsvgElements[i].node.parentNode.innerHTML;

                            // VISHAL - add a div around the image, and verticall center the div content so that image resize anchors from middle

                            // allRectsvgElements[i].node.parentNode.innerHTML = c + allRectsvgElements[i].node.outerHTML.replace("rect", "image");

                            if(allRectsvgElements[i].node.getAttribute('id')=='Chest-Logo'){
                                // var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // </object></foreignObject>';
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                </object></foreignObject>';
                                }else{
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" prevx="' + allRectsvgElements[i].node.getAttribute('x') + '" prevy="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '"  prevwidth="' + allRectsvgElements[i].node.getAttribute('width') + '" prevheight="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                </object></foreignObject>';
                                
                                }
                                allRectsvgElements[i].node.parentNode.innerHTML = c + foreignObject;
                                // allRectsvgElements[i].node.outerHTML = foreignObject;
                        } else {
                            // allRectsvgElements[i].node.outerHTML = allRectsvgElements[i].node.outerHTML.replace("rect", "image");
                            if(allRectsvgElements[i].node.getAttribute('id')=='Chest-Logo'){
                                // var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                // </object></foreignObject>';
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="143.5" height="143.5" >\
                                </object></foreignObject>';
                                }else{
                                var foreignObject = '<foreignObject style="z-index:0" id="' + allRectsvgElements[i].node.getAttribute('id') + '-p" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" prevx="' + allRectsvgElements[i].node.getAttribute('x') + '" prevy="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '"  prevwidth="' + allRectsvgElements[i].node.getAttribute('width') + '" prevheight="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                <object type="image/png" style="display:none;vertical-align: middle;" id="' + allRectsvgElements[i].node.getAttribute('id') + '" xmlns="http://www.w3.org/2000/svg" x="' + allRectsvgElements[i].node.getAttribute('x') + '" y="' + allRectsvgElements[i].node.getAttribute('y') + '" class="' + allRectsvgElements[i].node.getAttribute('class') + '" width="' + allRectsvgElements[i].node.getAttribute('width') + '" height="' + allRectsvgElements[i].node.getAttribute('height') + '" >\
                                </object></foreignObject>';
                                
                                }
                                allRectsvgElements[i].node.outerHTML = foreignObject;
                        }
                    }
                }
            }



            try {
                if (that.selected_slide == 1) {
                    that.outsideFileHTML = loadedFragment.paper.select("svg").node.outerHTML;
                } else {
                    that.insideFileHTML = loadedFragment.paper.select("svg").node.outerHTML;
                }

                $("clipPath").remove();
            } catch (error) {
                console.log(error);
            }
            if(loadedFragment.paper.select("svg").node.hasAttribute("width")){
                loadedFragment.paper.select("svg").node.removeAttribute("width");
            }
        });
        this.outside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.cut_name === src.cut_name && opt.layoutType === "Outside")[0];
        this.inside_Uniform = this.selectedJerseyCuts.filter((opt) => opt.cut_name === src.cut_name && opt.layoutType === "Inside")[0];
    }

    setDefaultTextColorOptions(loadedFragment, isFromColorPanel) {
        var that = this;
        var arr = [];
        var txts = document.getElementsByTagName("text");

        let elementStyle = document.getElementById("Name-Back");
        let rightSideLogo = document.getElementById("Right-Leg-Side-Logo");
        let demodiv = <any>document.getElementById('Name-Front');
        let fronflag = false;
        let backflag = false;
        let demodiv1 = <any>document.getElementById('Name-Back');

        if (demodiv && demodiv.childNodes && demodiv.childNodes[0].style && demodiv.childNodes[0].style.marginTop) {
            fronflag = true;
        }
        if (demodiv1 && demodiv1.childNodes && demodiv1.childNodes[0].style && demodiv1.childNodes[0].style.marginTop) {
            backflag = true;
        }
        setTimeout(() => {

            txts = loadedFragment.paper.selectAll(".text-element")['items'];
            for (var i in txts) {
                if (that.reEditFlag) {
                    if (that.submittedDesign) {
                        var arr1 = [], arr2 = [];
                        if (that.selected_slide == 1) {
                            if (that.layerColorApplied_OutSide.length > 0) {
                                arr1 = that.layerColorApplied_OutSide.filter(function (d) {
                                    return d.layer == txts[i]['node'].id;
                                });
                            }
                            if (arr1.length == 0 && that.submittedDesign.data.LayerColors_OutSide) {
                                arr1 = that.submittedDesign.data.LayerColors_OutSide.filter(function (d) {
                                    return d.layer == txts[i]['node'].id;
                                });
                            }
                        }
                        if (that.selected_slide == 2) {
                            if (that.layerColorApplied_InSide.length > 0) {
                                arr1 = that.layerColorApplied_InSide.filter(function (d) {
                                    return d.layer == txts[i]['node'].id;
                                });
                            }
                            if (arr1.length == 0 && that.submittedDesign.data.LayerColors_InSide) {
                                arr1 = that.submittedDesign.data.LayerColors_InSide.filter(function (d) {
                                    return d.layer == txts[i]['node'].id;
                                });
                            }
                        }

                        if (arr1[0]) {
                            that.setDefaultElements(arr1[0]);
                        }
                    }
                } else if (txts[i]['node'].style && txts[i]['node'].style.fontFamily == "" && !this.reEditFlag) {
                    var cssText = "";
                    try {
                        cssText = loadedFragment.paper.select("#" + txts[i]['node'].id + "").node.style.cssText;
                    } catch (error) {
                        console.log(error)
                    }
                    // loadedFragment.paper.select("#" + txts[i]['node'].id + "").attr({
                    //     style: cssText + 'font-family: \'CollegeBlock2-0\', sans-serif;'
                    // });
                }
            }
            if (Array.isArray(that.editableLayers) && !isFromColorPanel) {
                that.editableLayers.forEach((d) => {
                    if (this.selected_slide == 1 && d['color1']) {
                        arr = this.getSelectedColor('color1', d);
                        that.uniformColorSelectHandler(d);
                        if (arr && arr[0]) {
                            that.uniformColorSelectHandler(arr[0]);
                        }
                    } else if (this.selected_slide == 2 && d['color2']) {
                        arr = this.getSelectedColor('color2', d);
                        that.uniformColorSelectHandler(d);
                        if (arr && arr[0]) {
                            that.uniformColorSelectHandler(arr[0]);
                        }
                    }
                });
            }
            let ddd = <any>document.getElementById('svg').children;

            for (let inside of ddd) {
                if (inside.tagName == 'svg') {
                    for (let item of inside.children) {
                        if (item.tagName == 'defs') {
                            setTimeout(() => {

                                let allGrad = <any>document.querySelectorAll('*[id^="Gradient-Home-"]');
                                for (let item of allGrad) {
                                    document.getElementById(item.id.split('Gradient-Home-')[1]).style.fill = `url(#${item.id}`;
                                }
                                let all1Grad = <any>document.querySelectorAll('*[id^="Gradient-Away-"]');
                                for (let item of all1Grad) {
                                    document.getElementById(item.id.split('Gradient-Away-')[1]).style.fill = `url(#${item.id}`;
                                }
                                if (this.outsideFileHTMLDef) {
                                    if (item.innerHTML.includes('<pattern') || item.innerHTML.includes('<linearGradient') || item.innerHTML.includes('<radialGradient')) {
                                        item.innerHTML = this.outsideFileHTMLDef;
                                    } else {
                                        item.innerHTML = item.innerHTML + this.outsideFileHTMLDef;
                                    }
                                }
                                if (this.insideFileHTMLDef) {
                                    if (item.innerHTML.includes('<pattern') || item.innerHTML.includes('<linearGradient') || item.innerHTML.includes('<radialGradient')) {
                                        item.innerHTML = this.insideFileHTMLDef;
                                    } else {
                                        item.innerHTML = item.innerHTML + this.insideFileHTMLDef;
                                    }
                                }

                            }, 0)

                        }
                    }
                }
            }


            if (document.getElementById('Name-Below-Front') && this.frontbelowName)
                document.getElementById('Name-Below-Front').innerHTML = this.frontbelowName.innerHTML;

            if (this.frontbelowName && this.frontbelowName.style.display == "none") {
                document.getElementById('Name-Below-Front').style.display = "none";
            }
            if (localStorage.getItem('category') == 'Football') {
                let numFontkStyle = document.getElementById('Number-Front');
                let numBackStyle = document.getElementById('Number-Back');
                if (numFontkStyle && !numFontkStyle.style.fontSize)
                    numFontkStyle.style.fontSize = "80px";
                if (numBackStyle && !numBackStyle.style.fontSize)
                    numBackStyle.style.fontSize = "80px";
            }
            if (fronflag)
                this.markItCurveFront(demodiv, fronflag);
            if (backflag)
                this.markItCurveBack(demodiv1, backflag);
        }, 100);
    }
    getSelectedColor(key, layers) {
        let colorList = [];
        for (let key in this.colorsList) {
            colorList.push(this.colorsList[key]);
        }
        try {
            return colorList.filter(d => {
                return d.colorCode == layers[key].colorCode || d.colorName == layers[key].colorName;
            });
        } catch (error) {
        }
    }

    displayColorName(color) {
        this.colorName = color.colorName;
    }

    // push roster data into database
    submitTeamRosterForm(val) {
        //   console.log(val);
        //   this.alertService.confirmThis("Please double check your players and sizes. Are you ready to submit your design?", function() {
        //ACTION: Do this If user says YES
        this.toggleSubmitUniform();
        //   this.name = "Yes clicked";
        //   }.bind(this), function() {
        //       //ACTION: Do this if user says NO
        //       this.name = "No clicked";
        //   })
    }

    //Works with Team roaster - onClick of  AddPlayer
    addPlayer(player) {
        this.players.push(new PlayerObj(null, null, null, null));
    }

    //Works with Team roaster - onClick of  Delete Player
    deletePlayer(player, index) {
        if (index != 0) {
            if (confirm("Are you sure you want to delete this player?")) {
                this.players.splice(index, 1);
            }
        }
    }

    jerseycolorapplyonhover(event, layer: LayerObj) {
        let color;
        if (event.target.style.backgroundColor == "") {
            color = this.colorselect.colorCode;
        } else {
            color = event.target.style.backgroundColor;
        }
        let id = layer.layerID;
        let that = this;
        var object = that.canvas._objects[0];

        if (object) {
            if (object.paths)
                if (that.actualColorofLayer_OutSide.length === 0 && that.selected_slide === 1 || that.actualColorofLayer_InSide.length === 0 && that.selected_slide === 2) { // Stores the Layer and Original Color code from SVG data to compare while remove hover color and apply to orignal when not selected any color
                    for (var i = 0; i < object.paths.length; i++) {
                        if (that.selected_slide === 1)
                            that.actualColorofLayer_OutSide.push(new LayerColorOriginalObj(object.paths[i].id, object.paths[i].fill, ""));
                        else
                            that.actualColorofLayer_InSide.push(new LayerColorOriginalObj(object.paths[i].id, object.paths[i].fill, ""));
                    }
                }
            for (var i = 0; i < object.paths.length; i++) {
                if (object.paths[i].id == id) {
                    object.paths[i].setFill(color);
                    break;
                }
            }
            that.canvas.renderAll();
        }
    }

    _svgjerseycolorapplyonhover(event, layer: LayerObj) {
        if (!this.colorselect) return;
        let color;
        if (event.target.style.backgroundColor == "") {
            color = this.colorselect.colorCode;
        } else {
            color = event.target.style.backgroundColor;
        }
        let id = layer.layerID;
        let that = this;
        var object = {
            paths: document.getElementsByTagName("path")
        };
        if (that.actualColorofLayer_OutSide.length === 0 && that.selected_slide === 1 || that.actualColorofLayer_InSide.length === 0 && that.selected_slide === 2) { // Stores the Layer and Original Color code from SVG data to compare while remove hover color and apply to orignal when not selected any color
            for (var i = 0; i < object.paths.length; i++) {
                if (that.selected_slide === 1) {
                    if (that.reEditFlag) {
                        var a = that.layerColorApplied_OutSide.filter(function (d) {
                            return d.layer == object.paths[i].id;
                        });
                        if (a && a[0]) {
                            that.actualColorofLayer_OutSide.push(new LayerColorOriginalObj(a[0].layer, a[0].colorCode, a[0].colorName));
                        }
                    } else {
                        that.actualColorofLayer_OutSide.push(new LayerColorOriginalObj(object.paths[i].id, object.paths[i].style.fill, ""));
                    }
                } else {
                    that.actualColorofLayer_InSide.push(new LayerColorOriginalObj(object.paths[i].id, object.paths[i].style.fill, ""));
                }
            }
        }
        for (var i = 0; i < object.paths.length; i++) {
            if (object.paths[i].id == id) {
                object.paths[i].style.fill = color;
                break;
            }
        }


    }

    uniformColorSelectHandler(event) {
        let colorFromcolorcomponent: Icolorselected;

        if (event && event.altKey == false) {
            this.eventFromcolorcomponent = event;
        }
        if (event && event.layerID) {
            this.layerFromcolorcomponent = event;
        }
        if (event && event.colorName) {
            colorFromcolorcomponent = event;
            this.colorselectedForHover = event;
        }

        if (colorFromcolorcomponent) {
            this.colorselect = colorFromcolorcomponent;
            let color = colorFromcolorcomponent;
            let layer = this.layerFromcolorcomponent;

            // To store color applied to layer in both Inner & Outer
            if (this.selected_slide === 1) {
                for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    if (this.layerColorApplied_OutSide[i].layer === layer.layerID) {
                        this.layerColorApplied_OutSide[i].colorCode = color.colorCode;
                        this.layerColorApplied_OutSide[i].colorName = color.colorName;
                        break
                    }
                this.layerColorobj = this.layerColorApplied_OutSide;
            } else {
                for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    if (this.layerColorApplied_InSide[i].layer === layer.layerID) {
                        this.layerColorApplied_InSide[i].colorCode = color.colorCode;
                        this.layerColorApplied_InSide[i].colorName = color.colorName;
                        break
                    }
                this.layerColorobj = this.layerColorApplied_InSide;
            }
            this.jerseycolorwithLayer(this.eventFromcolorcomponent, this.layerFromcolorcomponent, colorFromcolorcomponent);
        }
    }


    uniformPatternSelectHandler(event) {
        let colorFromcolorcomponent: Icolorselected;

        if (event && event.altKey == false) {
            this.eventFromcolorcomponent = event;
        }
        if (event && event.layerID) {
            this.layerFromcolorcomponent = event;
        }
        if (event && event.colorName) {
            colorFromcolorcomponent = event;
            this.colorselectedForHover = event;
        }

        if (colorFromcolorcomponent) {
            this.colorselect = colorFromcolorcomponent;
            let color = colorFromcolorcomponent;
            let layer = this.layerFromcolorcomponent;

            // To store color applied to layer in both Inner & Outer
            if (this.selected_slide === 1) {
                for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    if (this.layerColorApplied_OutSide[i].layer === layer.layerID) {
                        this.layerColorApplied_OutSide[i].colorCode = color.colorCode;
                        this.layerColorApplied_OutSide[i].colorName = color.colorName;
                        break
                    }
                this.layerColorobj = this.layerColorApplied_OutSide;
            } else {
                for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    if (this.layerColorApplied_InSide[i].layer === layer.layerID) {
                        this.layerColorApplied_InSide[i].colorCode = color.colorCode;
                        this.layerColorApplied_InSide[i].colorName = color.colorName;
                        break
                    }
                this.layerColorobj = this.layerColorApplied_InSide;
            }
            this.jerseycolorwithLayer(this.eventFromcolorcomponent, this.layerFromcolorcomponent, colorFromcolorcomponent);
        }
    }

    //Apply Color to Canvas on Hover (mouse)
    colorapplyonhover(event) {
        let layerFromcolorhovercomponent: any;
        this.colorselect = this.colorselectedForHover;
        if (event && event.altKey == false) {
            this.eventFromcolorhovercomponent = event;
        }
        if (event.layerID) {
            layerFromcolorhovercomponent = event;
        }
        if (layerFromcolorhovercomponent) {
            this._svgjerseycolorapplyonhover(this.eventFromcolorhovercomponent, layerFromcolorhovercomponent);
        }
    }

    onclicksutemplate(res) {
        this.toggleUniformSelect(true);
        this.getSelectedJerseyStylesFromDb();
    }

    //Function to Apply original color if not selected any color or Apply Selected Color if Selected any color
    mouseleavecolor(curlayer) {
        let colorSelectedStatus: boolean = false;
        let cnt: number;
        let originalColor: string;

        if (curlayer.old) {
            this.prevColorObj = curlayer;
        } else {
            if (this.layerFromcolorcomponent) {
                if (this.selected_slide === 1) {
                    for (cnt = 0; cnt < this.layerColorApplied_OutSide.length; cnt++)
                        if (this.layerColorApplied_OutSide[cnt].layer === curlayer.layerID) {
                            if (this.layerColorApplied_OutSide[cnt].colorName != "") {
                                if (this.reEditFlag && this.prevColorObj && curlayer.layerID == this.prevColorObj.layer.layerID) {
                                    if (this.prevColorObj.old.colorName == this.layerColorApplied_OutSide[cnt].colorName) {
                                        colorSelectedStatus = true;
                                        break;
                                    }
                                } else {
                                    colorSelectedStatus = true;
                                    break;
                                }
                            }
                        }
                } else {
                    for (cnt = 0; cnt < this.layerColorApplied_InSide.length; cnt++)
                        if (this.layerColorApplied_InSide[cnt].layer === curlayer.layerID) {
                            if (this.layerColorApplied_InSide[cnt].colorName != "") {
                                if (this.reEditFlag && this.prevColorObj && curlayer.layerID == this.prevColorObj.layer.layerID) {
                                    if (this.prevColorObj.old.colorName == this.layerColorApplied_InSide[cnt].colorName) {
                                        colorSelectedStatus = true;
                                        break;
                                    }
                                } else {
                                    colorSelectedStatus = true;
                                    break;
                                }
                            }
                        }
                }
            }
            if (colorSelectedStatus) {
                if (this.selected_slide === 1) {
                    this.jerseycolorwithLayer(this.eventFromcolorcomponent, curlayer, this.layerColorApplied_OutSide[cnt]);
                } else
                    this.jerseycolorwithLayer(this.eventFromcolorcomponent, curlayer, this.layerColorApplied_InSide[cnt]);
            } else {
                if (this.selected_slide === 1) {
                    for (cnt = 0; cnt < this.actualColorofLayer_OutSide.length; cnt++) {
                        if (this.actualColorofLayer_OutSide[cnt].layer === curlayer.layerID) {
                            if (this.reEditFlag && curlayer.color1) {
                                originalColor = curlayer.color1.colorCode
                            } else
                                originalColor = this.actualColorofLayer_OutSide[cnt].colorCode;
                        }
                    }
                } else {
                    for (cnt = 0; cnt < this.actualColorofLayer_InSide.length; cnt++) {
                        if (this.actualColorofLayer_InSide[cnt].layer === curlayer.layerID) {
                            if (this.reEditFlag && curlayer.color2) {
                                originalColor = curlayer.color2.colorCode
                            } else
                                originalColor = this.actualColorofLayer_InSide[cnt].colorCode;
                        }
                    }
                }

                let id = curlayer.layerID;
                let that = this;
                var object = {
                    paths: document.getElementsByTagName("path")
                };

                if (object) {
                    if (object.paths) {
                        for (var i = 0; i < object.paths.length; i++) {
                            if (object.paths[i].id == id) {
                                object.paths[i].style.fill = originalColor;
                                break
                            }
                        }
                    }
                }
            }
        }
    }


    addLogoOnFrontChest() {
        if (this.isFrontImage) {
            var img1 = this.getImageById("frontImage");
            this.canvas.add(img1).renderAll();
        }
    }
    addLogoOnBackUpper() {
        if (this.isBackImage) {
            var img2 = this.getImageById("backImage");
            this.canvas.add(img2).renderAll();
        }
    }

    addLogoOnShortLeg() {
        if (this.isShortLegImage) {
            var img3 = this.getImageById("shortLegImage");
            this.canvas.add(img3).renderAll();
        }
    }

    changelogo(logoFiles) {
        this.logoFiles = logoFiles;
    }
    updatelogo(logoObj) {
        if (logoObj.logo)
            this.logo = logoObj.logo;
        if (logoObj.availableLogoLocations)
            this.availableLogoLocations = logoObj.availableLogoLocations;
    }

    handelLoading(loading) {
        if (loading.flag) {
            this.startLoadingSpinner();
        } else {
            this.loading = false;
        }

    }
    //Works on Event Emitter from Graphic Options - For Applying Color, Font Size, Font Type, Team and Player Names etc
    updateCanvasWithTeamName(data: ITexttoCanvas) {

        let that = this;
        let color = "";
        if (this.selected_slide === 1) {
            if (this.layerColorApplied_OutSide.length !== 0) {
                // color = this.layerColorApplied_OutSide[0].colorCode;
            }
        } else {
            if (this.layerColorApplied_InSide.length !== 0) {
                // color = this.layerColorApplied_InSide[0].colorCode;
            }
        }

        if (color == "" || color === undefined) {
            if (this.selected_slide === 1) {
                // if (this.actualColorofLayer_OutSide.length > 0)
                //     // color = this.actualColorofLayer_OutSide[0].colorCode;
            } else {
                if (this.actualColorofLayer_InSide.length > 0) {
                    // color = this.actualColorofLayer_InSide[0].colorCode;
                }
            }
        }

        var object = {
            paths: document.querySelectorAll('path, .text-element')
        };
        var texts = document.getElementsByTagName("text");
        if (object) {
            if (object.paths) {

                if (color === "" && object.paths[0]) {

                    // color = (<any>object.paths[0]).style.fill;
                }
                for (var i = 0; i < object.paths.length; i++) {

                    //Apply Team Name to SVG
                    if (data.teamorplyaer === "Team" && data.field === "Name" && object.paths[i].id == "Name-Front") {
                        var tempObject = this.snapSvg.select('#Name-Front');
                        // console.log('tempObject->',this.layerColorApplied_OutSide);

                        if (tempObject != null) {
                            tempObject.node.innerHTML = data.value;
                        } else {
                            tempObject.attr({
                                text: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Team_Name = data.value;
                        that.graphic_Data_Inside.Team_Name = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Front") {
                                this.layerColorApplied_OutSide[i].text = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Front") {
                                this.layerColorApplied_InSide[i].text = data.value;
                                break
                            }
                        // }
                        break
                    }


                    //Apply Fontsize to Team Name
                    if (data.teamorplyaer === "Team" && data.field === "Fontsize" && object.paths[i].id == "Name-Front") {
                        var tempObject = this.snapSvg.select('#Name-Front');
                        if (tempObject != null) {
                            tempObject.attr({
                                fontSize: data.value
                            });
                        } else {
                            tempObject.attr({
                                fontSize: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Team_FontSize = data.value;
                        that.graphic_Data_Inside.Team_FontSize = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Front") {
                                this.layerColorApplied_OutSide[i].fontSize = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Front") {
                                this.layerColorApplied_InSide[i].fontSize = data.value;
                                break
                            }
                        // }

                        break
                    }
                    //Apply Font Type to Team Name
                    if (data.teamorplyaer === "Team" && data.field === "Fonttype" && object.paths[i].id == "Name-Front") {
                        var tempObject = this.snapSvg.select('#Name-Front');
                        if (tempObject != null) {
                            tempObject.attr({
                                fontFamily: data.value
                            });
                        } else {
                            tempObject.attr({
                                fontFamily: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Team_FontType = data.value;
                        that.graphic_Data_Inside.Team_FontType = data.value;

                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Front") {
                                this.layerColorApplied_OutSide[i].fontType = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Front") {
                                this.layerColorApplied_InSide[i].fontType = data.value;
                                break
                            }
                        // }
                        break
                    }
                    //Apply Font Stroke to Team Name
                    if (data.teamorplyaer === "Team" && data.field === "FontStroke" && object.paths[i].id == "Name-Front") {
                        var tempObject = this.snapSvg.select('#Name-Front');
                        var thickness = '.7';
                        if (data.value.colorCode == "") {
                            thickness = '0';
                        }
                        tempObject.attr({
                            stroke: data.value.colorCode
                        });
                        tempObject.attr({
                            strokeWidth: thickness
                        });
                        tempObject.node.style.webkitTextStroke = thickness + 'px' + data.value.colorCode;

                        //Toggle
                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++) {
                                if (this.layerColorApplied_OutSide[i].layer === "Name-Front") {
                                    this.layerColorApplied_OutSide[i].fontStroke = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].fontStrokeColorName = data.value.colorName;
                                    break
                                }
                            }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Name-Front") {
                                    this.layerColorApplied_InSide[i].fontStroke = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].fontStrokeColorName = data.value.colorName;
                                    break
                                }
                            break;
                        }
                    }
                    //Apply Font Stroke to Player Name
                    if (data.teamorplyaer === "Player" && data.field === "FontStroke" && object.paths[i].id == "Name-Back") {
                        var tempObject = this.snapSvg.select('#Name-Back');
                        var thickness = '.7';
                        if (data.value.colorCode == "") {
                            thickness = '0';
                        }
                        tempObject.attr({

                            stroke: data.value.colorCode
                        });
                        tempObject.attr({
                            strokeWidth: thickness
                        });
                        tempObject.node.style.webkitTextStroke = thickness + 'px' + data.value.colorCode;
                        //Toggle
                        //that.graphic_Data_Outside.Player_FontStroke=data.value;
                        //that.graphic_Data_Inside.Player_FontStroke=data.value;

                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Name-Back") {
                                    this.layerColorApplied_OutSide[i].fontStroke = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].fontStrokeColorName = data.value.colorName;
                                    break
                                }
                            // break
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Name-Back") {
                                    this.layerColorApplied_InSide[i].fontStroke = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].fontStrokeColorName = data.value.colorName;

                                    break
                                }
                            break
                        }
                    }

                    //Apply color to Team Name
                    if (data.teamorplyaer === "Team" && data.field === "Color" && object.paths[i].id == "Name-Front") {
                        var tempObject = this.snapSvg.select('#Name-Front');

                        tempObject.attr({
                            fill: data.value.colorCode
                        });
                        if (tempObject.node) {
                            tempObject.node.style.color = data.value.colorCode;
                        }

                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Name-Front") {
                                    this.layerColorApplied_OutSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].colorName = data.value.colorName;
                                    break
                                }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Name-Front") {
                                    this.layerColorApplied_InSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].colorName = data.value.colorName;
                                    break
                                }
                        }
                        break;
                    }

                    //Apply Player Name to Canvas
                    if (data.teamorplyaer === "Player" && data.field === "Name" && object.paths[i].id == "Name-Back") {
                        var tempObject = this.snapSvg.select('#Name-Back');
                        if (tempObject != null) {
                            tempObject.attr({
                                text: data.value
                            });
                            tempObject.node.innerHTML = data.value;
                        } else {
                            tempObject.attr({
                                text: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Player_Name = data.value;
                        that.graphic_Data_Inside.Player_Name = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Back") {
                                this.layerColorApplied_OutSide[i].text = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Back") {
                                this.layerColorApplied_InSide[i].text = data.value;
                                break
                            }
                        // }
                        break
                    }
                    //Apply Fontsize to Player Name
                    if (data.teamorplyaer === "Player" && data.field === "Fontsize" && object.paths[i].id == "Name-Back") {
                        var tempObject = this.snapSvg.select('#Name-Back');
                        tempObject.attr({
                            fontSize: data.value
                        });
                        //Toggle
                        that.graphic_Data_Outside.Player_FontSize = data.value;
                        that.graphic_Data_Inside.Player_FontSize = data.value;

                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Back") {
                                this.layerColorApplied_OutSide[i].fontSize = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Back") {
                                this.layerColorApplied_InSide[i].fontSize = data.value;
                                break
                            }
                        // }

                        break
                    }

                    //Apply Font Type to Player Name
                    if (data.teamorplyaer === "Player" && data.field === "Fonttype" && object.paths[i].id == "Name-Back") {
                        var tempObject = this.snapSvg.select('#Name-Back');
                        tempObject.attr({
                            fontFamily: data.value
                        });
                        //Toggle
                        that.graphic_Data_Outside.Player_FontType = data.value;
                        that.graphic_Data_Inside.Player_FontType = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Back") {
                                this.layerColorApplied_OutSide[i].fontType = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Back") {
                                this.layerColorApplied_InSide[i].fontType = data.value;
                                break
                            }
                        // }
                        break
                    }

                    //Apply color to Player Name
                    if (data.teamorplyaer === "Player" && data.field === "Color" && object.paths[i].id == "Name-Back") {
                        var tempObject = this.snapSvg.select('#Name-Back');
                        tempObject.attr({
                            fill: data.value.colorCode
                        });
                        if (tempObject.node) {
                            tempObject.node.style.color = data.value.colorCode;
                        }
                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Name-Back") {
                                    this.layerColorApplied_OutSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].colorName = data.value.colorName;
                                    break
                                }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Name-Back") {
                                    this.layerColorApplied_InSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].colorName = data.value.colorName;
                                    break
                                }
                        }
                    }

                    if (data.teamorplyaer === "FrontNumber" && data.field === "Name" && (object.paths[i].id == "Number-Front" || object.paths[i].id == 'Front-Number-2')) {

                        var tempObject = this.snapSvg.select('#Number-Front');
                        var tempObject1 = this.snapSvg.select('#Front-Number-2');
                        if (tempObject != null || tempObject1 != null || tempObject1 || tempObject) {
                            if (data.value == "none") {
                                tempObject.attr({
                                    text: ""
                                });
                                tempObject1.attr({
                                    text: ""
                                });
                                tempObject.node.innerHTML = "";
                                tempObject1.node.innerHTML = "";
                            } else {
                                tempObject.attr({
                                    text: "" + data.value + ""
                                });
                                if (tempObject1 != null) {
                                    tempObject1.attr({
                                        text: "" + data.value + ""
                                    });
                                    tempObject1.node.innerHTML = data.value;
                                }

                                tempObject.node.innerHTML = data.value;

                            }
                        }
                        that.graphic_Data_Outside.Front_Number = data.value;
                        that.graphic_Data_Inside.Front_Number = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)

                            if (this.layerColorApplied_OutSide[i].layer === "Number-Front" || this.layerColorApplied_OutSide[i].layer === 'Front-Number-2') {
                                this.layerColorApplied_OutSide[i].text = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Number-Front" || this.layerColorApplied_InSide[i].layer === "Front-Number-2") {
                                this.layerColorApplied_InSide[i].text = data.value;
                                break
                            }
                        // }
                        break;
                    }

                    if (data.teamorplyaer === "BackNumber" && data.field === "Name" && (object.paths[i].id == "Number-Back")) {
                        var tempObject = this.snapSvg.select('#Number-Back');
                        if (tempObject != null) {
                            if (data.value == "none") {
                                tempObject.attr({
                                    text: ""
                                });
                                tempObject.node.innerHTML = "";
                            } else {
                                // tempObject.attr({ text: "" + data.value + ""});
                                tempObject.node.innerHTML = data.value;
                            }
                        }
                        that.graphic_Data_Outside.Back_Number = data.value;
                        that.graphic_Data_Inside.Back_Number = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Number-Back") {
                                this.layerColorApplied_OutSide[i].text = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Number-Back") {
                                this.layerColorApplied_InSide[i].text = data.value;
                                break
                            }
                        // }
                        break;
                    }

                    // Erase and Display Front numbers on None button click.
                    if (data.teamorplyaer === "FrontNumber" && data.field === "Text" && (object.paths[i].id == "Number-Front" || object.paths[i].id == 'Front-Number-2')) {

                        var tempObject = this.snapSvg.select('#Number-Front');
                        var tempObject1 = this.snapSvg.select('#Front-Number-2');

                        //   var tempObject = that.getItemById('Number-Front');
                        if (tempObject != null || tempObject1 != null) {
                            if (data.value == "none") {
                                //   tempObject.text = "";
                                tempObject.attr({
                                    text: ""
                                });
                                if (tempObject1 != null) {
                                    tempObject1.attr({
                                        text: ""
                                    });
                                    tempObject1.node.innerHTML = "";
                                }
                                tempObject.node.innerHTML = "";

                            } else {
                                tempObject.attr({
                                    text: "" + data.value + ""
                                });
                                tempObject1.attr({
                                    text: "" + data.value + ""
                                });
                            }

                            //   tempObject.text = "" + data.value + "";
                        } else {
                            if (data.value == "none") {
                                tempObject.attr({
                                    text: ""
                                });
                                tempObject1.attr({
                                    text: ""
                                });
                            } else {
                                tempObject.attr({
                                    text: "" + data.value + ""
                                });
                                tempObject1.attr({
                                    text: "" + data.value + ""
                                });
                            }
                        }
                        that.graphic_Data_Outside.Front_Number = data.value;
                        that.graphic_Data_Inside.Front_Number = data.value;
                        break;
                    }
                    // Erase and Display Back numbers on None button click.
                    if (data.teamorplyaer === "BackNumber" && data.field === "Text" && (object.paths[i].id == "Number-Back")) {
                        var tempObject = this.snapSvg.select('#Number-Back');

                        if (data.value == "none") {
                            tempObject.attr({
                                text: ""
                            });
                            tempObject.node.innerHTML = "";
                        } else {
                            tempObject.attr({
                                text: "" + data.value + ""
                            });
                        }

                        that.graphic_Data_Outside.Back_Number = data.value;
                        that.graphic_Data_Inside.Back_Number = data.value;
                        break;
                    }

                    //Apply Top numbers
                    if (data.teamorplyaer === "FrontNumber" && data.field === "Top" && (object.paths[i].id == "Number-Front" || object.paths[i].id == "Front-Number-2")) {
                        //   var tempObject = that.getItemById('Number-Front');
                        var tempObject;
                        if (object.paths[i].id == "Number-Front") {
                            tempObject = this.snapSvg.select('#Number-Front');
                        } else {
                            tempObject = this.snapSvg.select('#Front-Number-2');
                        }

                        if (tempObject != null) {
                            if (data.value == "none")
                                tempObject.attr({
                                    text: ""
                                });
                            else
                                tempObject.attr({
                                    text: "" + data.value + ""
                                });
                        } else {
                            that.canvas._objects[0].paths[i].top = data.value;
                        }
                        //Toggle
                        that.graphic_Data_Outside.Front_Top = data.value;
                        that.graphic_Data_Inside.Front_Top = data.value;
                        break
                    }

                    // Apply Fontsize to Front Numbers
                    if (data.teamorplyaer === "FrontNumber" && (object.paths[i].id === "Number-Front" || object.paths[i].id === "Front-Number-2")) {
                        if (data.field === "Fontsize") {
                            if (object.paths[i].id === "Number-Front") {
                                var tempObject = this.snapSvg.select('#Number-Front');
                            } else {
                                var tempObject = this.snapSvg.select('#Front-Number-2');
                            }


                            tempObject.attr({
                                fontSize: data.value
                            });
                            //Toggle
                            that.graphic_Data_Outside.Front_FontSize = data.value;
                            that.graphic_Data_Inside.Front_FontSize = data.value;

                            // if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Number-Front" || this.layerColorApplied_OutSide[i].layer === "Front-Number-2") {
                                    this.layerColorApplied_OutSide[i].fontSize = data.value;
                                    break
                                }
                            // } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Number-Front" || this.layerColorApplied_InSide[i].layer === "Front-Number-2") {
                                    this.layerColorApplied_InSide[i].fontSize = data.value;
                                    break
                                }
                            // }
                            break;
                        }
                    }

                    // Apply Fontsize to Back Numbers
                    if (data.teamorplyaer === "BackNumber" && object.paths[i].id === "Number-Back") {
                        if (data.field === "Fontsize") {
                            //   var tempObject = that.getItemById('Number-Back');
                            var tempObject = this.snapSvg.select('#Number-Back');

                            tempObject.attr({
                                fontSize: data.value
                            });
                            //Toggle
                            that.graphic_Data_Outside.Back_FontSize = data.value;
                            that.graphic_Data_Inside.Back_FontSize = data.value;
                            // if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Number-Back") {
                                    this.layerColorApplied_OutSide[i].fontSize = data.value;
                                    break
                                }
                            // } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Number-Back") {
                                    this.layerColorApplied_InSide[i].fontSize = data.value;
                                    break
                                }
                            // }
                            break;
                        }
                    }
                    // Apply color to Front Numbers
                    if (data.teamorplyaer === "Numbers" && data.field === "Color" && (object.paths[i].id == "Number-Front" || object.paths[i].id == "Front-Number-2")) {
                        //   var tempObject = that.getItemById('Number-Front');
                        var tempObject = this.snapSvg.select('#Number-Front');
                        var tempObject1 = this.snapSvg.select('#Front-Number-2');



                        tempObject.attr({
                            fill: data.value.colorCode
                        });
                        if (tempObject1) {
                            tempObject1.attr({
                                fill: data.value.colorCode
                            });
                        }
                        if (tempObject.node || tempObject1.node) {
                            tempObject.node.style.color = data.value.colorCode;
                            if (tempObject1) {
                                tempObject1.node.style.color = data.value.colorCode;
                            }
                        }

                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Number-Front" || this.layerColorApplied_OutSide[i].layer === "Front-Number-2") {
                                    this.layerColorApplied_OutSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].colorName = data.value.colorName;
                                    break
                                }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Number-Front" || this.layerColorApplied_InSide[i].layer === "Front-Number-2") {
                                    this.layerColorApplied_InSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].colorName = data.value.colorName;
                                    break
                                }
                        }
                    }

                    // Apply color to Front and Back Numbers
                    if (data.teamorplyaer === "Numbers" && data.field === "Color" && object.paths[i].id == "Number-Back") {
                        var tempObject = this.snapSvg.select('#Number-Back');

                        tempObject.attr({
                            fill: data.value.colorCode
                        });
                        if (tempObject.node) {
                            tempObject.node.style.color = data.value.colorCode;
                        }
                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Number-Back") {
                                    this.layerColorApplied_OutSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].colorName = data.value.colorName;
                                    break
                                }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Number-Back") {
                                    this.layerColorApplied_InSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].colorName = data.value.colorName;
                                    break
                                }
                        }
                    }

                    // Apply Font Type to Front and Back Numbers
                    if (data.teamorplyaer === "Numbers" && data.field === "Fonttype" && (object.paths[i].id == "Number-Back" || object.paths[i].id === "Number-Front" || object.paths[i].id === "Front-Number-2")) {

                        var tempObject = this.snapSvg.select('#Number-Back');
                        var tempObject1 = this.snapSvg.select('#Number-Front');
                        var tempObject2 = this.snapSvg.select('#Front-Number-2');

                        if (tempObject2) {
                            tempObject2.attr({
                                fontFamily: data.value
                            });
                        }

                        if (tempObject1) {
                            tempObject1.attr({
                                fontFamily: data.value
                            });
                        }

                        if (tempObject) {
                            tempObject.attr({
                                fontFamily: data.value
                            });
                        }

                        //Toggle
                        that.graphic_Data_Outside.Numbers_FontType = data.value;
                        that.graphic_Data_Inside.Numbers_FontType = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Number-Back" || this.layerColorApplied_OutSide[i].layer === "Number-Front" || this.layerColorApplied_OutSide[i].layer === "Front-Number-2") {
                                this.layerColorApplied_OutSide[i].fontType = data.value;
                                // break;
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Number-Back" || this.layerColorApplied_InSide[i].layer === "Number-Front" || this.layerColorApplied_InSide[i].layer === "Front-Number-2") {
                                this.layerColorApplied_InSide[i].fontType = data.value;
                                // break
                            }
                        // }
                    }

                    // Apply Font Type to Front and Back Numbers
                    if (data.teamorplyaer === "Numbers" && data.field === "FontStroke" && (object.paths[i].id === "Number-Front" || object.paths[i].id === "Front-Number-2")) {

                        var tempObject1 = this.snapSvg.select('#Number-Front');
                        var tempObject2 = this.snapSvg.select('#Front-Number-2');



                        tempObject1.attr({
                            stroke: data.value.colorCode
                        });
                        tempObject1.attr({
                            strokeWidth: 2
                        });
                        if (tempObject2) {
                            tempObject2.attr({
                                stroke: data.value.colorCode
                            });
                            tempObject2.attr({
                                strokeWidth: 2
                            });
                            tempObject2.node.style.webkitTextStroke = '1px' + data.value.colorCode;
                        }

                        tempObject1.node.style.webkitTextStroke = '1px' + data.value.colorCode;


                        if (that.selected_slide === 1) {
                            for (let i = 0; i < that.layerColorApplied_OutSide.length; i++)
                                if (that.layerColorApplied_OutSide[i].layer === "Number-Front" || that.layerColorApplied_OutSide[i].layer === "Front-Number-2") {
                                    that.layerColorApplied_OutSide[i].fontStroke = data.value.colorCode;
                                    that.layerColorApplied_OutSide[i].fontStrokeColorName = data.value.colorName;
                                    that.layerColorApplied_OutSide[i].strokeWidth = 2 + "";
                                    break
                                }
                        } else {
                            for (let i = 0; i < that.layerColorApplied_InSide.length; i++)
                                if (that.layerColorApplied_InSide[i].layer === "Number-Front" || that.layerColorApplied_InSide[i].layer === "Front-Number-2") {
                                    that.layerColorApplied_InSide[i].fontStroke = data.value.colorCode;
                                    that.layerColorApplied_InSide[i].fontStrokeColorName = data.value.colorName;
                                    that.layerColorApplied_InSide[i].strokeWidth = 2 + "";
                                    break
                                }
                        }
                        //Toggle
                        //that.graphic_Data_Outside.Numbers_FontStroke=data.value;
                        //that.graphic_Data_Inside.Numbers_FontStroke=data.value;
                    }

                    if (data.teamorplyaer === "Image") {
                        if (data.value == 'add' && data.field == 'frontImage') {
                            that.isFrontImage = true;
                        } else if (data.value == 'remove' && data.field == 'frontImage') {
                            that.isFrontImage = false;
                        } else if (data.value == 'add' && data.field == 'backImage') {
                            that.isBackImage = true;
                        } else if (data.value == 'remove' && data.field == 'backImage') {
                            that.isBackImage = false;
                        } else if (data.value == 'add' && data.field == 'shortLegImage') {
                            that.isShortLegImage = true;
                        } else if (data.value == 'remove' && data.field == 'shortLegImage') {
                            that.isShortLegImage = false;
                        }
                        break;
                    }

                    if (data.teamorplyaer === "Player" && data.field == 'position' && object.paths[i].id == "Name-Back") {
                        if (data.value == 'left') {
                            (<any>object.paths[i]).style.left = (parseInt((<any>object.paths[i]).style.left) - 8);
                            that.graphic_Data_Outside.Player_Left = (<any>object.paths[i]).style.left;
                            that.graphic_Data_Inside.Player_Left = (<any>object.paths[i]).style.left;
                        } else if (data.value == 'right') {
                            (<any>object.paths[i]).style.left = (parseInt((<any>object.paths[i]).style.left) + 8);
                            that.graphic_Data_Outside.Player_Left = (<any>object.paths[i]).style.left;
                            that.graphic_Data_Inside.Player_Left = (<any>object.paths[i]).style.left;
                        }
                        if (data.value == 'top') {
                            (<any>object.paths[i]).style.top = (parseInt((<any>object.paths[i]).style.top) - 8);
                            that.graphic_Data_Outside.Player_Top = (<any>object.paths[i]).style.top;
                            that.graphic_Data_Inside.Player_Top = (<any>object.paths[i]).style.top;
                        } else if (data.value == 'bottom') {
                            (<any>object.paths[i]).style.top = (parseInt((<any>object.paths[i]).style.top) + 8);
                            that.graphic_Data_Outside.Player_Top = (<any>object.paths[i]).style.top;
                            that.graphic_Data_Inside.Player_Top = (<any>object.paths[i]).style.top;
                        }
                        break;
                    }

                    // Apply Font Type to Front and Back Numbers
                    if (data.teamorplyaer === "Numbers" && data.field === "FontStroke" && object.paths[i].id == "Number-Back") {
                        //   var tempObject = that.getItemById('Number-Back');
                        var tempObject = this.snapSvg.select('#Number-Back');

                        tempObject.attr({
                            stroke: data.value.colorCode
                        });
                        tempObject.attr({
                            strokeWidth: 2
                        });

                        tempObject.node.style.webkitTextStroke = '2px' + data.value.colorCode;

                        if (that.selected_slide === 1) {
                            for (let i = 0; i < that.layerColorApplied_OutSide.length; i++)
                                if (that.layerColorApplied_OutSide[i].layer === "Number-Back") {
                                    that.layerColorApplied_OutSide[i].fontStroke = data.value.colorCode;
                                    that.layerColorApplied_OutSide[i].fontStrokeColorName = data.value.colorName;
                                    that.layerColorApplied_OutSide[i].strokeWidth = 2 + "";
                                    break
                                }
                        } else {
                            for (let i = 0; i < that.layerColorApplied_InSide.length; i++)
                                if (that.layerColorApplied_InSide[i].layer === "Number-Back") {
                                    that.layerColorApplied_InSide[i].fontStroke = data.value.colorCode;
                                    that.layerColorApplied_InSide[i].fontStrokeColorName = data.value.colorName;
                                    that.layerColorApplied_InSide[i].strokeWidth = 2 + "";
                                    break
                                }
                        }
                        //Toggle
                        //that.graphic_Data_Outside.Numbers_FontStroke=data.value;
                        //that.graphic_Data_Inside.Numbers_FontStroke=data.value;
                    }
                }
                // END OF fOR lOOP
            }
            try {
                // if (color)
                //     (<any>object.paths[0]).style.fill = (color);
            } catch (error) {
            }
        }



    }

    updateCanvasWithTeamNameBelow(data: ITexttoCanvas) {

        let that = this;
        let color = "";
        if (this.selected_slide === 1) {
            if (this.layerColorApplied_OutSide.length !== 0) {
                // color = this.layerColorApplied_OutSide[0].colorCode;
            }
        } else {
            if (this.layerColorApplied_InSide.length !== 0) {
                // color = this.layerColorApplied_InSide[0].colorCode;
            }
        }

        if (color == "" || color === undefined) {
            if (this.selected_slide === 1) {
                // if (this.actualColorofLayer_OutSide.length > 0)
                //     color = this.actualColorofLayer_OutSide[0].colorCode;
            } else {
                if (this.actualColorofLayer_InSide.length > 0) {
                    // color = this.actualColorofLayer_InSide[0].colorCode;
                }
            }
        }

        var object = {
            paths: document.querySelectorAll('path, .text-element')
        };
        var texts = document.getElementsByTagName("text");
        if (object) {
            if (object.paths) {
                if (color === "" && object.paths[0]) {
                    // color = (<any>object.paths[0]).style.fill;
                }
                for (var i = 0; i < object.paths.length; i++) {

                    //Apply Team Name to SVG
                    if (data.teamorplyaer === "TeamBelow" && data.field === "Name" && object.paths[i].id == "Name-Below-Front") {
                        var tempObject = this.snapSvg.select('#Name-Below-Front');
                        if (tempObject != null) {
                            tempObject.node.innerHTML = data.value;
                        } else {
                            tempObject.attr({
                                text: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Team_Name = data.value;
                        that.graphic_Data_Inside.Team_Name = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Front") {
                                this.layerColorApplied_OutSide[i].text = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Below-Front") {
                                this.layerColorApplied_InSide[i].text = data.value;
                                break
                            }
                        // }
                        break
                    }


                    //Apply Fontsize to Team Name
                    if (data.teamorplyaer === "TeamBelow" && data.field === "Fontsize" && object.paths[i].id == "Name-Below-Front") {
                        var tempObject = this.snapSvg.select('#Name-Below-Front');
                        if (tempObject != null) {
                            tempObject.attr({
                                fontSize: data.value
                            });
                        } else {
                            tempObject.attr({
                                fontSize: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Team_FontSize = data.value;
                        that.graphic_Data_Inside.Team_FontSize = data.value;
                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Front") {
                                this.layerColorApplied_OutSide[i].fontSize = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Below-Front") {
                                this.layerColorApplied_InSide[i].fontSize = data.value;
                                break
                            }
                        // }

                        break
                    }
                    //Apply Font Type to Team Name
                    if (data.teamorplyaer === "TeamBelow" && data.field === "Fonttype" && object.paths[i].id == "Name-Below-Front") {
                        var tempObject = this.snapSvg.select('#Name-Below-Front');
                        if (tempObject != null) {
                            tempObject.attr({
                                fontFamily: data.value
                            });
                        } else {
                            tempObject.attr({
                                fontFamily: data.value
                            });
                        }
                        //Toggle
                        that.graphic_Data_Outside.Team_FontType = data.value;
                        that.graphic_Data_Inside.Team_FontType = data.value;

                        // if (this.selected_slide === 1) {
                        for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                            if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Front") {
                                this.layerColorApplied_OutSide[i].fontType = data.value;
                                break
                            }
                        // } else {
                        for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                            if (this.layerColorApplied_InSide[i].layer === "Name-Below-Front") {
                                this.layerColorApplied_InSide[i].fontType = data.value;
                                break
                            }
                        // }
                        break
                    }
                    //Apply Font Stroke to Team Name
                    if (data.teamorplyaer === "TeamBelow" && data.field === "FontStroke" && object.paths[i].id == "Name-Below-Front") {
                        var tempObject = this.snapSvg.select('#Name-Below-Front');
                        var thickness = '.7';
                        if (data.value.colorCode == "") {
                            thickness = '0';
                        }
                        tempObject.attr({
                            stroke: data.value.colorCode
                        });
                        tempObject.attr({
                            strokeWidth: thickness
                        });
                        tempObject.node.style.webkitTextStroke = thickness + 'px' + data.value.colorCode;

                        //Toggle
                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++) {
                                if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Front") {
                                    this.layerColorApplied_OutSide[i].fontStroke = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].fontStrokeColorName = data.value.colorName;
                                    break
                                }
                            }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Name-Below-Front") {
                                    this.layerColorApplied_InSide[i].fontStroke = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].fontStrokeColorName = data.value.colorName;
                                    break
                                }
                            break;
                        }
                    }
                    //Apply Font Stroke to Player Name
                    // if (data.teamorplyaer === "PlayerBelow" && data.field === "FontStroke" && object.paths[i].id == "Name-Below-Back") {
                    //     console.log('data.teamorplyaer///', data.teamorplyaer);
                    //     var tempObject = this.snapSvg.select('#Name-Below-Back');
                    //     var thickness = '.7';
                    //     if (data.value.colorCode == "") {
                    //         thickness = '0';
                    //     }
                    //     tempObject.attr({
                    //         stroke: data.value.colorCode
                    //     });
                    //     tempObject.attr({
                    //         strokeWidth: thickness
                    //     });
                    //     tempObject.node.style.webkitTextStroke = thickness + 'px' + data.value.colorCode;
                    //     //Toggle
                    //     //that.graphic_Data_Outside.Player_FontStroke=data.value;
                    //     //that.graphic_Data_Inside.Player_FontStroke=data.value;

                    //     if (this.selected_slide === 1) {
                    //         for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    //             if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Back") {
                    //                 this.layerColorApplied_OutSide[i].fontStroke = data.value.colorCode;
                    //                 this.layerColorApplied_OutSide[i].fontStrokeColorName = data.value.colorName;
                    //                 break
                    //             }
                    //         // break
                    //     } else {
                    //         for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    //             if (this.layerColorApplied_InSide[i].layer === "Name-Below-Back") {
                    //                 this.layerColorApplied_InSide[i].fontStroke = data.value.colorCode;
                    //                 this.layerColorApplied_InSide[i].fontStrokeColorName = data.value.colorName;

                    //                 break
                    //             }
                    //         break
                    //     }
                    // }

                    //Apply color to Team Name
                    if (data.teamorplyaer === "TeamBelow" && data.field === "Color" && object.paths[i].id == "Name-Below-Front") {
                        var tempObject = this.snapSvg.select('#Name-Below-Front');

                        tempObject.attr({
                            fill: data.value.colorCode
                        });
                        if (tempObject.node) {
                            tempObject.node.style.color = data.value.colorCode;
                        }

                        if (this.selected_slide === 1) {
                            for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                                if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Front") {
                                    this.layerColorApplied_OutSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_OutSide[i].colorName = data.value.colorName;
                                    break
                                }
                        } else {
                            for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                                if (this.layerColorApplied_InSide[i].layer === "Name-Below-Front") {
                                    this.layerColorApplied_InSide[i].colorCode = data.value.colorCode;
                                    this.layerColorApplied_InSide[i].colorName = data.value.colorName;
                                    break
                                }
                        }
                        break;
                    }

                    //Apply Player Name to Canvas
                    // if (data.teamorplyaer === "PlayerBelow" && data.field === "Name" && object.paths[i].id == "Name-Below-Back") {
                    //     console.log('data.teamorplyaer.........', data.teamorplyaer);
                    //     var tempObject = this.snapSvg.select('#Name-Below-Back');
                    //     // console.log('tempObject->',this.layerColorApplied_OutSide);
                    //     if (tempObject != null) {
                    //         tempObject.attr({
                    //             text: data.value
                    //         });
                    //         tempObject.node.innerHTML = data.value;
                    //     } else {
                    //         tempObject.attr({
                    //             text: data.value
                    //         });
                    //     }
                    //     //Toggle
                    //     that.graphic_Data_Outside.Player_Name = data.value;
                    //     that.graphic_Data_Inside.Player_Name = data.value;
                    //     // if (this.selected_slide === 1) {
                    //     for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    //         if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Back") {
                    //             this.layerColorApplied_OutSide[i].text = data.value;
                    //             break
                    //         }
                    //     // } else {
                    //     for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    //         if (this.layerColorApplied_InSide[i].layer === "Name-Below-Back") {
                    //             this.layerColorApplied_InSide[i].text = data.value;
                    //             break
                    //         }
                    //     // }
                    //     break
                    // }
                    //Apply Fontsize to Player Name
                    // if (data.teamorplyaer === "PlayerBelow" && data.field === "Fontsize" && object.paths[i].id == "Name-Below-Back") {
                    //     var tempObject = this.snapSvg.select('#Name-Below-Back');
                    //     tempObject.attr({
                    //         fontSize: data.value
                    //     });
                    //     //Toggle
                    //     that.graphic_Data_Outside.Player_FontSize = data.value;
                    //     that.graphic_Data_Inside.Player_FontSize = data.value;

                    //     // if (this.selected_slide === 1) {
                    //     for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    //         if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Back") {
                    //             this.layerColorApplied_OutSide[i].fontSize = data.value;
                    //             break
                    //         }
                    //     // } else {
                    //     for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    //         if (this.layerColorApplied_InSide[i].layer === "Name-Below-Back") {
                    //             this.layerColorApplied_InSide[i].fontSize = data.value;
                    //             break
                    //         }
                    //     // }

                    //     break
                    // }

                    //Apply Font Type to Player Name
                    // if (data.teamorplyaer === "PlayerBelow" && data.field === "Fonttype" && object.paths[i].id == "Name-Below-Back") {
                    //     var tempObject = this.snapSvg.select('#Name-Below-Back');
                    //     tempObject.attr({
                    //         fontFamily: data.value
                    //     });
                    //     //Toggle
                    //     that.graphic_Data_Outside.Player_FontType = data.value;
                    //     that.graphic_Data_Inside.Player_FontType = data.value;
                    //     // if (this.selected_slide === 1) {
                    //     for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    //         if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Back") {
                    //             this.layerColorApplied_OutSide[i].fontType = data.value;
                    //             break
                    //         }
                    //     // } else {
                    //     for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    //         if (this.layerColorApplied_InSide[i].layer === "Name-Below-Back") {
                    //             this.layerColorApplied_InSide[i].fontType = data.value;
                    //             break
                    //         }
                    //     // }
                    //     break
                    // }

                    //Apply color to Player Name
                    // if (data.teamorplyaer === "PlayerBelow" && data.field === "Color" && object.paths[i].id == "Name-Below-Back") {
                    //     var tempObject = this.snapSvg.select('#Name-Below-Back');
                    //     tempObject.attr({
                    //         fill: data.value.colorCode
                    //     });
                    //     if (tempObject.node) {
                    //         tempObject.node.style.color = data.value.colorCode;
                    //     }
                    //     if (this.selected_slide === 1) {
                    //         for (let i = 0; i < this.layerColorApplied_OutSide.length; i++)
                    //             if (this.layerColorApplied_OutSide[i].layer === "Name-Below-Back") {
                    //                 this.layerColorApplied_OutSide[i].colorCode = data.value.colorCode;
                    //                 this.layerColorApplied_OutSide[i].colorName = data.value.colorName;
                    //                 break
                    //             }
                    //     } else {
                    //         for (let i = 0; i < this.layerColorApplied_InSide.length; i++)
                    //             if (this.layerColorApplied_InSide[i].layer === "Name-Below-Back") {
                    //                 this.layerColorApplied_InSide[i].colorCode = data.value.colorCode;
                    //                 this.layerColorApplied_InSide[i].colorName = data.value.colorName;
                    //                 break
                    //             }
                    //     }
                    // }

                }
                // END OF fOR lOOP
            }
            try {
                // if (color)
                //     (<any>object.paths[0]).style.fill = (color);
            } catch (error) {
            }
        }



    }


    clearDefaultFonts() {
        this.graphic_Data_Outside.Back_FontSize = 0;
        this.graphic_Data_Outside.Front_FontSize = 0;
        this.graphic_Data_Outside.Numbers_FontType = "";
        this.graphic_Data_Outside.Player_FontSize = 0;
        this.graphic_Data_Outside.Player_FontType = "";
        this.graphic_Data_Outside.Player_Name = "";
        this.graphic_Data_Outside.Team_FontSize = 0;
        this.graphic_Data_Outside.Team_FontType = ""
        this.graphic_Data_Outside.Team_Name = "";
        this.graphic_Data_Outside.Front_Number = "";
        this.graphic_Data_Outside.Back_Number = "";
        //this.graphic_Data_Outside.Team_FontStroke="";
        //this.graphic_Data_Outside.Numbers_FontStroke="";
        //this.graphic_Data_Outside.Player_FontStroke="";

        this.graphic_Data_Inside.Back_FontSize = 0;
        this.graphic_Data_Inside.Front_FontSize = 0;
        this.graphic_Data_Inside.Numbers_FontType = "";
        this.graphic_Data_Inside.Player_FontSize = 0;
        this.graphic_Data_Inside.Player_FontType = "";
        this.graphic_Data_Inside.Player_Name = "";
        this.graphic_Data_Inside.Team_FontSize = 0;
        this.graphic_Data_Inside.Team_FontType = "";
        this.graphic_Data_Inside.Team_Name = "";
        this.graphic_Data_Inside.Front_Number = "";
        this.graphic_Data_Inside.Back_Number = "";
        //this.graphic_Data_Inside.Team_FontStroke="";
        //this.graphic_Data_Inside.Numbers_FontStroke="";
        //this.graphic_Data_Inside.Player_FontStroke="";

        // this.layerColorApplied_OutSide = [];
        // this.layerColorApplied_InSide = [];
        // this.svgIdColors = [];
    }

    dragTextElements(flag) {

        var that = this;
        this.applied_OutSideOptions = [];
        // var txts = document.getElementsByTagName("text");
        var txts = (<any>document.querySelectorAll(".text-element"));
        if (this.reEditFlag) {
            for (var i in txts) {
                if (txts[i].style) {
                    if (that.submittedDesign) {
                        var arr1 = [], arr2 = [];
                        if (that.submittedDesign.data.LayerColors_OutSide) {
                            arr1 = that.submittedDesign.data.LayerColors_OutSide.filter(function (d) {
                                return d.layer == txts[i].id;
                            });
                        } else if (that.submittedDesign.data.LayerColors_InSide) {
                            arr1 = that.submittedDesign.data.LayerColors_InSide.filter(function (d) {
                                return d.layer == txts[i].id;
                            });
                        }
                        // var arr1 = that.submittedDesign.LayerColors_OutSide.filter(function(d){
                        //     return d.layer == txts[i].id;
                        // });
                        if (arr1[0]) {
                            that.setDefaultElements(arr1[0]);
                        } else {
                            var cssText = "";
                            try {
                                cssText = this.snapSvg.select("#" + txts[i].id + "").node.style.cssText;
                            } catch (error) {
                            }
                            // this.snapSvg.select("#" + txts[i].id + "").attr({
                            //     style: cssText + 'font-family: \'CollegeBlock2-0\', sans-serif;'
                            // });
                        }
                    }
                }
            }
        } else {
            for (var i in txts) {
                if (txts[i].style && txts[i].style.fontFamily == "" && !this.reEditFlag) {
                    var cssText = "";
                    try {
                        cssText = this.snapSvg.select("#" + txts[i].id + "").node.style.cssText;
                    } catch (error) {
                    }
                    // this.snapSvg.select("#" + txts[i].id + "").attr({
                    //     style: cssText + 'font-family: \'CollegeBlock2-0\', sans-serif;'
                    // });
                }
            }
        }

    }

    setDefaultElements(obj) {
        // var defaultFont = 'CollegeBlock2-0';
        var defaultColorObj = { "colorCode": "#2b2d2f", "colorName": "Charcoal Gray" };
        var fontType = 'CollegeBlock2-0';
        var colorCode = '#2b2d2f';
        var colorName = 'Charcoal Gray';
        var fontStrokeColorName = "";
        var fontStroke = "";
        var fontSize = "";
        if (obj.fontType && obj.fontType != "") {
            fontType = obj.fontType;
        }
        if (obj.colorCode != "") {
            colorCode = obj.colorCode;
        }
        if (obj.colorCode != "") {
            colorName = obj.colorName;
        }
        if (obj.fontStroke != "") {
            fontStroke = '-webkit-text-stroke: 1px' + obj.fontStroke + ';';
        }
        if (obj.fontSize && obj.fontSize != "") {
            fontSize = obj.fontSize;
        }
        this.applied_OutSideOptions.push(obj);
        var cssText = "";
        try {
            var rect = this.snapSvg.select("#" + obj.layer + "-p").node;
            var w = rect.getAttribute("width");
            var h = rect.getAttribute("height");
            if (h <= 20) {
                h = 20;
            }
            let verticalAlignment = `vertical-align: middle;`;
            if (rect.id == 'Name-Back' || rect.id == 'Name-Front') {
                verticalAlignment = `vertical-align: top;`;
            }
            if (obj.layer == 'Number-Front' || obj.layer == 'Number-Back' || obj.layer == 'Front-Number-2') {
                // cssText = 'display: table-cell;'+verticalAlignment+'width:' + w + 'px; height:' + h + 'px;';
                cssText = '' + verticalAlignment + ' text-align:center; width:' + w + 'px; height:' + h + 'px;';

            }
            // this.snapSvg.select("#" + obj.layer + "").attr({
            //     style: cssText + 'font-family: ' + fontType + ';color: ' + colorCode + ';' + ';font-size: ' + fontSize + 'px;' + fontStroke
            // });
            if (obj.text) {
                var tempObject = this.snapSvg.select("#" + obj.layer + "");
                tempObject.node.innerHTML = obj.text;
            }
        } catch (error) {
        }


    };


    startLoadingSpinner() {

        this.loading = true;
        setTimeout(function () {
            // this.loading = false;
        }.bind(this), 1500);
    }



    //function to get all variant size
    getVariantSize() {
        let jerseyId = 3716154359892;
        let shortsId = 3716179722324;
        if (this.selectedJersycut.name == "verge") {
            jerseyId = 3716426629204;
            shortsId = 3716472209492;
        } else if (this.selectedJersycut.name == "intrepid") {
            jerseyId = 3715768778836;
            shortsId = 3702683828308;
        } else if (this.selectedJersycut.name == "phase") {
            jerseyId = 3716583817300;
            shortsId = 3716641325140;
        } else if (this.selectedJersycut.name == "synthesis") {
            jerseyId = 3716246044756;
            shortsId = 3716269047892;
        }


        var data = {
            "id": jerseyId
        };
        this.http.post("https://uniform-e640f.appspot.com/variants.php",
            JSON.stringify(data), {})
            .subscribe(
                res => {
                    // console.log(res);
                    try {
                        this.orderDataJersey = JSON.parse((<any>res)._body).variants;
                    } catch (error) { }
                }
            );

        //for shorts
        var data = {
            "id": shortsId
        };
        // this.players = <IPlayer[]>[];

        this.http.post("https://uniform-e640f.appspot.com/variants.php",
            JSON.stringify(data), {})
            .subscribe(
                res => {
                    try {
                        this.orderDataShorts = JSON.parse((<any>res)._body).variants;
                        if (this.reEditFlag && this.submittedDesign && this.submittedDesign.data.Players) {
                            this.players.pop();
                            this.submittedDesign.data.Players.forEach(d => {
                                if (this.players && this.players.length == 0) {
                                    this.players = [new PlayerObj(d.name, d.topSize, d.bottomSize, d.number)];
                                } else {
                                    this.players.push(new PlayerObj(d.name, d.topSize, d.bottomSize, d.number));
                                }
                            });
                        }

                    } catch (error) { }
                }
            );
    }


    getVariantSizeForLater(submitJersey, savelaterFlag) {
        let jerseyId = 3716154359892;
        let shortsId = 3716179722324;
        if (this.selectedJersycut.name == "verge") {
            jerseyId = 3716426629204;
            shortsId = 3716472209492;
        } else if (this.selectedJersycut.name == "intrepid") {
            jerseyId = 3715768778836;
            shortsId = 3702683828308;
        } else if (this.selectedJersycut.name == "phase") {
            jerseyId = 3716583817300;
            shortsId = 3716641325140;
        } else if (this.selectedJersycut.name == "synthesis") {
            jerseyId = 3716246044756;
            shortsId = 3716269047892;
        }


        var data = {
            "id": jerseyId
        };
        this.http.post("https://uniform-e640f.appspot.com/variants.php",
            JSON.stringify(data), {})
            .subscribe(
                res => {
                    // console.log(res);
                    try {
                        this.orderDataJersey = JSON.parse((<any>res)._body).variants;
                    } catch (error) { }
                }
            );

        //for shorts
        var data = {
            "id": shortsId
        };
        // this.players = <IPlayer[]>[];

        this.http.post("https://uniform-e640f.appspot.com/variants.php",
            JSON.stringify(data), {})
            .subscribe(
                res => {
                    try {
                        this.orderDataShorts = JSON.parse((<any>res)._body).variants;
                        if (this.reEditFlag && this.submittedDesign && this.submittedDesign.data.Players) {
                            this.players.pop();
                            this.submittedDesign.data.Players.forEach(d => {
                                if (this.players && this.players.length == 0) {
                                    this.players = [new PlayerObj(d.name, d.topSize, d.bottomSize, d.number)];
                                } else {
                                    this.players.push(new PlayerObj(d.name, d.topSize, d.bottomSize, d.number));
                                }
                            });
                            this.submitJersey(submitJersey, savelaterFlag,'');
                        }

                    } catch (error) { }
                }
            );
    }


    public orderDataJersey1 = ["XS", "S", "M", "L", "XL", "XXL"];
    public orderDataShorts1 = ["XS", "S", "M", "L", "XL", "XXL"];
    public orderDataJersey = [];
    public orderDataShorts = [];


    localStorage() {
        localStorage.setItem('markcurve1', 'markcurve1');
        localStorage.setItem('markcurve2', 'markcurve2');
        if (localStorage.getItem('typed'))
            localStorage.removeItem('typed');
        if (localStorage.getItem('typed2'))
            localStorage.removeItem('typed2');
        if (localStorage.getItem('design'))
            localStorage.removeItem('design')
        if (localStorage.getItem('circleType'))
            localStorage.removeItem('circleType');
        if (localStorage.getItem('teamname'))
            localStorage.removeItem('teamname');
        if (localStorage.getItem('playername'))
            localStorage.removeItem('playername');
        if (localStorage.getItem('circleType1'))
            localStorage.removeItem('circleType1');
        if (localStorage.getItem('curve'))
            localStorage.removeItem('curve');
        if (localStorage.getItem('slidervalue1'))
            localStorage.removeItem('slidervalue1')
        if (localStorage.getItem('slidervalue2'))
            localStorage.removeItem('slidervalue2')

    }



    getClipArt() {
        this.clipartList = [];
        // this.startLoadingSpinner();
        this.dbService.list('/clip-arts').snapshotChanges()
            .subscribe(data => {
                this.clipartList = [];
                data.forEach(action => {
                    const value = action.payload.val();
                    const $key = action.key;
                    this.clipartList.push({ $key, ...value });
                });
                this.clipartList.sort((a, b) => a.order - b.order);
                // this.loading = false;
            });


    }

    openClipArtModal(data) {
        this.toBeDeleted = document.getElementById("svgContainer").childNodes[1]
        $(this.toBeDeleted).remove();
            // document.getElementById("svg").style.display = "none";
       
        let me = this;
        let findIndex = this.clipartList.findIndex(x => x.categoryName == "Mascots")
        console.log('clip empty');
        this.selectedImgIndex = 0;
        let snapclip = Snap("#clipArtSvg");
        snapclip.clear();
        function onSVGLoadedClipArt(data) {
            snapclip.append(data);
            me.cirlceLength = document.querySelectorAll('circle');
            if (me.cirlceLength.length == 0)
                me.cirlceLength = document.querySelectorAll('*[id^="Color-"]');
        }
        Snap.load(this.clipartList[findIndex].imagePath,
            onSVGLoadedClipArt);
        this.colorsList1 = data.colorListforLayer;
        this.frontLogo = data.frontLogo;
        document.getElementById('openClipArtModal').click();
        // this.selectedCategory = undefined;
        this.selectedCategory = "Mascots";
        this.selectedImgIndex = findIndex;

        this.openClipArt = true;
    }


    updatedClipArtPostion(event) {
    }


    clipArtColoreSelected(number, color) {
        // this.colorSelectDropDown.closeDropdown();
        // document.getElementById('heading'+number).innerHTML=color.colorName;
        let element = this.cirlceLength[number];
        element.style.fill = color;

    }

    previewImageSelected(item, index) {
        //     document.getElementById("svg").style.display = "none";
        console.log("item is ",item);
        console.log("index is ",index);
        this.selectedImgIndex = index;
        // this.previewImage = item.imagePath;
        let me = this;
        let snapclip = Snap("#clipArtSvg");
        snapclip.clear();
        function onSVGLoadedClipArt(data) {
            snapclip.append(data);
            me.cirlceLength = document.querySelectorAll('circle');
            if (me.cirlceLength.length == 0)
                me.cirlceLength = document.querySelectorAll('*[id^="Color-"]');

        }
        Snap.load(item.imagePath,
            onSVGLoadedClipArt);
        // this.cirlceLength =document.querySelectorAll('circle');

    }


    async setImage() {
        let svg = Snap("#clipArtSvg");
        this.clipArtImage = svg.toDataURL();
        svgpng("clipArtSvg", { width: 300, height: 300 }).
            then((file) => {
                this.blobToFile(file);
            }).catch((error) => {
                console.log('error', error);
            })
        document.getElementById('closeDialog').click();
        let snapclip = Snap("#clipArtSvg");
        snapclip.clear();
        document.getElementById("svgContainer").appendChild(this.toBeDeleted);
        // document.getElementById("svg").style.display = "";

    }

    closeDialog() {
        let snapclip = Snap("#clipArtSvg");
        snapclip.clear();
        document.getElementById("svgContainer").appendChild(this.toBeDeleted);
        // document.getElementById("svg").style.display = "";
        this.openClipArt = false;
    }


    blobToFile(url) {
        fetch(url)
            .then(res => res.blob())
            .then(blob => {
                let file = new File([blob], 'File name', { type: blob.type });
                let files = [];
                let target = {}
                files[0] = file;
                target = { files: files };
                let event = { target: target };
                this.openClipArt = false;
                this.graphicOption.uploadImage(event, 'clipArt', this.frontLogo);
            });
    }
    removeLocalStorage() {
        for (let x in localStorage) {
            if (x.includes('patSvg')) {
                localStorage.removeItem(x);
            }
        }
    }

    changeCategory1(ev) {
        let status = ev.value;
        this.selectedCategory = ev.target.value;
    }

    changeCategory(name) {
        this.selectedCategory = name;
    }

    async fetchSubmissionToINCID() {
        this.lastSubmissions = [];
        await this.submissionService.getAllSubmissions().subscribe(res => {
            this.lastSubmissions = [];
            this.lastSubmissions = res.json();
            this.lastSubmissions = this.lastSubmissions.sort((a, b) => a.dateToShow - b.dateToShow);
            this.lastSubmissions1 = this.lastSubmissions[this.lastSubmissions.length - 1]._id;
        });



        // this.dbService.list('/submissions', ref => ref.limitToLast(1).orderByChild("dateToShow")).snapshotChanges().subscribe(res => {

        //     res.forEach(action => {
        //         const key = action.key;
        //         this.lastSubmissions.push(key);
        //     });
        // })
    }

    async fetchRevisionToINCID() {
        this.dbService.list(`/revision/${this.designId}`, ref => ref.limitToLast(1).orderByChild("resubmitDate")).snapshotChanges().subscribe(res => {
            this.lastRevisions = [];
            res.forEach(action => {
                const key = action.key;
                this.lastRevisions.push(key);
            });
        });
    }

    signInForUpload(redirected) {
        this.dialog.open(SignInModalComponent, {
            data: {
                redirected: redirected
            }
        })
    }
    login(email, password) {
        var loginObject = {
            email: email,
            password: password
        }
        let me = this;
        this.loading = true;
        this.submissionService.login(loginObject).subscribe(res => {
            let user = JSON.parse((<any>res)._body);
            window.localStorage.setItem('name', user.user.name);
            window.localStorage.setItem('emailForSignIn', user.user.email);
            window.localStorage.setItem('token', user.token);
            if (user.user.role) {
                if (user.user.role == 'customer') {
                    window.localStorage.setItem('userrole', 'User');
                    me.router.navigate(['/locker-room/submissions']);
                } else if (user.user.role == 'admin') {
                    window.localStorage.setItem('userrole', 'Admin');
                    me.router.navigate(['/admin/submissions']); 
                }
            }
            this.loading = false;
        }, error => {
            let err = JSON.parse((<any>error)._body);
            this.loading = false;
        });
    }

    createNewAccount(email, password, fullName, organization, phoneNumber) {
        this.loading = true;
        var obj = {
            email: email,
            password: password,
            fullName: fullName,
            organization: organization ? organization : '',
            phoneNumber: phoneNumber ? phoneNumber : ''

        }
        let me = this;
        this.submissionService.registerUser(obj).subscribe(res => {
            let user = JSON.parse((<any>res)._body);
            console.log(user.user.email);
            window.localStorage.setItem('emailForSignIn', user.user.emailAddress);
            window.localStorage.setItem('token', user.token);
            
            if (user.user.role) {
                if (user.user.role == 'customer') {
                    window.localStorage.setItem('userrole', 'User');
                    me.router.navigate(['/locker-room/submissions']);
                } else if (user.user.role == 'admin') {
                    window.localStorage.setItem('userrole', 'Admin');
                    me.router.navigate(['/admin/submissions']);
                }
            }
            this.loading = false;

        }, error => {
            let err = JSON.parse((<any>error)._body);
            this.loading = false;
        });
    }


    onFileDropped($event) {
        // this.prepareFilesList($event);

        console.log("files issssss",$event.target.files);
        if ($event.target.files.length != 0) {
            for(var i=0;i<$event.target.files.length;i++){
            let file = $event.target.files[i];
            this.handleReaderLoadedforAttachment(file)
            }
        }
        
      }
      deleteCustomerAttachment(index){
        this.attachmentURL.splice(index, 1);
    }
    
      /**
       * handle file from browsing
       */
      fileBrowseHandler(files) {
        console.log("files issssss browssssss",files);
        // this.prepareFilesList(files);
        if (files.length != 0) {
            for(var i=0;i<files.length;i++){
            let file = files[i];
            this.handleReaderLoadedforAttachment(file)
            }
        }

      }

      onFileChange1(event){
        console.log("event.target.files",event.target.files);
          if (event.target.files.length != 0) {
            for(var i=0;i<event.target.files.length;i++){
            let file = event.target.files[i];
            this.handleReaderLoadedforAttachment(file)
            }
        }
      }
      attachmentURL = [];
      // uploadedImage1 = null;
      async handleReaderLoadedforAttachment(file) {
        this.toastr.warning("Plase wait while uploading image.", '', { onActivateTick: true, timeOut: 10000, positionClass: 'toast-top-right' });
        let uniqlogo1 = 'ReQuestImageforAttachment' + (new Date().getTime());
            let storageRef = firebase.storage().ref();
        const fileData = await storageRef.child(`${'/customer-attachment'}/${uniqlogo1}`).put(file)
          .then(snapshot => {
            return snapshot.ref.getDownloadURL();
          }).then(async (downloadURL) => {
            this.attachmentURL.push(downloadURL);
            // this.uploadedImage1 = downloadURL;
            this.toastr.success('Image. sucessfully uploaded', '', { positionClass: 'toast-top-right' });
          }).catch(error => {
            this.toastr.error("Faild to upload image. Plase try again", '', { positionClass: 'toast-top-right', onActivateTick: true, timeOut: 10000 });
          });
        }

        reload(){
            this.availableLogoLocations = [];
            this.logo = '';   
             }
    
    gotoBuilder(){
        console.log("***********************************");
        
        this.router.navigate(['/']);
        document.getElementById('backtobuilder').click();
    }
}
